/* js/head-init.js */
// Storage keys are spelled out here, not read from GHD.KEYS
// (dashboard/js/storage-keys.js): this file runs first in <head>, before any
// namespace exists. GHD.KEYS is still the registry of record —
// every key below is listed there, so keep the two in step.
//
// Share this page's locale with the dashboard SPA so signing in from a localized page
// keeps the language. The SPA reads localStorage 'ghd_ui_lang' on load, and
// localStorage is per-origin — the app has its own — so the value reaches it only
// through the /go/ hop.
// A link straight to the app carries the locale in its URL instead: build time stamps
// ?lang= on every one a localized page holds (tools/lib/i18n_common.stamp_app_locale)
// and dashboard/i18n/arrival-locale.js adopts it there under exactly the rules below.
//
// Only a *landing-derived* value may be overwritten. A locale someone deliberately
// chose (the settings picker, the share pages' header picker, or reconciling the
// account's saved preference — see dashboard/js/i18n.js and js/public-i18n.js)
// outranks whichever page the user happens to open, so a Dutch
// account bouncing off the English homepage no longer boots the dashboard in English
// and then has to switch back. 'ghd_ui_lang_seed' records who wrote the language last:
// this file writes the locale it seeded, a deliberate pick writes the sentinel "app".
// Still equal
// to our own seed means nobody has expressed a stronger preference since, so the
// language picker (plain links to /nl/, /de/, …) can still move the SPA's language. A
// missing seed means the value predates this key and is treated as landing-derived —
// the old behaviour, self-correcting after one visit.
try {
  // The code, not the tag: a page can be `lang="zh-Hant"` for locale `zh`.
  var l = (document.documentElement.lang || "").split("-")[0];
  if (
    ["en", "nl", "de", "es", "fr", "pt", "it", "hu", "ru", "pl", "id", "tr", "ca", "uk", "el", "cs", "sv", "nb", "ro", "fi", "th", "vi", "bg", "da", "ja", "ko", "zh"].indexOf(l) !== -1
  ) {
    var storedLang = localStorage.getItem("ghd_ui_lang");
    var seededLang = localStorage.getItem("ghd_ui_lang_seed");
    if (!storedLang || seededLang === null || storedLang === seededLang) {
      localStorage.setItem("ghd_ui_lang", l);
      localStorage.setItem("ghd_ui_lang_seed", l);
    }
  }
} catch (e) {}
// Capture the Google Ads click id (auto-tagging appends ?gclid= to paid landings).
// The dashboard SPA (same origin) sends it to the backend at signup for offline
// conversion uploads. 90 days matches Google's click attribution window.
try {
  var g = new URLSearchParams(location.search).get("gclid");
  if (g) localStorage.setItem("ghd_gclid", JSON.stringify({ v: g, t: Date.now() }));
} catch (e) {}

;
/* js/arrival-touch.js */
// Where this device came from, sent once at signup (dashboard/js/api.js) and
// cleaned by backend/signup/arrival.py. Two records, each
// {v: path, r: referring host, u: utm_source, o: "www" | "app", t}:
//
//   ghd_entry       the first page opened, kept 90 days and never replaced inside them;
//   ghd_last_touch  the latest load that came from another site or carries
//                   ?utm_source=, replaced by each newer one.
//
// From the URL only the path and utm_source: any other parameter can carry an ad id.
// AI apps often send no Referer but ChatGPT appends ?utm_source=chatgpt.com, so
// either one identifies the source.
//
// Runs on both origins. On the app (<html data-origin="app">, which survives the
// build folding this file into app-bundle.js where a tag attribute would not) it covers a
// visitor who opens the app without passing www; www's own records arrive later
// through site/go/, and app.js keeps the earlier entry and the later last touch.
// Keys are spelled out, as in head-init.js; GHD.KEYS is the registry of record.
(function () {
  // Hosts that are a step in our own flows, never a source: our origins and the
  // TWA, and the sign-in and payment pages that send people back to us.
  var NOT_A_SOURCE =
    /(^|\.)(gethumandesign\.com|supabase\.co|stripe\.com|paypal\.com|localhost)$|^(accounts\.google\.com|appleid\.apple\.com|127\.0\.0\.1|com\.gethumandesign\.app)$/;
  var origin;
  var touch;
  var external;
  try {
    origin = document.documentElement.getAttribute("data-origin") === "app" ? "app" : "www";
    var ref = "";
    try {
      ref = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : "";
    } catch (e) {}
    var ours = !!ref && NOT_A_SOURCE.test(ref);
    // On the app, a hop from www, a sign-in return or an email link is a step
    // in a journey that started elsewhere, not an arrival.
    if (
      origin === "app" &&
      (ours ||
        location.hash.indexOf("#ghd_handoff=") === 0 ||
        /(^|[?&])(code|token_hash|error)=/.test(location.search.slice(1)) ||
        /access_token=/.test(location.hash))
    )
      return;
    var utm = String(new URLSearchParams(location.search).get("utm_source") || "")
      .trim()
      .toLowerCase();
    if (!/^[a-z0-9][a-z0-9._-]{0,63}$/.test(utm)) utm = "";
    external = (!!ref && !ours) || !!utm;
    touch = JSON.stringify({ v: location.pathname, r: ref, u: utm, o: origin, t: Date.now() });
  } catch (e) {
    return;
  }
  try {
    var entry = null;
    try {
      entry = JSON.parse(localStorage.getItem("ghd_entry") || "null");
    } catch (e) {}
    if (!entry || !(Date.now() - entry.t < 90 * 24 * 3600 * 1000)) localStorage.setItem("ghd_entry", touch);
  } catch (e) {}
  try {
    if (external) localStorage.setItem("ghd_last_touch", touch);
  } catch (e) {}
})();

;
/* app-config.js */
/* The environment every page runs in — loaded by the landing site, the app SPA,
 * the share pages, the knowledge base, the consent screen and the /go/ handoff.
 *
 * One copy of the things that used to be spelled out per file: the two origins,
 * the API base, the Supabase project, and the one reader of the stored session.
 * They were duplicated across a dozen files, so a change of project or host had
 * to be found by grep and was silently half-done when a copy was missed.
 *
 * Dependency-free and safe to run first: it touches nothing but `location` at
 * load, because several pages load it in the head before anything else.
 *
 * It also carries the store-app facts. The app is on Google Play and in the App
 * Store, so on Android and on iPhone and iPad the store app replaces the PWA
 * everywhere we used to promote installing: the landing page shows that
 * store's badge instead of the install button, and the dashboard sends
 * "Download app" taps to the store. Only desktop still gets the PWA. */
(function () {
  // Both hostnames reach the local dev stack — docker publishes nginx on the two
  // ports for either name, and developers type both. One definition, so a page
  // opened on 127.0.0.1 does not get local API calls and production links.
  var isLocal = ["localhost", "127.0.0.1"].indexOf(location.hostname) !== -1;

  // Local dev on a local Supabase (`make serve SUPABASE=local`, which starts
  // one with tools/dev/local_supabase.py). The backend is switched by its
  // environment; the browser is switched here, once per browser, by visiting
  // any local page with ?supabase=local — sticky until ?supabase=prod — the
  // way ?dev_login=off works. A flag rather than a build step because this file
  // is served straight from the source tree and has to decide before anything
  // else runs; localStorage directly rather than GHD.storage because nothing
  // else is loaded yet. Never true off localhost.
  var localSupabase = false;
  if (isLocal) {
    try {
      var wanted = new URLSearchParams(location.search).get("supabase");
      if (wanted === "local") localStorage.setItem("ghd_supabase", "local");
      if (wanted === "prod") localStorage.removeItem("ghd_supabase");
      localSupabase = localStorage.getItem("ghd_supabase") === "local";
    } catch (e) {
      /* storage blocked: production project, as before */
    }
  }

  window.GHD_APP = {
    isLocal: isLocal,
    // Which Supabase the browser talks to. Shown by the dev bar so a session
    // on the wrong project is visible at a glance.
    localSupabase: localSupabase,

    // --- Origins -------------------------------------------------------------
    // The marketing site and the app SPA are separate origins: the site is served
    // from www.gethumandesign.com, the app from app.gethumandesign.com. Anything
    // that links from one to the other must use an absolute URL built from these
    // — a bare "/privacy" inside the app resolves to the *app* origin and 404s.
    //
    // They are separate hosts (not just paths) because the Android TWA claims one
    // host wholesale: while the app's scope covered the marketing site, Android
    // opened gethumandesign.com inside the app, where Play's payments policy
    // forces the pricing UI to stay hidden — so signed-in users could not reach a
    // price at all. A distinct app host is what makes "the website" and "the app"
    // separable to Android, to Play, and to link handling in general.
    //
    // Local dev mirrors the same two-origin shape on two ports (docker-compose.yml
    // + frontend_web/nginx.conf), so cross-origin bugs surface locally rather than
    // in production.
    SITE_ORIGIN: isLocal ? "http://localhost:8080" : "https://www.gethumandesign.com",
    APP_ORIGIN: isLocal ? "http://localhost:8081" : "https://app.gethumandesign.com",
    // The marketing host as it is written down, whatever is serving this page.
    // kb-links.json carries these absolute URLs in every environment, because the
    // MCP clients that read the same map have no origin to resolve a path against
    // — so anything recognising a knowledge-base URL has to know this name too.
    SITE_CANONICAL: "https://www.gethumandesign.com",
    // Absolute URL for a path on the marketing site, e.g. siteUrl("/privacy/").
    siteUrl: function (path) {
      return this.SITE_ORIGIN + (path || "/");
    },
    // Absolute URL for a path/route in the app, e.g. appUrl("//settings").
    appUrl: function (path) {
      return this.APP_ORIGIN + (path || "/");
    },

    // --- The API ---------------------------------------------------------------
    // Local dev proxies /api/ on whichever origin the page came from → the
    // backend_api container (docker-compose.yml + frontend_web/nginx.conf).
    // Everywhere else calls the live API host directly, cross-origin.
    API_BASE_URL: isLocal ? "/api" : "https://api.gethumandesign.com",

    // --- Supabase --------------------------------------------------------------
    // The project the browser talks to. The anon key is public by design — it
    // carries no privilege of its own; row-level security and the user's JWT
    // decide what it may read. It is in the page source of every deployed page.
    // (Replaced below when the browser is switched to the local stack.)
    SUPABASE_REF: "esxruozvqtkmjspwwwkx",
    SUPABASE_URL: "https://esxruozvqtkmjspwwwkx.supabase.co",
    SUPABASE_ANON_KEY:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVzeHJ1b3p2cXRrbWpzcHd3d2t4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE3ODE0MTQsImV4cCI6MjA4NzM1NzQxNH0.pbkrWH8vU3o2zBEbMIfrpHxM0DDUYIJUYtnSi1swVcM",

    // Where the Supabase SDK keeps the session for this project. Pages read it
    // directly rather than waiting on the SDK's async init, which can take
    // seconds when a token refresh is due — first paint would wait with it.
    sessionKey: function () {
      return "sb-" + this.SUPABASE_REF + "-auth-token";
    },

    /**
     * The stored session if it is usable right now, else null.
     *
     * "Usable" means a token with a user attached that is still valid in 30
     * seconds — the margin keeps a request that is about to be sent from going
     * out with a token that expires in flight.
     *
     * Not every reader wants this question: /go/ and the app's own boot path
     * deliberately accept an expired access_token, because api.js refreshes and
     * retries on a 401 and bouncing to /login on expiry logs out people coming
     * back from a long redirect. Those read sessionKey() and judge for
     * themselves; everyone asking "is someone signed in" asks here.
     */
    readSession: function () {
      try {
        var raw = localStorage.getItem(this.sessionKey());
        var stored = raw ? JSON.parse(raw) : null;
        var notExpired = stored && stored.expires_at && stored.expires_at > Date.now() / 1000 + 30;
        if (stored && stored.access_token && stored.user && notExpired) return stored;
      } catch (e) {
        /* malformed token, or storage blocked entirely */
      }
      return null;
    },

    // --- Release ---------------------------------------------------------------
    // The release the shell was served with. Only the app shell stamps one
    // (dashboard/index.html); the public pages carry no <meta name="version">.
    // Read on demand, not at load: this file runs in the head of most pages,
    // before the parser has reached the meta.
    appVersion: function () {
      var meta = document.querySelector('meta[name="version"]');
      return (meta && meta.content) || "";
    },

    // An asset URL that changes when the release does, so a year-long immutable
    // cache entry can never outlive its content. On a page with no release stamp
    // the path is returned untouched: a "?v=" of nothing would only mint a second
    // cache entry for the same bytes (the share pages, which draw the bodygraph
    // SVG, are the pages that need this).
    versionedAsset: function (path) {
      var version = this.appVersion();
      if (!version) return path;
      var url = new URL(path, window.location.origin);
      url.searchParams.set("v", version);
      return url.toString();
    },

    PLAY_STORE_URL: "https://play.google.com/store/apps/details?id=com.gethumandesign.app",
    // The App Store listing (iPhone and iPad). The id is also the Smart App
    // Banner's `app-id` in every page head that carries one, and backend
    // email/letters.py spells the same URL; site-app-store.test.js pins all three.
    APP_STORE_ID: "6819655533",
    APP_STORE_URL: "https://apps.apple.com/app/id6819655533",
    // The App Store launch switch. Off until Apple approves the iOS app, because
    // the listing above does not exist publicly before then: off, nothing outside
    // the iOS app points at it (badges, Smart App Banner, the Home Screen note,
    // the FAQ answer, the letters' badge) and iPhone keeps Add to Home Screen.
    // The build reads this line too (tools/lib/app_store_switch.py), and the
    // backend's copy, config.APP_STORE_LIVE, is held equal to it by a test. Flip
    // both at go-live, then delete the switch (docs/plans/ios-app.md, "Launch").
    APP_STORE_LIVE: false,
    // Where an App Store subscription is managed from any browser: the web's
    // answer for an account Apple bills, which no Stripe portal can touch.
    APP_STORE_SUBSCRIPTIONS_URL: "https://apps.apple.com/account/subscriptions",
    // Sign in with Apple on every login and signup surface. Turning it off hides
    // the buttons without touching accounts that already sign in with Apple.
    APPLE_SIGN_IN: true,
    // Must match `packageId` in frontend_android/twa-manifest.json and
    // `package_name` in .well-known/assetlinks.json. Named separately from the
    // store URL because an intent:// link addresses the package, not the listing.
    ANDROID_PACKAGE: "com.gethumandesign.app",
    // Locales we ship an official "Get it on Google Play" badge for. To add a
    // language, download its official badge (see i18n/README.md) and drop the SVG
    // at assets/google-play-badge-<locale>.svg, then add the locale here.
    PLAY_BADGE_LOCALES: [
      "en",
      "nl",
      "de",
      "es",
      "fr",
      "it",
      "pt",
      "hu",
      "ru",
      "pl",
      "id",
      "tr",
      "ca",
      "uk",
      "el",
      "cs",
      "sv",
      "nb",
      "ro",
      "fi",
      "th",
      "vi",
      "bg",
      "da",
      "zh",
      "ko",
      "ja",
    ],
    // Locales whose official badge we hold only as a raster. The SVGs come from
    // Google's Partner Marketing Hub, which serves them behind a sign-in; the
    // badge is outlined text, so it cannot be retyped into an existing SVG
    // without stopping being Google's artwork. Hungarian and Russian therefore
    // ship the official PNG Google itself serves at
    // play.google.com/intl/<code>/badges/ — 646x250 into a ~135px slot is a 4.8x
    // source, so it is not soft. Swap either for the SVG (and drop the entry) the
    // next time someone is signed in to the hub. `footer.play_badge` in that
    // locale's common.json holds the same path for the footer partial and must be
    // changed with it. zh is Google's zh-TW badge (立即下載, Traditional), from
    // play.google.com/intl/en_us/badges/static/images/badges/zh-tw_badge_web_generic.png
    // — the same source tr's file is byte-identical to. sv, nb, ro, fi, th, vi, bg, da,
    // ko and ja are sv_, no_, ro_, fi_, th_, vi_, bg_, da_, ko_ and ja_badge_web_generic.png
    // from the same directory (Google has no nb file; its Norwegian badge is "no").
    PLAY_BADGE_PNG: [
      "hu",
      "ru",
      "pl",
      "id",
      "tr",
      "ca",
      "uk",
      "el",
      "cs",
      "sv",
      "nb",
      "ro",
      "fi",
      "th",
      "vi",
      "bg",
      "da",
      "zh",
      "ko",
      "ja",
    ],
    // Locales Apple publishes a localized "Download on the App Store" badge in,
    // saved from its Marketing Tools (tools.applemediaservices.com/api/badges/
    // download-on-the-app-store/black/<lang-region>) as assets/app-store-badge-
    // <locale>.svg, with a 3x PNG beside it for the letters (mail clients do not
    // draw SVG). Always the black badge: Apple asks for it whenever another
    // store's badge shares the layout, and it carries its own grey rule for dark
    // pages. Ukrainian is missing because Apple's tool serves the English badge
    // for it, so uk falls back to en. `footer.app_store_badge` in each
    // common.json names the same file for the footer partial.
    APP_STORE_BADGE_LOCALES: [
      "en",
      "nl",
      "de",
      "es",
      "fr",
      "it",
      "pt",
      "hu",
      "ru",
      "pl",
      "id",
      "tr",
      "ca",
      "el",
      "cs",
      "sv",
      "nb",
      "ro",
      "fi",
      "th",
      "vi",
      "bg",
      "da",
      "zh",
      "ko",
      "ja",
    ],
    // Locales the knowledge base is actually translated into — i.e. the ones with
    // a docs/knowledge-base/<locale> tree. The app has to know: it links into the
    // docs from chat replies and group pages, and a /<locale>/docs/… URL for a
    // language that was never built is a 404, which is worse than the English
    // page. Pinned to the trees on disk by tools/gate/i18n_check.py, so it
    // cannot drift.
    DOCS_LOCALES: [
      "en",
      "nl",
      "de",
      "es",
      "fr",
      "pt",
      "it",
      "hu",
      "ru",
      "pl",
      "id",
      "tr",
      "ca",
      "uk",
      "el",
      "cs",
      "sv",
      "nb",
      "ro",
      "fi",
      "th",
      "vi",
      "bg",
      "da",
      "ko",
      "ja",
      "zh",
    ],
    // The knowledge-base location for a UI locale: /docs/… in English,
    // /<locale>/docs/… where that language exists, and English for anything else.
    // Accepts either a root-relative path or an absolute URL on SITE_ORIGIN because
    // kb-links.json deliberately serves absolute canonical URLs for the MCP clients
    // that share it with the browser.
    docsPath: function (pathOrUrl, locale) {
      var p = String(pathOrUrl || "/");
      var l = (locale || "en").slice(0, 2).toLowerCase();
      if (l === "en" || this.DOCS_LOCALES.indexOf(l) === -1) return p;
      if (p.indexOf("/docs/") === 0) return "/" + l + p;
      // An absolute URL is localized under the host it already names, ours or not
      // yet resolved: kb-links.json is written with SITE_CANONICAL everywhere, so
      // matching only against this environment's SITE_ORIGIN left every
      // translated link on localhost and on preview deploys pointing at the
      // English tree — production behaviour that local dev could never surface.
      var absolute = /^(https?:\/\/[^/]+)(\/docs\/.*)$/.exec(p);
      if (absolute && (absolute[1] === this.SITE_ORIGIN || absolute[1] === this.SITE_CANONICAL)) {
        return absolute[1] + "/" + l + absolute[2];
      }
      return p;
    },
    // URL of the official localized Play badge for a given UI locale (falls back to en).
    // Absolute, not root-relative: /assets/ only exists on the marketing origin, and
    // the dashboard — which shows this badge in its "Download app" row — is served
    // from the app origin, where a bare "/assets/…" would 404.
    playBadge: function (locale) {
      var l = (locale || "en").slice(0, 2).toLowerCase();
      if (this.PLAY_BADGE_LOCALES.indexOf(l) === -1) l = "en";
      var ext = this.PLAY_BADGE_PNG.indexOf(l) === -1 ? ".svg" : ".png";
      return this.siteUrl("/assets/google-play-badge-" + l + ext);
    },
    // The official localized App Store badge for a UI locale (falls back to en).
    // Absolute for the same reason as playBadge.
    appStoreBadge: function (locale) {
      var l = (locale || "en").slice(0, 2).toLowerCase();
      if (this.APP_STORE_BADGE_LOCALES.indexOf(l) === -1) l = "en";
      return this.siteUrl("/assets/app-store-badge-" + l + ".svg");
    },
  };

  if (localSupabase) {
    // The Supabase CLI's demo project, identical on every machine — the same
    // strings tools/dev/local_supabase.py prints. The ref is what supabase-js
    // derives from the host ("127"), and sessionKey() follows it, so a local
    // session is never read as a production one or the other way round.
    window.GHD_APP.SUPABASE_REF = "127";
    window.GHD_APP.SUPABASE_URL = "http://127.0.0.1:54321";
    window.GHD_APP.SUPABASE_ANON_KEY =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0";
  }
})();

// Local dev only: cross-origin links between the two origins are baked into the
// markup as absolute production URLs, so they are correct in production without
// depending on JS at all. On localhost that would send a developer to the live
// site, so re-point them at the matching local origin. Matching on the production
// prefix means no marker attribute is needed in the markup.
//
// Only rewrites links present at DOMContentLoaded. Anything built later in JS
// reads its origin off GHD_APP above, which is already the local one here.
(function () {
  if (!window.GHD_APP.isLocal) return;
  var MAP = [
    ["https://www.gethumandesign.com", window.GHD_APP.SITE_ORIGIN],
    ["https://app.gethumandesign.com", window.GHD_APP.APP_ORIGIN],
  ];
  var fix = function () {
    MAP.forEach(function (pair) {
      document.querySelectorAll('a[href^="' + pair[0] + '"]').forEach(function (a) {
        a.href = pair[1] + a.getAttribute("href").slice(pair[0].length);
      });
    });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fix);
  else fix();
})();

;
/* logo.js */
(function () {
  // Canonical "get humandesign" teardrop mark (32-unit design box).
  // Glyph bbox ~ x7..25, y9..25; visual centre (16, 17.05); two-dot channel knockout.
  var PATH = "M 9,9 L 23,9 Q 26,9 24.3,12 L 17.7,23.6 Q 16,26.6 14.3,23.6 L 7.7,12 Q 6,9 9,9 Z";
  var uid = 0;

  function maskDefs(id) {
    return (
      '<defs><mask id="' +
      id +
      '">' +
      '<rect width="40" height="40" fill="white"/>' +
      '<circle cx="16" cy="13" r="1.9" fill="black"/>' +
      '<circle cx="16" cy="18.4" r="1.9" fill="black"/>' +
      '<rect x="15.525" y="13" width="0.95" height="5.4" fill="black"/>' +
      "</mask></defs>"
    );
  }

  // Standalone icon. viewBox crops to the glyph so it sits centred in its box.
  function logoSVG(opts) {
    var fill = opts && opts.fill != null ? opts.fill : "var(--accent)";
    var width = opts && opts.width != null ? opts.width : 26;
    var height = opts && opts.height != null ? opts.height : 26;
    var cls = opts && opts.cls != null ? opts.cls : "";
    var id = "lm-" + uid++;
    var clsAttr = cls ? ' class="' + cls + '"' : "";
    return (
      "<svg" +
      clsAttr +
      ' width="' +
      width +
      '" height="' +
      height +
      '" viewBox="4 5 24 24" fill="none" aria-hidden="true">' +
      maskDefs(id) +
      '<path d="' +
      PATH +
      '" fill="' +
      fill +
      '" mask="url(#' +
      id +
      ')"/>' +
      "</svg>"
    );
  }

  // Wordmark lockup. Icon sized to 4/3 em (~2x cap-height) and shifted so the
  // bottom dot's lower edge sits exactly on the text baseline (y=19); gap = 0.4 em.
  // The text is set at 2x and halved: Safari 15 lays text out at a whole-number
  // font size, and 14.5 widened to 15 pushed the last "n" past the viewBox.
  var VB_W = 147,
    VB_H = 28;
  function logoWithTextSVG(opts) {
    var height = opts && opts.height != null ? opts.height : 28;
    var cls = opts && opts.cls != null ? opts.cls : "";
    var accentFill = opts && opts.accentFill != null ? opts.accentFill : "var(--accent)";
    var textFill = opts && opts.textFill != null ? opts.textFill : "var(--text)";
    var id = "lm-" + uid++;
    var clsAttr = cls ? ' class="' + cls + '"' : "";
    var width = Math.round(height * (VB_W / VB_H));
    return (
      "<svg" +
      clsAttr +
      ' height="' +
      height +
      '" width="' +
      width +
      '" viewBox="0 0 ' +
      VB_W +
      " " +
      VB_H +
      '" fill="none" aria-hidden="true" text-rendering="geometricPrecision">' +
      '<g transform="translate(-5.5185,-5.5285) scale(1.2083)">' +
      maskDefs(id) +
      '<path d="' +
      PATH +
      '" fill="' +
      accentFill +
      '" mask="url(#' +
      id +
      ')"/>' +
      "</g>" +
      '<text transform="scale(0.5)" y="38" font-family="\'DM Sans\', system-ui, sans-serif" font-size="29" letter-spacing="-0.66">' +
      '<tspan x="60.86" fill="' +
      accentFill +
      '" font-weight="500">get</tspan>' +
      '<tspan dx="2" fill="' +
      textFill +
      '" font-weight="700">humandesign</tspan>' +
      "</text>" +
      "</svg>"
    );
  }

  // Greyscale secondary lockup (Option B): same geometry, two-tone grey instead
  // of orange. Mark + "get" use --text-mid (a warm mid-grey defined for both
  // themes); "humandesign" uses --text. Theme-aware via the app's [data-theme].
  function logoGreyWithTextSVG(opts) {
    opts = opts || {};
    return logoWithTextSVG({
      height: opts.height,
      cls: opts.cls,
      accentFill: opts.accentFill != null ? opts.accentFill : "var(--text-mid)",
      textFill: opts.textFill != null ? opts.textFill : "var(--text)",
    });
  }

  window.logoSVG = logoSVG;
  window.logoWithTextSVG = logoWithTextSVG;
  window.logoGreyWithTextSVG = logoGreyWithTextSVG;

  function inject() {
    document.querySelectorAll("[data-logo-header]").forEach(function (el) {
      el.outerHTML = logoSVG({ cls: "logo-icon", width: 34, height: 34 });
    });
    document.querySelectorAll("[data-logo-footer]").forEach(function (el) {
      el.outerHTML = logoSVG({ fill: "var(--text)", width: 64, height: 64 });
    });
    document.querySelectorAll("[data-logo-with-text]").forEach(function (el) {
      var h = el.getAttribute("data-logo-with-text") || "28";
      el.outerHTML = logoWithTextSVG({ height: parseInt(h, 10) });
    });
    document.querySelectorAll("[data-logo-grey-with-text]").forEach(function (el) {
      var h = el.getAttribute("data-logo-grey-with-text") || "22";
      el.outerHTML = logoGreyWithTextSVG({ height: parseInt(h, 10) });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", inject);
  } else {
    inject();
  }
})();

;
/* js/status-dot.js */
/* The footer's status pill — colours itself from status.gethumandesign.com.
 *
 * The pill ships grey and says "Status" (see partials/footer.html). Only a
 * reading it actually got upgrades it to green, amber or red. Everything that
 * can go wrong — offline, blocked by an extension, CORS, a mid-deploy 404, a
 * watchdog that has stopped publishing — resolves to the same answer: leave it
 * exactly as the HTML shipped it. A green dot nobody measured is worse than no
 * dot, because it is the one thing on the page that a visitor would believe
 * during an outage.
 *
 * The verdict itself is computed once, in the status Worker's cron sweep, and
 * published as a ~110-byte summary. That is deliberate: the alternative is a
 * second copy of the banner rules here, drifting away from the status page's,
 * and 45 KB of ninety-day history pulled on every landing-page view to colour
 * one dot.
 */
(function () {
  "use strict";

  var ENDPOINT = "https://status.gethumandesign.com/api/status/summary";

  /* How old the *oldest* component's check may get before we stop claiming
   * anything. The probes do not share a cadence — most run every five minutes,
   * the chat and engine checks every fifteen — so this is three misses of the
   * slowest one. The status page's own note uses 20 minutes because it asks a
   * different question (is the monitor alive at all, which the newest check
   * answers); a pill that says "all systems" has to age out on the component
   * that has been quiet longest, or one stalled probe family leaves it green
   * forever.
   *
   * Measured against the reader's clock rather than a second timestamp in the
   * payload, for the reason status.js gives: the monitor writing the checks and
   * the watchdog publishing them can stall independently, and two fields from
   * the same payload cannot see the second one stop. */
  var STALE_MS = 45 * 60 * 1000;

  function paint(el, state) {
    var label = el.getAttribute("data-label-" + state);
    if (!label) return; // unknown / unrecognised state: stay grey and say "Status"
    var node = el.querySelector(".footer-status-label");
    if (node) node.textContent = label;
    el.setAttribute("data-state", state);
  }

  function load(el) {
    fetch(ENDPOINT, { cache: "no-store" })
      .then(function (res) {
        if (!res.ok) throw new Error("status HTTP " + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.state || !data.oldest_check_at) return;
        if (Date.now() - new Date(data.oldest_check_at).getTime() > STALE_MS) return;
        paint(el, data.state);
      })
      .catch(function () {
        /* We don't know, so we don't say. */
      });
  }

  document.addEventListener("DOMContentLoaded", function () {
    var el = document.getElementById("footer-status");
    if (!el || !window.fetch) return;

    // Below the fold by definition — nothing here may compete with the page's
    // own content for bandwidth before anyone has scrolled to it.
    var start = function () {
      load(el);
    };
    if (!("IntersectionObserver" in window)) {
      setTimeout(start, 3000);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          io.disconnect();
          start();
          return;
        }
      },
      { rootMargin: "200px" },
    );
    io.observe(el);
  });
})();

;
/* pricing.js */
/**
 * Shared pricing utilities: which currency a reader is shown, exchange rates,
 * what Checkout will charge, how a price is worded, and the currency picker.
 * Used by both the homepage (index.html) and the dashboard's upgrade cards.
 *
 * The storage keys below are spelled out rather than read from GHD.KEYS
 * (dashboard/js/storage-keys.js): this file also runs on the landing pages,
 * which don't load the dashboard bundle. They are registered there too — keep
 * the two in step.
 */
var Pricing = (function () {
  // Every currency we are willing to quote a price in. The English names are a
  // fallback only: `currencyName()` asks Intl for the reader's own language
  // first, which is why none of these strings live in the i18n catalogs.
  //
  // The list is bounded by what we can price *accurately*: a currency belongs
  // here only if one of the two rate sources below publishes it daily. That
  // rules out the hyperinflationary and sanctioned ones (VES, IRR, LBP, ZWL) —
  // a converted price there is a number, not information — and the Argentine
  // peso, whose official rate (the one both sources publish) is about 30%
  // below what an Argentine card pays.
  var CURRENCIES = {
    // Americas
    USD: "US Dollar",
    CAD: "Canadian Dollar",
    MXN: "Mexican Peso",
    BRL: "Brazilian Real",
    CLP: "Chilean Peso",
    COP: "Colombian Peso",
    PEN: "Peruvian Sol",
    UYU: "Uruguayan Peso",
    BOB: "Bolivian Boliviano",
    DOP: "Dominican Peso",
    GTQ: "Guatemalan Quetzal",
    CRC: "Costa Rican Colón",
    // Europe
    EUR: "Euro",
    GBP: "British Pound",
    CHF: "Swiss Franc",
    SEK: "Swedish Krona",
    NOK: "Norwegian Krone",
    DKK: "Danish Krone",
    ISK: "Icelandic Króna",
    PLN: "Polish Złoty",
    CZK: "Czech Koruna",
    HUF: "Hungarian Forint",
    RON: "Romanian Leu",
    RSD: "Serbian Dinar",
    UAH: "Ukrainian Hryvnia",
    RUB: "Russian Ruble",
    TRY: "Turkish Lira",
    // Middle East
    ILS: "Israeli New Shekel",
    AED: "UAE Dirham",
    SAR: "Saudi Riyal",
    QAR: "Qatari Riyal",
    KWD: "Kuwaiti Dinar",
    BHD: "Bahraini Dinar",
    OMR: "Omani Rial",
    JOD: "Jordanian Dinar",
    // Africa
    ZAR: "South African Rand",
    EGP: "Egyptian Pound",
    NGN: "Nigerian Naira",
    KES: "Kenyan Shilling",
    GHS: "Ghanaian Cedi",
    MAD: "Moroccan Dirham",
    TND: "Tunisian Dinar",
    DZD: "Algerian Dinar",
    TZS: "Tanzanian Shilling",
    MUR: "Mauritian Rupee",
    // Asia & Pacific
    JPY: "Japanese Yen",
    CNY: "Chinese Yuan",
    HKD: "Hong Kong Dollar",
    TWD: "New Taiwan Dollar",
    KRW: "South Korean Won",
    SGD: "Singapore Dollar",
    MYR: "Malaysian Ringgit",
    THB: "Thai Baht",
    IDR: "Indonesian Rupiah",
    PHP: "Philippine Peso",
    VND: "Vietnamese Dong",
    INR: "Indian Rupee",
    PKR: "Pakistani Rupee",
    BDT: "Bangladeshi Taka",
    LKR: "Sri Lankan Rupee",
    NPR: "Nepalese Rupee",
    AUD: "Australian Dollar",
    NZD: "New Zealand Dollar",
    // Central Asia & Caucasus
    KZT: "Kazakhstani Tenge",
    GEL: "Georgian Lari",
    AMD: "Armenian Dram",
    AZN: "Azerbaijani Manat",
    UZS: "Uzbekistani Som",
  };

  // Which currency a country's visitor is quoted in, by geo-IP or by the
  // browser's region. Only currencies in CURRENCIES appear; geo-IP quotes a
  // visitor from anywhere else the euro, the currency Pro is priced in
  // (`primeGeoCurrency`). Checkout charges a local price by the same table:
  // backend/billing/local_prices.py COUNTRY_CURRENCY is it lower-cased, and a
  // test holds the two equal.
  var LOCALE_CURRENCY = {
    US: "USD",
    GB: "GBP",
    JP: "JPY",
    AU: "AUD",
    CA: "CAD",
    CH: "CHF",
    IN: "INR",
    BR: "BRL",
    MX: "MXN",
    // Dollars, not pesos: see the peso's note above CURRENCIES.
    AR: "USD",
    CL: "CLP",
    CO: "COP",
    PE: "PEN",
    UY: "UYU",
    BO: "BOB",
    DO: "DOP",
    GT: "GTQ",
    CR: "CRC",
    // Dollar economies, and (PY, HN, NI, VE) countries whose own money we do
    // not quote, where a price from abroad is read in dollars.
    EC: "USD",
    SV: "USD",
    PA: "USD",
    PR: "USD",
    PY: "USD",
    HN: "USD",
    NI: "USD",
    VE: "USD",
    TL: "USD",
    SE: "SEK",
    NO: "NOK",
    DK: "DKK",
    IS: "ISK",
    PL: "PLN",
    CZ: "CZK",
    HU: "HUF",
    RO: "RON",
    RS: "RSD",
    UA: "UAH",
    RU: "RUB",
    TR: "TRY",
    // The Crown Dependencies and Liechtenstein use their neighbour's money.
    JE: "GBP",
    GG: "GBP",
    IM: "GBP",
    LI: "CHF",
    IL: "ILS",
    AE: "AED",
    SA: "SAR",
    QA: "QAR",
    KW: "KWD",
    BH: "BHD",
    OM: "OMR",
    JO: "JOD",
    ZA: "ZAR",
    EG: "EGP",
    NG: "NGN",
    KE: "KES",
    GH: "GHS",
    MA: "MAD",
    TN: "TND",
    DZ: "DZD",
    TZ: "TZS",
    MU: "MUR",
    CN: "CNY",
    HK: "HKD",
    TW: "TWD",
    KR: "KRW",
    SG: "SGD",
    MY: "MYR",
    TH: "THB",
    ID: "IDR",
    PH: "PHP",
    VN: "VND",
    PK: "PKR",
    BD: "BDT",
    LK: "LKR",
    NP: "NPR",
    NZ: "NZD",
    KZ: "KZT",
    GE: "GEL",
    AM: "AMD",
    AZ: "AZN",
    UZ: "UZS",
    DE: "EUR",
    FR: "EUR",
    IT: "EUR",
    ES: "EUR",
    NL: "EUR",
    BE: "EUR",
    AT: "EUR",
    PT: "EUR",
    FI: "EUR",
    IE: "EUR",
    GR: "EUR",
    SK: "EUR",
    SI: "EUR",
    LV: "EUR",
    LT: "EUR",
    EE: "EUR",
    LU: "EUR",
    MT: "EUR",
    CY: "EUR",
    HR: "EUR",
    // The euro since 2026-01-01.
    BG: "EUR",
    // The euro outside the EU: geo-IP would quote it anyway, a browser's
    // region would not.
    AD: "EUR",
    MC: "EUR",
    SM: "EUR",
    VA: "EUR",
    ME: "EUR",
    XK: "EUR",
  };

  // The currency each shipped language is quoted in when nothing better is
  // known. Most name one country's money; English names none, so it
  // takes the dollar and lets geo-IP sharpen it (a London reader gets GBP).
  // Portuguese is Brazilian here — so is our og:locale (i18n/locales.json).
  var LANGUAGE_CURRENCY = {
    en: "USD",
    nl: "EUR",
    de: "EUR",
    fr: "EUR",
    es: "EUR",
    it: "EUR",
    pt: "BRL",
    // Traditional Chinese is Taiwan's first (the registry's hreflang lists
    // zh-TW before zh-HK); geo-IP moves a Hong Kong reader to HKD. The page
    // is `lang="zh-Hant"`, which pageLanguage() cuts back to "zh".
    zh: "TWD",
    // Languages read mostly in one country take that country's money. Russian
    // is left to the browser's region: it is read across a dozen countries.
    tr: "TRY",
    pl: "PLN",
    cs: "CZK",
    hu: "HUF",
    uk: "UAH",
    id: "IDR",
    el: "EUR",
    ca: "EUR",
  };

  var PRICES_EUR = { monthly: 3.99, yearly: 39.99 };
  // Pro inside the phone apps, where the stores take their commission:
  // frontend_ios/store_listing/subscriptions.json (test_landing_pricing_currency.py).
  var STORE_PRICES_EUR = { monthly: 4.99, yearly: 47.99 };
  var LS_KEY = "fx_selected_currency";
  var GEO_KEY = "fx_geo_currency"; // cached currency from Cloudflare geo-IP
  // + YYYY-MM-DD: one day's exchange rates. The "2" is the shape of the
  // table, not its age: the first version cached ten currencies, and a
  // browser holding one of those would have priced the other sixty in euros
  // for the rest of the day. A new prefix retires them without a size check —
  // which would also have refetched all day on a day one source was down,
  // backing off exactly when we should be leaning on the cache.
  var FX_PREFIX = "fx2_EUR_";
  var FX_PREFIX_OLD = "fx_EUR_";

  function _fromRegion(region) {
    var cur = LOCALE_CURRENCY[region];
    return cur && CURRENCIES[cur] ? cur : null;
  }

  // A stored code, or null for none, for one we no longer quote, or for
  // storage the browser blocks.
  function _stored(key) {
    try {
      var code = localStorage.getItem(key);
      return code && CURRENCIES[code] ? code : null;
    } catch (e) {
      return null;
    }
  }

  // The language this page is being read in — <html lang>, which the build
  // stamps per locale and the dashboard rewrites when the account language
  // changes. Falls back to the browser's own language.
  function _intlLocale() {
    var lang = "";
    try {
      lang = document.documentElement.getAttribute("lang") || "";
    } catch (e) {}
    return lang || navigator.language || "en";
  }

  function pageLanguage() {
    return _intlLocale().split("-")[0].toLowerCase();
  }

  // The browser's locales, most preferred first, each as [language, region];
  // the region is "" for a bare "es" or an "es-419".
  function _browserLocales() {
    var tags = [];
    try {
      tags = Array.prototype.slice.call(navigator.languages || []);
    } catch (e) {}
    tags.push(navigator.language || "");
    return tags.map(function (tag) {
      var parts = String(tag).split("-");
      var region = parts.slice(1).filter(function (part) {
        return /^[A-Za-z]{2}$/.test(part);
      })[0];
      return [parts[0].toLowerCase(), (region || "").toUpperCase()];
    });
  }

  // What we quote before the reader or geo-IP says otherwise. A browser locale
  // in the page's own language says where its reader is (es-MX on the Spanish
  // page, pt-PT on the Portuguese one); failing that, the page language's own
  // currency; failing that, any region the browser names. Geo-IP refines this
  // in `primeGeoCurrency`, a network round trip later.
  function defaultCurrency() {
    var page = pageLanguage();
    var locales = _browserLocales();
    var cur = null;
    var i;
    for (i = 0; i < locales.length && !cur; i++) {
      if (locales[i][0] === page) cur = _fromRegion(locales[i][1]);
    }
    if (cur) return cur;
    var byLang = LANGUAGE_CURRENCY[page];
    if (byLang && CURRENCIES[byLang]) return byLang;
    for (i = 0; i < locales.length && !cur; i++) cur = _fromRegion(locales[i][1]);
    return cur || "EUR";
  }

  // Best guess short of the reader's own pick: a cached geo-IP currency beats
  // the browser and the language, because where someone is says more about the
  // money they hold than the language they read in.
  function detectCurrency() {
    return _stored(GEO_KEY) || defaultCurrency();
  }

  // Cloudflare's edge geo-IP (same-origin /cdn-cgi/trace, loc=XX), cached as the
  // currency to quote. Resolves to that currency when it moves the guess, else
  // null: the reader has picked one, the lookup failed (local dev has no
  // Cloudflare), or it confirms the guess. Asked once per page load.
  var _geo = null;
  function primeGeoCurrency() {
    if (_stored(LS_KEY)) return Promise.resolve(null); // the reader chose
    if (_geo) return _geo;
    var before = detectCurrency();
    _geo = fetch("/cdn-cgi/trace")
      .then(function (r) {
        return r.text();
      })
      .then(function (txt) {
        var m = txt.match(/(?:^|\n)loc=([A-Z]{2})/);
        // XX is Cloudflare's "unknown"; T1 (Tor) never matches two letters.
        if (!m || m[1] === "XX") return null;
        // A country whose money we don't quote sees the euro price itself, not
        // its language's currency: an Angolan on /pt/ must not be quoted reais.
        var cur = _fromRegion(m[1]) || "EUR";
        try {
          localStorage.setItem(GEO_KEY, cur);
        } catch (e) {}
        return cur === before ? null : cur;
      })
      .catch(function () {
        return null;
      });
    return _geo;
  }

  // Yesterday's rates are dead weight — drop every cached table but today's,
  // under either prefix. Without this a daily visitor accumulates one entry per
  // day, forever, and the retired fx_EUR_* ones would never be collected at all.
  function _pruneStaleRates(keepKey) {
    try {
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var k = localStorage.key(i);
        if (!k || k === keepKey) continue;
        if (k.indexOf(FX_PREFIX) === 0 || k.indexOf(FX_PREFIX_OLD) === 0) localStorage.removeItem(k);
      }
    } catch (e) {}
  }

  function _fetchJson(url) {
    return fetch(url)
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return null;
      });
  }

  // Two sources, because neither alone covers the list above. Frankfurter
  // republishes the ECB's daily reference rates — thirty currencies, the best
  // provenance available for free — and open.er-api.com fills in the other
  // forty. They are fetched together and merged with the ECB winning every
  // overlap, so one source going dark costs us currencies, never a wrong price.
  function _fetchRates() {
    return Promise.all([
      _fetchJson("https://api.frankfurter.dev/v1/latest?base=EUR"),
      _fetchJson("https://open.er-api.com/v6/latest/EUR"),
    ]).then(function (res) {
      var wide = (res[1] && res[1].rates) || {};
      var ecb = (res[0] && res[0].rates) || {};
      var rates = {};
      Object.keys(CURRENCIES).forEach(function (code) {
        var v = ecb[code] || wide[code];
        if (typeof v === "number" && v > 0) rates[code] = v;
      });
      rates.EUR = 1;
      return rates;
    });
  }

  function loadRates() {
    var key = FX_PREFIX + new Date().toISOString().slice(0, 10);
    var cached = null;
    try {
      cached = localStorage.getItem(key);
    } catch (e) {
      /* blocked storage — refetch below, every time */
    }
    if (cached) {
      try {
        var parsed = JSON.parse(cached);
        // Whatever the two sources answered with today, even a partial table:
        // a currency with no rate is priced in euros for the day, which is the
        // same answer refetching would give while the source is still down.
        if (parsed) return Promise.resolve(parsed);
      } catch (e) {}
    }
    return _fetchRates()
      .then(function (rates) {
        // Neither source answered — offline, or both blocked. Price in euros for
        // this view, but don't write that down: cached, it would hold every page
        // view for the rest of the day in euros after the network came back.
        if (Object.keys(rates).length < 2) return rates;
        try {
          localStorage.setItem(key, JSON.stringify(rates));
          // Only a new day writes a new key, so pruning on write is enough.
          _pruneStaleRates(key);
        } catch (e) {
          /* uncached rates still price the page; they just cost a fetch */
        }
        return rates;
      })
      .catch(function () {
        // ECB reference rates of 2026-10-23, for when the merge itself fails.
        return { EUR: 1, USD: 1.12, GBP: 0.84, MXN: 21, BRL: 5.65 };
      });
  }

  // Currency names in the reader's own language, straight from the browser's
  // CLDR data — "Amerikaanse dollar", "dollar des États-Unis". Nothing here is
  // a catalog string, so the picker reads natively in languages we don't even
  // ship. Old engines without Intl.DisplayNames get the English table.
  var _names = null;
  function _nameTable() {
    if (_names) return _names;
    _names = {};
    var dn = null;
    try {
      dn = new Intl.DisplayNames([_intlLocale()], { type: "currency" });
    } catch (e) {}
    Object.keys(CURRENCIES).forEach(function (code) {
      var localized = "";
      try {
        localized = dn ? dn.of(code) : "";
      } catch (e) {}
      // Intl echoes the code back when it has no name for it.
      _names[code] = localized && localized !== code ? localized : CURRENCIES[code];
    });
    return _names;
  }

  function currencyName(code) {
    return _nameTable()[code] || code;
  }

  // Lower-cased and stripped of diacritics, so "zloty" finds "Złoty" and
  // "colon" finds "Colón". Sorting uses the same key: the localized names are
  // what the reader scans, so they decide the order, not the English ones.
  // Letters of every script survive, or a Korean "원" or a Russian "рубль"
  // folds to nothing and matches every currency.
  var _NOT_A_LETTER = (function () {
    try {
      return new RegExp("[^\\p{L}\\p{M}\\p{N}]+", "gu");
    } catch (e) {
      return /[^a-z0-9]+/g;
    }
  })();

  function _foldSearch(s) {
    var out = String(s).toLowerCase();
    try {
      out = out.normalize("NFD").replace(/[̀-ͯ]/g, "");
    } catch (e) {}
    return out.replace(_NOT_A_LETTER, "");
  }

  // The picker's order: the reader's own currency first, then the euro (the
  // currency Pro is priced in), then everything else A–Z by its localized name.
  function currencyList(selected) {
    var names = _nameTable();
    var rest = Object.keys(CURRENCIES).filter(function (c) {
      return c !== selected && c !== "EUR";
    });
    try {
      rest.sort(function (a, b) {
        return names[a].localeCompare(names[b], _intlLocale());
      });
    } catch (e) {
      rest.sort();
    }
    var head = [];
    if (CURRENCIES[selected]) head.push(selected);
    if (selected !== "EUR") head.push("EUR");
    return head.concat(rest);
  }

  // Codes whose code or name contains `query`. An empty query is the whole
  // list, in `currencyList` order.
  function searchCurrencies(query, selected) {
    var all = currencyList(selected);
    var q = _foldSearch(query || "");
    if (!q) return all;
    var names = _nameTable();
    return all.filter(function (code) {
      // The code matches only as a prefix — "us" finds USD, "sd" should not —
      // while a name matches anywhere in it, so "dollar" finds all nine.
      return (
        code.toLowerCase().indexOf(q) === 0 ||
        _foldSearch(names[code]).indexOf(q) !== -1 ||
        _foldSearch(CURRENCIES[code]).indexOf(q) !== -1
      );
    });
  }

  // `digits` overrides the decimal places — the free plan passes 0, so its
  // nothing reads as "$0" rather than "$0.00". Omitted, the currency decides:
  // CLDR knows the yen and the won have no cents and the dinar has three.
  //
  // The euro used to be hand-formatted here as "€" + toFixed(2), which is right
  // in English and wrong in five of the six other languages we ship — a Dutch
  // or German reader writes €29,99. Intl gets it right in all seven, and it is
  // asked in the page's language rather than the browser's, so the separators
  // match the page the number sits on.
  function formatPrice(currency, amount, digits) {
    var opts = /** @type {Intl.NumberFormatOptions} */ ({ style: "currency", currency: currency });
    if (digits !== undefined) {
      opts.minimumFractionDigits = digits;
      opts.maximumFractionDigits = digits;
    }
    try {
      return new Intl.NumberFormat(_intlLocale(), opts).format(amount);
    } catch (e) {
      return currency + " " + amount.toFixed(2);
    }
  }

  // ── What Checkout will take, and how a card words it ──────────────────────

  // The longest a price waits for any one thing it is drawn from.
  var WAIT_MS = 3000;

  // `promise`'s answer, or `fallback` once it has failed or taken `ms`.
  function _within(promise, ms, fallback) {
    return new Promise(function (resolve) {
      var timer = setTimeout(function () {
        resolve(fallback);
      }, ms);
      promise.then(
        function (value) {
          clearTimeout(timer);
          resolve(value);
        },
        function () {
          clearTimeout(timer);
          resolve(fallback);
        },
      );
    });
  }

  function _positive(n) {
    return typeof n === "number" && isFinite(n) && n > 0;
  }

  // GET /v1/pricing's answer as {currency, monthly, yearly}, or null for one we
  // could not price from.
  function _chargeFrom(body) {
    var code = body && typeof body.currency === "string" ? body.currency.toUpperCase() : "";
    var prices = CURRENCIES[code] && body.prices;
    var own = prices && typeof prices === "object" ? prices[code.toLowerCase()] : null;
    if (!own || !_positive(own.monthly) || !_positive(own.yearly)) return null;
    return { currency: code, monthly: own.monthly, yearly: own.yearly };
  }

  // The signed-in reader's access token, or null. Sent so the API can answer a
  // returning customer the way Checkout will: Stripe may hold them to the
  // currency they paid in before.
  function _accessToken() {
    try {
      var session = window.GHD_APP && window.GHD_APP.readSession ? window.GHD_APP.readSession() : null;
      return (session && session.access_token) || null;
    } catch (e) {
      return null;
    }
  }

  // What Checkout will charge this reader, in major units: {currency: "MXN",
  // monthly: 49, yearly: 499}. The API decides it by the country Cloudflare
  // sees, the lookup the page quotes by. Anything short of a usable answer is
  // the euro price, which is what Checkout charges wherever it has no local
  // one. One request for the page however many cards ask; a failed one is
  // asked again by the next.
  var _charge = null;
  function loadCharge() {
    if (_charge) return _charge;
    var euro = { currency: "EUR", monthly: PRICES_EUR.monthly, yearly: PRICES_EUR.yearly };
    var base = window.GHD_APP && window.GHD_APP.API_BASE_URL;
    if (!base) return Promise.resolve(euro);
    var ctrl = typeof AbortController === "function" ? new AbortController() : null;
    var init = /** @type {RequestInit} */ ({});
    if (ctrl) init.signal = ctrl.signal;
    var token = _accessToken();
    if (token) init.headers = { Authorization: "Bearer " + token };
    var asked = fetch(base + "/v1/pricing", init)
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(_chargeFrom);
    _charge = _within(asked, WAIT_MS, null).then(function (charge) {
      if (charge) return charge;
      if (ctrl) ctrl.abort();
      _charge = null;
      return euro;
    });
    return _charge;
  }

  // Everything a price is drawn from, so it is painted once and in the right
  // currency: the geo-IP answer (on a first visit it can move the currency),
  // the day's rates and the charge, each wait bounded. `currency` is the one to
  // show, unless the reader has picked one meanwhile.
  function loadPriceInputs() {
    return Promise.all([
      _within(primeGeoCurrency(), WAIT_MS, null),
      _within(loadRates(), WAIT_MS, null),
      loadCharge(),
    ]).then(function (got) {
      return { currency: _stored(LS_KEY) || got[0] || detectCurrency(), rates: got[1], charge: got[2] };
    });
  }

  // An amount as Checkout takes it: to the cent, and a whole one without the
  // ".00" (MX$49, not MX$49.00).
  function _exact(currency, amount) {
    return formatPrice(currency, amount, Number.isInteger(amount) ? 0 : undefined);
  }

  // A conversion claims only what it knows: whole units from 20 up, where cents
  // would be false precision, and the currency's own decimals below.
  function _approx(currency, amount) {
    return amount >= 20 ? formatPrice(currency, Math.round(amount), 0) : formatPrice(currency, amount);
  }

  function _rateOf(code, rates) {
    if (code === "EUR") return 1;
    var rate = rates && rates[code];
    return _positive(rate) ? rate : 0;
  }

  function _fill(label, price) {
    // A function, so a "$" in the price is never read as a replacement pattern.
    return String(label || "").replace("{price}", function () {
      return price;
    });
  }

  // The yearly plan's saving on twelve monthly payments, as the badge prints it
  // ("-16%"), from the two prices this reader is charged; "" for none.
  function _saving(charge) {
    var pct = Math.round((1 - charge.yearly / (charge.monthly * 12)) * 100);
    if (!(pct > 0)) return "";
    try {
      return new Intl.NumberFormat(_intlLocale(), { style: "percent" }).format(-pct / 100);
    } catch (e) {
      return "-" + pct + "%";
    }
  }

  // What a Pro card prints for one period, shown in `display` where the day's
  // rates allow. The landing page and the app's upgrade cards both print this,
  // so the two can never word a price differently.
  //
  //   charge  what Checkout will take (`loadCharge`)
  //   rates   the day's EUR-based table (`loadRates`), or null
  //   period  "monthly" | "yearly"; both are quoted per month
  //   labels  {billedAsYear, convertedFromMonth, convertedFromYear}, each with
  //           a {price}: the caller's catalog, as this file serves every locale
  //
  // In the charge's own currency every amount is exact. In any other it is a
  // conversion at the day's reference rate, which what is finally taken will
  // not match to the cent (Stripe or the card converts at its own rate, plus a
  // fee), so it says "≈" and the note names the real price. A display currency
  // with no rate today is shown as the charge, exactly.
  //   -> {headline, note, exact, currency, free, saving}
  function quote(charge, display, rates, period, labels) {
    labels = labels || {};
    var yearly = period === "yearly";
    var from = _rateOf(charge.currency, rates);
    var to = _rateOf(display, rates);
    var converted = display !== charge.currency && from > 0 && to > 0;
    var shown = converted ? display : charge.currency;
    var perMonth = yearly ? charge.yearly / 12 : charge.monthly;
    var real = _exact(charge.currency, yearly ? charge.yearly : charge.monthly);
    var note = "";
    if (converted) note = _fill(yearly ? labels.convertedFromYear : labels.convertedFromMonth, real);
    else if (yearly) note = _fill(labels.billedAsYear, real);
    return {
      headline: converted ? "≈ " + _approx(shown, (perMonth / from) * to) : _exact(shown, perMonth),
      note: note,
      exact: !converted,
      currency: shown,
      // The free plan's nothing, in the same money as Pro and never "≈".
      free: formatPrice(shown, 0, 0),
      saving: _saving(charge),
    };
  }

  // Renders the option rows into `ul`. `query` filters them; `labels` carries
  // the two strings this file cannot translate itself — the header and the
  // empty-result line — because it runs on all seven locales from one copy.
  function renderDropdown(ul, selected, query, labels) {
    labels = labels || {};
    ul.innerHTML = "";
    var header = document.createElement("li");
    header.className = "currency-dropdown-header";
    header.setAttribute("aria-disabled", "true");
    header.textContent = labels.header || "Show price in";
    ul.appendChild(header);

    var codes = searchCurrencies(query, selected);
    if (!codes.length) {
      var empty = document.createElement("li");
      empty.className = "currency-dropdown-empty";
      empty.setAttribute("aria-disabled", "true");
      empty.textContent = labels.empty || "No currency found";
      ul.appendChild(empty);
      return;
    }
    var names = _nameTable();
    codes.forEach(function (code) {
      var li = document.createElement("li");
      li.setAttribute("role", "option");
      li.setAttribute("aria-selected", code === selected ? "true" : "false");
      li.dataset.currency = code;
      var abbr = document.createElement("span");
      abbr.className = "currency-code";
      abbr.textContent = code;
      var name = document.createElement("span");
      name.className = "currency-name";
      name.textContent = names[code];
      li.appendChild(abbr);
      li.appendChild(name);
      ul.appendChild(li);
    });
  }

  // The currency to show: the reader's own pick, else the best guess.
  function getSelectedCurrency() {
    return _stored(LS_KEY) || detectCurrency();
  }

  function setSelectedCurrency(code) {
    try {
      localStorage.setItem(LS_KEY, code);
    } catch (e) {
      /* the choice just wont outlive the page */
    }
  }

  // Wires a whole currency picker onto `root` (a .currency-selector holding the
  // trigger button): builds the search box and the option list, and owns the
  // opening, filtering, click-away and keyboard. Both the landing page and the
  // dashboard's upgrade card mount one, which is why the behaviour lives here
  // rather than twice in their own files.
  //
  //   opts.labels  {header, search, empty} — translated by the caller, because
  //                this file is served as one copy to all seven locales
  //   opts.value   the code to start on
  //   opts.signal  optional AbortSignal, for a card that can be torn down
  //   opts.onSelect(code) — the reader picked one
  //
  // Returns { set(code) }, so a caller can push a later geo-IP refinement in.
  function mountPicker(root, opts) {
    opts = opts || {};
    var labels = opts.labels || {};
    var btn = root.querySelector("button");
    var codeEl = root.querySelector("[data-currency-code]");
    var current = CURRENCIES[opts.value] ? opts.value : "EUR";
    var listen = opts.signal ? { signal: opts.signal } : undefined;

    var panel = document.createElement("div");
    panel.className = "currency-panel";
    panel.hidden = true;
    var input = document.createElement("input");
    input.type = "search";
    input.className = "currency-search";
    input.autocomplete = "off";
    input.spellcheck = false;
    input.placeholder = labels.search || "Search";
    input.setAttribute("aria-label", labels.search || "Search");
    var list = document.createElement("ul");
    list.className = "currency-dropdown";
    list.setAttribute("role", "listbox");
    panel.appendChild(input);
    panel.appendChild(list);
    root.appendChild(panel);

    function paint() {
      renderDropdown(list, current, input.value, labels);
    }

    function setCode(code) {
      current = code;
      if (codeEl) codeEl.textContent = code;
      paint();
    }

    function close() {
      panel.hidden = true;
      btn.setAttribute("aria-expanded", "false");
    }

    function open() {
      panel.hidden = false;
      btn.setAttribute("aria-expanded", "true");
      input.value = "";
      paint();
      // Not on a touch keyboard: raising it would cover the list it filters.
      if (!window.matchMedia || !window.matchMedia("(pointer: coarse)").matches) input.focus();
      var sel = list.querySelector('[aria-selected="true"]');
      if (sel) sel.scrollIntoView({ block: "nearest" });
    }

    // The row the arrow keys are on. Hovering doesn't move it — only the
    // keyboard does, so the two never fight over the same highlight.
    function options() {
      return Array.prototype.slice.call(list.querySelectorAll("li[data-currency]"));
    }

    function moveActive(step) {
      var opts_ = options();
      if (!opts_.length) return;
      var at = opts_.findIndex(function (li) {
        return li.classList.contains("is-active");
      });
      var next = at < 0 ? (step > 0 ? 0 : opts_.length - 1) : (at + step + opts_.length) % opts_.length;
      opts_.forEach(function (li) {
        li.classList.remove("is-active");
      });
      opts_[next].classList.add("is-active");
      opts_[next].scrollIntoView({ block: "nearest" });
    }

    function pick(code) {
      setSelectedCurrency(code);
      setCode(code);
      close();
      btn.focus();
      if (opts.onSelect) opts.onSelect(code);
    }

    btn.addEventListener(
      "click",
      function (e) {
        e.stopPropagation();
        if (panel.hidden) open();
        else close();
      },
      listen,
    );

    panel.addEventListener(
      "click",
      function (e) {
        e.stopPropagation();
        var li = /** @type {Element} */ (e.target).closest("li[data-currency]");
        if (li) pick(/** @type {HTMLElement} */ (li).dataset.currency);
      },
      listen,
    );

    input.addEventListener("input", paint, listen);

    input.addEventListener(
      "keydown",
      function (e) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          moveActive(1);
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          moveActive(-1);
        } else if (e.key === "Enter") {
          e.preventDefault();
          // Nothing highlighted yet: Enter takes the top hit, so typing
          // "yen" and pressing Enter is the whole interaction.
          var target = list.querySelector("li.is-active") || options()[0];
          if (target) pick(target.dataset.currency);
        } else if (e.key === "Escape") {
          close();
          btn.focus();
        }
      },
      listen,
    );

    document.addEventListener("click", close, listen);

    setCode(current);
    return { set: setCode };
  }

  return {
    CURRENCIES: CURRENCIES,
    PRICES_EUR: PRICES_EUR,
    STORE_PRICES_EUR: STORE_PRICES_EUR,
    currencyName: currencyName,
    currencyList: currencyList,
    searchCurrencies: searchCurrencies,
    defaultCurrency: defaultCurrency,
    detectCurrency: detectCurrency,
    primeGeoCurrency: primeGeoCurrency,
    loadRates: loadRates,
    loadCharge: loadCharge,
    loadPriceInputs: loadPriceInputs,
    quote: quote,
    formatPrice: formatPrice,
    renderDropdown: renderDropdown,
    mountPicker: mountPicker,
    getSelectedCurrency: getSelectedCurrency,
    setSelectedCurrency: setSelectedCurrency,
  };
})();

// Named on the window the way people-form.js and place-autocomplete.js name
// theirs, so a reader can be asked for it without a bare reference that throws
// when this file is the one that 404'd (js/landing.js, GHD.moduleOr). A
// top-level `var` in a classic script already lands here — this says so out
// loud, and keeps saying it if the declaration ever becomes a `const`, which
// would not (docs/internal/decisions.md, lexical globals are not on window).
window.Pricing = Pricing;

;
/* auth-nav.js */
/**
 * Shared login detection for static pages.
 * If a Supabase auth token exists in localStorage, updates the nav
 * to show logged-in actions (Chat button).
 *
 * Include this script at the bottom of every static page:
 *   <script src="/auth-nav.js" defer></script>
 *
 * Requirements:
 *   - Desktop nav-actions container:  id="nav-actions"
 *   - Mobile  nav-actions container:  class="mobile-nav-actions"
 *   - Mobile  nav-links   container:  class="mobile-nav-links" (optional)
 *   - Desktop nav-links   container:  nav element inside .site-header
 */
(function () {
  try {
    // Is this person signed in to the app?
    //
    // The session itself is unreachable from here: the app is served from
    // app.gethumandesign.com and localStorage is per-origin. So the app publishes
    // a `ghd_signed_in` flag as a cookie on the parent domain (see
    // dashboard/js/app.js `_publishSignedInHint`) and this reads that.
    //
    // The localStorage check stays as a second source, and not because of the
    // retired /dashboard/ shell: the landing page's chart form calls
    // supabase-js signUp() here (js/landing.js), so this origin holds a real
    // session from the moment someone signs up — while the cookie only appears
    // once they have loaded the app at least once.
    //
    // Getting this wrong is not cosmetic: without a signed-in signal the pricing
    // card never becomes "Upgrade", so a signed-in free user reading this page
    // has no route to checkout at all.
    var signedIn = /(?:^|;\s*)ghd_signed_in=1(?:;|$)/.test(document.cookie);

    // One reader of the stored session, in /app-config.js — which this page has
    // to load before this script for the fallback to work at all.
    if (!signedIn && !window.GHD_APP.readSession()) return;

    // Signed-in links go through /go/, which gets this origin's session across
    // to the app origin (localStorage is per-origin, so a direct link would land
    // the user signed out). Not by putting the session in the URL — /go/ sends a
    // bare flag and the app fetches the tokens over the /go/bridge/ postMessage
    // channel; see go/go.js for the leak that shaped this.
    // Signed-out CTAs link to the app directly: there is no
    // session to hand over, and the one thing they do have to carry — the page's
    // language — rides in the URL instead (tools/lib/i18n_common.stamp_app_locale),
    // which costs a signup no redirect and survives a device with no storage.
    var go = function (route) {
      return "/go/?to=" + encodeURIComponent(route);
    };

    var actionsHtml = '<a href="' + go("/chat") + '" class="btn-header-cta">Chat</a>';

    var nav = document.getElementById("nav-actions");
    if (nav) nav.innerHTML = actionsHtml;

    var mobileActions = document.querySelector(".mobile-nav-actions");
    if (mobileActions) mobileActions.innerHTML = actionsHtml;

    // On homepage: hide the signup CTAs for logged-in users — the header's
    // "Chat" button is their way in, so no second CTA is needed.
    var mobileCta = document.getElementById("mobile-cta");
    if (mobileCta) mobileCta.hidden = true;

    var mobileCtaNote = document.getElementById("mobile-cta-note");
    if (mobileCtaNote) {
      mobileCtaNote.hidden = true;
    }

    var chartForm = document.getElementById("chart-form");
    if (chartForm) chartForm.hidden = true;

    // The hero's quiet web route pointed at that form; it now points at their
    // chart, so the store badge is still not the only way in.
    var webAlt = document.getElementById("hero-web-alt");
    if (webAlt) {
      webAlt.href = go("/chat");
      webAlt.textContent = webAlt.getAttribute("data-label-signed-in") || webAlt.textContent;
      webAlt.classList.add("is-signed-in");
    }

    // Mid-article, a docs page invites the reader down to that form ("Calculate
    // your free chart ↓"). With the form hidden the link scrolls to nothing, and
    // the pitch is aimed at someone who already has a chart — so it goes too.
    // (kb-panel.js strips the same element for the same reason.)
    document.querySelectorAll(".docs-cta-inline").forEach(function (n) {
      n.hidden = true;
    });

    // Knowledge-base articles end with the same signup form, so the line above
    // hides it there too — but a docs page has something better to offer a
    // signed-in reader than a gap. Reveal the chat block that ships beside it.
    var docsSignedIn = document.getElementById("docs-cta-signedin");
    if (docsSignedIn) docsSignedIn.hidden = false;

    // The pricing cards, for someone who already has an account. The plan comes
    // from a second hint the app publishes beside the flag (ghd_plan); an account
    // that has not loaded the app since has none and reads as free. It is only
    // ever a hint: "manage" and "checkout" both land on pages that check the real
    // plan. Labels come localized on data-* attributes — this script is English.
    var proCard = document.querySelector(".pricing-card.featured");
    var proBtn = proCard && proCard.querySelector(".btn-plan");
    if (proBtn) {
      var planMatch = /(?:^|;\s*)ghd_plan=(pro|free)(?:;|$)/.exec(document.cookie);
      var isPro = !!planMatch && planMatch[1] === "pro";
      var freeBtn = document.querySelector(".pricing-card:not(.featured) .btn-plan");
      if (isPro) {
        proCard.classList.add("is-current");
        proCard.setAttribute("data-badge", proCard.getAttribute("data-badge-current") || "Your plan");
        proBtn.textContent = proBtn.getAttribute("data-label-manage") || "Manage subscription";
        proBtn.href = go("/settings");
        if (freeBtn) freeBtn.remove();
      } else {
        proBtn.textContent = proBtn.getAttribute("data-label-upgrade") || "Upgrade to Pro";
        // js/landing.js points the button at whichever period its toggle shows.
        proBtn.setAttribute("data-href-monthly", go("/checkout?billing=monthly"));
        proBtn.setAttribute("data-href-yearly", go("/checkout?billing=yearly"));
        proBtn.href = go("/checkout?billing=monthly");
        if (freeBtn) {
          var current = document.createElement("p");
          current.className = "plan-current";
          current.textContent = freeBtn.getAttribute("data-label-current") || "Your current plan";
          freeBtn.replaceWith(current);
        }
      }
    }

    // Every non-English locale has its own homepage at /<code>/ (nginx.conf routes
    // them), so "the homepage" is per-locale and so is the link back to it — a Dutch
    // reader who lands on "Home" must stay on the Dutch site. The locale list is
    // pinned to the shipped set by tools/gate/i18n_check.py.
    var path = window.location.pathname.replace(/index\.html$/, "");
    var seg = path.split("/")[1] || "";
    var home =
      [
        "nl",
        "de",
        "es",
        "fr",
        "pt",
        "it",
        "hu",
        "ru",
        "pl",
        "id",
        "tr",
        "ca",
        "uk",
        "el",
        "cs",
        "sv",
        "nb",
        "ro",
        "fi",
        "th",
        "vi",
        "bg",
        "da",
        "ja",
        "ko",
        "zh",
      ].indexOf(seg) !== -1
        ? "/" + seg + "/"
        : "/";

    // On sub-pages (not the homepage): replace "Pricing" nav link with "Home".
    // The label is baked in per-locale via data-home-label; English-only pages
    // (privacy, terms, …) carry no attribute and fall back to "Home".
    if (path !== home) {
      var homeLinks = document.querySelectorAll(
        '.site-header nav > a[href*="pricing"], .mobile-nav-links a[href*="pricing"]',
      );
      homeLinks.forEach(function (a) {
        a.textContent = a.getAttribute("data-home-label") || "Home";
        a.href = home;
      });
    }
  } catch (e) {}
})();

;
/* js/html-escape.js */
/**
 * HTML escaping — the single definition site for the whole site.
 *
 * Every page that builds markup by string concatenation loads this first and
 * calls `GHD.escapeHtml`. Do not hand-roll a local escape helper: the
 * `textContent` → `innerHTML` trick that reads as equivalent does NOT escape
 * double quotes, so its output breaks out of a quoted attribute.
 *
 * Extends the `window.GHD` namespace. Load before every other GHD file and
 * before any page script that renders user-supplied values.
 */
(function () {
  window.GHD = window.GHD || {};

  // Escape a value for safe insertion into innerHTML *or* a quoted attribute
  // (quotes are escaped too, so it is safe in both positions). Null and
  // undefined become the empty string; non-strings are coerced.
  GHD.escapeHtml = function (value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  };
})();

;
/* js/api-error.js */
/**
 * Reading an error body our API sent — the single definition site for the
 * whole site.
 *
 * A FastAPI `detail` is a string when *we* raised the HTTPException, and a list
 * of `{loc, msg, …}` objects when Pydantic rejected the request body before our
 * code ran. Callers put the result straight into `textContent`, so a list used
 * to reach the user as the literal "[object Object]" — which is how a signup
 * that left the birth time blank became an unreadable dead end people retried
 * nine times. Every page that shows what an API call said therefore reads it
 * through here rather than touching `body.detail`.
 *
 * Pydantic's own `msg` is written for whoever sent the request (often an LLM),
 * so it is a fallback, not a substitute for a form checking its own fields.
 *
 * Extends the `window.GHD` namespace and depends on nothing.
 */
(function () {
  window.GHD = window.GHD || {};

  /**
   * The sentence in a failed response's parsed JSON body, or "".
   *
   * FastAPI errors carry `detail`, PostgREST errors carry `message`; a caller
   * that wants its own wording writes `GHD.detailText(body) || fallback`.
   *
   * The object shape below (`{code, message}`) has a sentence too, and used to
   * come back empty: a reader who hit the chat wall was shown "Error 429" while
   * the wording naming their reset date sat unread in the body. Branching on the
   * code (`detailCode`) and reading the sentence are two questions, and the
   * answer to the second is the same field it is on every other shape.
   */
  GHD.detailText = function (body) {
    var detail = body && typeof body === "object" ? body.detail : null;
    if (typeof detail === "string" && detail) return detail;
    if (detail && typeof detail === "object" && !Array.isArray(detail)) {
      return typeof detail.message === "string" ? detail.message : "";
    }
    if (Array.isArray(detail)) {
      var joined = detail
        .map(function (entry) {
          return typeof entry === "string" ? entry : (entry && entry.msg) || "";
        })
        .filter(Boolean)
        .join(" ");
      if (joined) return joined;
    }
    var message = body && typeof body === "object" ? body.message : null;
    return typeof message === "string" ? message : "";
  };

  /**
   * The machine-readable `code` in a failed response's `detail`, or "".
   *
   * A few of our errors raise `detail` as an *object* — `{code, message, …}` —
   * so a client can branch on the reason instead of on the sentence: the chat
   * quota wall (`RATE_LIMITED`) and the duplicate-turn refusal
   * (`TURN_IN_FLIGHT`), which the chat swallows without a word. Reading it here
   * keeps the rule that nothing else touches `.detail` at all, since its three
   * shapes are the whole reason that rule exists.
   */
  GHD.detailCode = function (body) {
    var detail = body && typeof body === "object" ? body.detail : null;
    if (!detail || typeof detail !== "object" || Array.isArray(detail)) return "";
    return typeof detail.code === "string" ? detail.code : "";
  };

  /** Another field of an object `detail` (the data export's `export`, `retry_at`), or null. */
  GHD.detailField = function (body, key) {
    var detail = body && typeof body === "object" ? body.detail : null;
    if (!detail || typeof detail !== "object" || Array.isArray(detail)) return null;
    return Object.prototype.hasOwnProperty.call(detail, key) ? detail[key] : null;
  };
})();

;
/* js/i18n-core.js */
/**
 * The parts of runtime i18n that are the same everywhere.
 *
 * Two runtimes sit on top of this — dashboard/js/i18n.js for the signed-in app
 * and site/js/public-i18n.js for the share pages and the OAuth consent screen —
 * and they differ in exactly one thing: how the locale is chosen. The app also
 * weighs the arrival language and the signed-out auth locale, and reconciles
 * against the account's `profiles.ui_language`; the public pages ask the browser
 * and offer a picker. Everything under that decision — which locales exist, how
 * a code is clamped to one, where a bundle lives, what t() does with `{vars}`,
 * how `data-i18n` markup is filled in — was written twice and drifted.
 *
 * So it is written once here, and each runtime keeps only its own chain.
 *
 * Also `GHD.trOr(key, fallback, vars)`: t() with an English literal for when
 * there is no translation. Four files had a copy of it and one had drifted into
 * printing the raw key.
 *
 * Extends the `window.GHD` namespace. Load after the generated bundle loader
 * (which defines `__GHD_LOCALES__` and the message globals) and before the
 * runtime that uses it.
 */
(function () {
  window.GHD = window.GHD || {};

  var DEFAULT = "en";

  /**
   * The shipped UI locales, from the generated bundle (i18n/locales.json).
   *
   * Read on every call rather than captured at load: this file has no way to
   * insist it evaluates after the bundle loader on every page, and a captured
   * `["en"]` would silently clamp every other language away.
   */
  function locales() {
    return window.__GHD_LOCALES__ || [{ code: DEFAULT, native: "English", english: "English" }];
  }

  /** The message globals the per-locale bundle defines, or null. */
  function bundle(loc) {
    return window["__GHD_MSG_" + String(loc).toUpperCase() + "__"] || null;
  }

  /** Fill `{name}` placeholders from `vars`; an unknown one is left as written. */
  function interpolate(text, vars) {
    if (!vars) return text;
    return String(text).replace(/\{(\w+)\}/g, function (whole, name) {
      return Object.prototype.hasOwnProperty.call(vars, name) ? vars[name] : whole;
    });
  }

  /**
   * Map any language code — including the ~50 a chat reply can be written in —
   * to a shipped UI locale, or null.
   */
  function toSupported(code) {
    if (!code) return null;
    var primary = String(code).replace("_", "-").split("-")[0].toLowerCase();
    var supported = locales().map(function (entry) {
      return entry.code;
    });
    return supported.indexOf(primary) !== -1 ? primary : null;
  }

  /**
   * The public tag a locale is written under — `<html lang>` and every Intl
   * call. The code itself unless the registry names one (`zh` → `zh-Hant`: a
   * bare "zh" lets the browser and Intl fall back to Simplified).
   */
  function bcp47(code) {
    var list = locales();
    for (var i = 0; i < list.length; i++) {
      if (list[i].code === code) return list[i].bcp47 || code;
    }
    return code;
  }

  /**
   * The tag an Intl date formatter is handed: a public tag, on the Gregorian
   * calendar. Thai's default is the Buddhist one, which prints 1990 as 2533, and
   * a birth year has to read as the year the reader typed. A tag already on the
   * Gregorian calendar comes back as it was.
   */
  function intlTag(tag) {
    try {
      if (tag && new Intl.DateTimeFormat(tag).resolvedOptions().calendar !== "gregory") return tag + "-u-ca-gregory";
    } catch (e) {
      /* a tag Intl refuses is the caller's to handle, unchanged */
    }
    return tag;
  }

  /**
   * The active message table for a locale.
   *
   * Each bundle is already merged over the English base at build time; the
   * English one is laid down first anyway, to cover a bundle that failed to
   * load or a loader that disagrees with the runtime about the locale.
   */
  function messagesFor(loc) {
    return Object.assign({}, bundle(DEFAULT) || {}, bundle(loc) || {});
  }

  /**
   * A `t(key, vars)` over a table the caller can swap under it.
   *
   * A missing key answers with the key itself: a visible signal, and what lets
   * GHD.trOr tell a miss from a translation. `t.setMessages(next)` replaces the
   * table in place, so the language switch the dashboard does without reloading
   * reaches every reference already handed out — `window.t` included.
   */
  function makeT(messages) {
    var table = messages || {};
    function t(key, vars) {
      var text = Object.prototype.hasOwnProperty.call(table, key) ? table[key] : key;
      return interpolate(text, vars);
    }
    t.setMessages = function (next) {
      table = next || {};
    };
    return t;
  }

  /**
   * Translate static markup: `data-i18n` (innerHTML) and
   * `data-i18n-attr="attr:key;attr2:key2"` (attribute values). Call after
   * rendering, with the runtime's own `t`.
   */
  function applyTranslations(root, t) {
    var scope = root || document;
    scope.querySelectorAll("[data-i18n]").forEach(function (el) {
      el.innerHTML = t(el.getAttribute("data-i18n"));
    });
    scope.querySelectorAll("[data-i18n-attr]").forEach(function (el) {
      el.getAttribute("data-i18n-attr")
        .split(";")
        .forEach(function (pair) {
          var at = pair.indexOf(":");
          if (at === -1) return;
          el.setAttribute(pair.slice(0, at).trim(), t(pair.slice(at + 1).trim()));
        });
    });
  }

  GHD.i18n = {
    DEFAULT: DEFAULT,
    // Marks `ghd_ui_lang` as a deliberate choice rather than a value a localized
    // landing page seeded in passing (site/js/head-init.js leaves ours alone).
    // Both pickers write it, and they mean the same thing by it.
    SEED_APP: "app",
    locales: locales,
    bundle: bundle,
    toSupported: toSupported,
    bcp47: bcp47,
    intlTag: intlTag,
    messagesFor: messagesFor,
    makeT: makeT,
    applyTranslations: applyTranslations,
    interpolate: interpolate,
  };

  /**
   * t(), with the English words to print when there is no translation.
   *
   * Two cases produce the same answer here: a page that carries no i18n runtime
   * at all (the shared conversation view loads cards.js without one), and a key
   * the catalog has not got. t() answers a miss with the key, so that is what
   * this watches for — and the fallback gets the same `{var}` interpolation the
   * translation would have had.
   *
   * A fallback is a safety net, never the copy: the catalog wins wherever it has
   * an entry, so an edit to the English wording belongs in i18n/en/*.json.
   */
  GHD.trOr = function (key, fallback, vars) {
    if (typeof window.t === "function") {
      var translated = window.t(key, vars);
      if (translated !== key) return translated;
    }
    return interpolate(fallback == null ? key : fallback, vars);
  };
})();

;
/* js/signup-seed.js */
/**
 * Signup details shared across origins; keep the stored fields compatible.
 *
 *     { firstName?, birthDate, birthTime, birthPlace, noTime, timezone, savedAt, aiConsent? }
 *
 * `birthTime` may be empty; `noTime` distinguishes an unknown time from noon.
 * `aiConsent` is true only when the iOS app's signup consent box was ticked.
 */
(function () {
  window.GHD = window.GHD || {};

  var KEY = "ghd_signup_birth_data";
  var EMAIL_KEY = "ghd_signup_email";

  /**
   * Email confirmation links may be opened days after signup.
   */
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;

  var DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

  function text(value) {
    return typeof value === "string" ? value : "";
  }

  /**
   * Reject invalid timestamps explicitly; comparisons with NaN would bypass the TTL.
   */
  function read() {
    var stored;
    try {
      stored = JSON.parse(localStorage.getItem(KEY) || "null");
    } catch (e) {
      return null;
    }
    if (!stored || typeof stored !== "object") return null;
    if (typeof stored.savedAt !== "number" || Date.now() - stored.savedAt > TTL_MS) return null;
    if (!DATE_RE.test(text(stored.birthDate))) return null;
    if (!text(stored.birthPlace).trim()) return null;
    return {
      firstName: text(stored.firstName),
      birthDate: stored.birthDate,
      birthTime: text(stored.birthTime),
      birthPlace: stored.birthPlace,
      noTime: stored.noTime === true,
      timezone: text(stored.timezone),
      savedAt: stored.savedAt,
      aiConsent: stored.aiConsent === true,
    };
  }

  /**
   * Store the seed and its email; the email outlives the seed to prefill signup.
   */
  function write(seed, email) {
    var record = {
      firstName: text(seed && seed.firstName),
      birthDate: text(seed && seed.birthDate),
      birthTime: text(seed && seed.birthTime),
      birthPlace: text(seed && seed.birthPlace),
      noTime: !!(seed && seed.noTime),
      timezone: text(seed && seed.timezone),
      savedAt: seed && typeof seed.savedAt === "number" ? seed.savedAt : Date.now(),
      aiConsent: !!(seed && seed.aiConsent === true),
    };
    try {
      localStorage.setItem(KEY, JSON.stringify(record));
      if (email) localStorage.setItem(EMAIL_KEY, email);
    } catch (e) {
      /* private mode or full storage — onboarding falls back to asking again */
    }
    return record;
  }

  /** Both halves: a leftover email prefills the next signup on this device. */
  function clear() {
    try {
      localStorage.removeItem(KEY);
      localStorage.removeItem(EMAIL_KEY);
    } catch (e) {
      /* private mode */
    }
  }

  function readEmail() {
    try {
      return localStorage.getItem(EMAIL_KEY) || "";
    } catch (e) {
      return "";
    }
  }

  function writeEmail(email) {
    try {
      if (email) localStorage.setItem(EMAIL_KEY, email);
    } catch (e) {
      /* the field itself is already corrected */
    }
  }

  GHD.signupSeed = {
    KEY: KEY,
    EMAIL_KEY: EMAIL_KEY,
    TTL_MS: TTL_MS,
    read: read,
    write: write,
    clear: clear,
    readEmail: readEmail,
    writeEmail: writeEmail,
  };
})();

;
/* js/auth-shared.js */
/**
 * The pieces every surface that talks to Supabase Auth needs, wherever it is
 * served from.
 *
 * Three pages ask someone to create an account: the marketing homepage
 * (site/js/landing.js), the app's own /signup (dashboard/js/auth.js) and the
 * OAuth consent screen (dashboard/oauth/consent/consent.js). They live on two
 * origins and share no bundle, so each one used to carry its own copy of the
 * provider marks and its own reading of Supabase's error messages — including
 * two different password regexes, one of which had drifted.
 *
 * Settings joined them without asking for an account: changing an email address
 * is a Supabase Auth call like any other, and it fails with the same codes.
 * That is why `authErrorKey` lives here rather than in dashboard/js/auth.js,
 * where it started — a second table on the settings page is exactly the drift
 * this file exists to prevent.
 *
 * Extends the `window.GHD` namespace. Load before any page script that renders
 * a provider button or reports a Supabase auth failure.
 */
(function () {
  window.GHD = window.GHD || {};

  /**
   * The provider marks, as SVG.
   *
   * Google's is brand-coloured and must stay so; GitHub's inherits
   * `currentColor` so it sits in a button of any theme.
   */
  GHD.authIcons = {
    google: function (size) {
      return (
        '<svg width="' +
        size +
        '" height="' +
        size +
        '" viewBox="0 0 24 24" aria-hidden="true">' +
        '<path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>' +
        '<path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>' +
        '<path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>' +
        '<path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>' +
        "</svg>"
      );
    },

    github: function (size) {
      return (
        '<svg width="' +
        size +
        '" height="' +
        size +
        '" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
        '<path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"/>' +
        "</svg>"
      );
    },

    // Apple's logo in one colour, as its Sign in with Apple guidelines ask of a
    // custom button: it takes the button's text colour.
    apple: function (size) {
      return (
        '<svg width="' +
        size +
        '" height="' +
        size +
        '" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
        '<path d="M16.37 1.43c0 1.14-.49 2.27-1.18 3.08-.74.9-1.99 1.57-2.99 1.57-.12 0-.23-.02-.3-.03-.01-.06-.04-.22-.04-.39 0-1.15.57-2.27 1.21-2.98.8-.94 2.14-1.64 3.25-1.68.03.13.05.28.05.43zm4.56 15.71c-.03.07-.46 1.58-1.52 3.12-.94 1.34-1.94 2.71-3.43 2.71-1.52 0-1.9-.88-3.63-.88-1.7 0-2.3.91-3.67.91-1.38 0-2.33-1.26-3.43-2.8-1.29-1.82-2.32-4.63-2.32-7.28 0-4.28 2.8-6.55 5.55-6.55 1.45 0 2.68.95 3.6.95.87 0 2.22-1.01 3.9-1.01.61 0 2.89.06 4.37 2.19-.13.09-2.38 1.37-2.38 4.19 0 3.26 2.85 4.42 2.96 4.45z"/>' +
        "</svg>"
      );
    },

    envelope: function (size) {
      return (
        '<svg width="' +
        size +
        '" height="' +
        size +
        '" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="2" y="4" width="20" height="16" rx="2"/>' +
        '<path d="m22 7-10 5L2 7"/>' +
        "</svg>"
      );
    },
  };

  /**
   * Whether Sign in with Apple leads the provider buttons: on an iPhone, iPad or
   * Mac, where it is one tap (Face ID, Touch ID) and needs no password. iPadOS
   * Safari reports itself as a Mac, so the Mac test covers it too. Elsewhere
   * Google leads. Both buttons keep the same size either way, as Apple asks.
   */
  GHD.appleFirst = function (ua) {
    var agent = typeof ua === "string" ? ua : (window.navigator && window.navigator.userAgent) || "";
    return /iPhone|iPad|iPod|Macintosh/.test(agent);
  };

  // Supabase's errors arrive as raw English on a page translated into seven
  // languages, so they are mapped to copy of ours rather than printed. Keyed on
  // `error.code` (supabase-js 2.x) and never on the message text, which is the
  // half that changes between releases. One table for every screen: sign-in, the
  // OAuth start, the reset mail, the new password and the settings page's email
  // row all answer out of it.
  var AUTH_ERROR_KEYS = {
    invalid_credentials: "auth.error.invalid_credentials",
    email_not_confirmed: "auth.error.email_not_confirmed",
    over_request_rate_limit: "auth.error.too_many_attempts",
    over_email_send_rate_limit: "auth.error.too_many_attempts",
    validation_failed: "auth.error.invalid_email",
    email_address_invalid: "auth.error.invalid_email",
    // Someone else already signs in with the address, so it cannot be moved to.
    email_exists: "auth.error.account_exists",
    weak_password: "auth.error.password_min",
    same_password: "auth.error.same_password",
    // The recovery link that opened /set-password has stopped being a session.
    session_expired: "auth.error.link_expired",
    session_not_found: "auth.error.link_expired",
    otp_expired: "auth.error.link_expired",
  };

  /**
   * The catalog key for a Supabase auth error, or "" for a code we don't know.
   *
   * The raw message never reaches the page — it goes to the console instead,
   * which is where a new code gets read off a report and added above. Callers
   * supply their own sentence for the "" case: the screen's own "could not start
   * sign-in", or the generic one.
   */
  GHD.authErrorKey = function (error) {
    var code = error && error.code;
    var known = code ? AUTH_ERROR_KEYS[code] : "";
    if (!known) console.warn("[auth]", code || "no error code", (error && error.message) || error);
    return known || "";
  };

  /**
   * What to tell someone whose sign-up Supabase refused.
   *
   * Supabase answers in English whatever language the page is in, so the two
   * failures worth recognising are answered with copy of ours. Everything else
   * falls through to the raw text: an untranslated explanation still beats no
   * explanation.
   *
   * `strings` carries the three already-translated sentences, because the three
   * callers resolve their copy differently — `t()` on the app, build-time
   * data-msg-* attributes on the marketing pages, `tr()` with an inline English
   * fallback on the consent screen.
   *
   * Returns `{ message, existing }`; `existing` is what makes the caller offer a
   * way to sign in instead.
   */
  GHD.friendlyAuthError = function (err, strings) {
    var s = strings || {};
    var raw = (err && err.message) || s.generic || "Something went wrong. Please try again.";
    // "User already registered" is what Supabase says for a taken address.
    if (/already\s+(registered|exists)/i.test(raw) || (/email/i.test(raw) && /(registered|exists|taken)/i.test(raw))) {
      return { message: s.accountExists || raw, existing: true };
    }
    if (/password/i.test(raw) && /(short|weak|character)/i.test(raw)) {
      return { message: s.passwordTooShort || raw, existing: false, passwordTooShort: true };
    }
    return { message: raw, existing: false };
  };

  /**
   * A signup form's one error line, which moves under the field a check names.
   *
   * A sentence at the foot of a long form is out of view of the field it is
   * about, and on a phone out of view altogether; a short password once read as
   * a button that did nothing. So `show(text, { fields })` puts the line inside
   * the first field's box (`boxSelector`), marks every named field
   * `aria-invalid` (each page colours that red), scrolls there and focuses it.
   * A message that names no field — the server, the network — stays where the
   * page put it, by the buttons. Editing a marked field clears it.
   *
   * `opts.focus` replaces focusing the first field (a date in three parts
   * focuses its first empty part); `opts.link` is an element appended after the
   * sentence. `onClear` runs whenever the line is taken down.
   */
  GHD.fieldStatus = function (errorEl, boxSelector, onClear) {
    var home = errorEl && errorEl.parentNode;
    var homeNext = errorEl && errorEl.nextSibling;
    var marked = [];

    function clear() {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = "";
      errorEl.classList.remove("is-field");
      if (home && errorEl.parentNode !== home) {
        home.insertBefore(errorEl, homeNext && homeNext.parentNode === home ? homeNext : null);
      }
      marked.forEach(function (el) {
        el.removeAttribute("aria-invalid");
        el.removeEventListener("input", clear);
        el.removeEventListener("change", clear);
      });
      marked = [];
      if (onClear) onClear();
    }

    function show(text, opts) {
      opts = opts || {};
      if (!errorEl) return;
      clear();
      var fields = (opts.fields || []).filter(Boolean);
      var box = fields.length && fields[0].closest ? fields[0].closest(boxSelector) : null;
      if (box) {
        box.appendChild(errorEl);
        errorEl.classList.add("is-field");
      }
      fields.forEach(function (el) {
        el.setAttribute("aria-invalid", "true");
        el.addEventListener("input", clear);
        el.addEventListener("change", clear);
      });
      marked = fields;
      errorEl.textContent = text;
      if (opts.link) {
        errorEl.appendChild(document.createTextNode(" "));
        errorEl.appendChild(opts.link);
      }
      errorEl.hidden = false;
      var target = box || errorEl;
      var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (target.scrollIntoView) {
        target.scrollIntoView({ block: box ? "center" : "nearest", behavior: still ? "auto" : "smooth" });
      }
      if (fields.length) {
        if (opts.focus) opts.focus();
        else fields[0].focus({ preventScroll: !!box });
      }
    }

    return { show: show, clear: clear };
  };
})();

;
/* dashboard/js/place-autocomplete.js */
/**
 * Place autocomplete — shared dropdown component for location inputs.
 *
 *   bind(input, {onSelect, onNarrow, fetchFn, strings})   the dropdown alone
 *   bindPublic(input, {apiBase, …})   signed out: public geocoder + zone hint
 *   bindTzHint(input, hint, icon)     signed in: the same, through Api
 *
 * A country spanning several clocks (`country_clock_hours`, no `timezone`) is
 * shown as a prompt to narrow, never a pick: this field must never confirm a
 * clock the save will refuse. `fetchFn` rejects with an Error carrying the HTTP
 * `status` on failure, because a failed search is not an empty one. The
 * geocoder is capped at one request a second app-wide, so keystrokes are
 * answered locally where possible (`narrowLocally`). The resolved zone is
 * always marked as `input._timezone`.
 *
 * Loads after /js/html-escape.js; renders suggestions via GHD.escapeHtml.
 */

// The anonymous per-device id the public geocoder's rate limit counts against.
// Same key as GHD.KEYS.deviceId — spelled out because the marketing pages that
// bind a place field load no dashboard bundle to read it off.
const _PA_DEVICE_KEY = "ghd_device_id";

// How long one search may hold a field's single slot (ms): above the backend's
// 6 s wait for a geocoder slot plus the lookup itself.
const _PA_STALL_MS = 12000;

/* The four lines the dropdown can show, read fresh on every render (the
   settings picker can swap the catalog under a bound field). GHD.trOr, not t(),
   because the marketing form and consent screen may have no i18n runtime. */
function _defaultStrings() {
  return {
    searching: GHD.trOr("settings.tz.searching", "Searching…"),
    noResults: GHD.trOr("settings.tz.no_locations", "No locations found"),
    rateLimited: GHD.trOr("settings.tz.rate_limited", "Too many searches in a row — wait a moment, then keep typing."),
    busy: GHD.trOr("settings.tz.search_busy", "The place search is busy — wait a moment, then keep typing."),
    error: GHD.trOr("settings.tz.search_failed", "Couldn't search just now. Check your connection and try again."),
    countryNarrow: GHD.trOr(
      "settings.tz.country_narrow",
      "Spans about {hours} hours of clock time — add a city or region",
    ),
  };
}

/* Fold a query or a place name down to what matching should compare. */
function _paFold(text) {
  return String(text || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/\u03c2/g, "\u03c3") // Greek final sigma: "\u0391\u03b8\u03b7\u03bd\u03b1\u03c2" and "\u0391\u03b8\u03b7\u03bd\u03b1\u03c3" are one word
    .replace(/\u0111/g, "d"); // Vietnamese đ, which NFD keeps: "Da Nang" is "\u0110\u00e0 N\u1eb5ng"
}

/* The words of a folded name, in any script; a Thai word keeps its marks. */
var _PA_WORD_BREAK = /[^\p{L}\p{M}\p{N}]+/u;

/* Does this suggestion still match the query, judged locally? Every query
   token must start some token of the display name. Strict on purpose: a miss
   goes to the server, the safe direction. */
function _paStillMatches(displayName, query) {
  var haystack = _paFold(displayName).split(_PA_WORD_BREAK).filter(Boolean);
  var needles = _paFold(query).split(_PA_WORD_BREAK).filter(Boolean);
  return needles.every(function (needle) {
    return haystack.some(function (word) {
      return word.indexOf(needle) === 0;
    });
  });
}

/* Is this suggestion a prompt to narrow the search rather than a place to pick?
   Reads the `country_clock_hours` flag rather than the missing zone, so a row
   with neither (a bug) is never treated as pickable with an empty clock. */
function _paIsNarrowRow(place) {
  return !!place && place.country_clock_hours != null;
}

const PlaceAutocomplete = {
  bind(input, { onSelect, onNarrow, fetchFn, strings = _defaultStrings }) {
    if (!input) return;

    let timer = null;
    let seq = 0;
    // One search at a time per field. The server queues each lookup for the
    // geocoder's one-a-second slot, so a steady typist's superseded queries
    // would sit in that queue ahead of the one they finish on, and it is the
    // last that gets refused. A newer query waits here instead (`queued`).
    let inFlight = false;
    let queued = false;
    let activeIdx = -1;
    let items = [];
    let dropdown = null;
    // The last query the SERVER answered, and what it answered with. Together
    // they are what lets the next few keystrokes be answered without asking
    // anyone: see `narrowLocally` below.
    let lastQuery = "";
    let lastResults = [];

    // Create dropdown container
    const wrap = input.parentElement;
    wrap.style.position = "relative";

    /* A phone's keyboard leaves room for one or two rows under a field in the
       middle of the form: lift the field to the top of what is visible when
       the list opens, and keep the list inside what is left. A short form's
       scroller cannot scroll that far, so it gets room at its foot while the
       list is open. */
    var phone = null;

    function isPhone() {
      return !!window.matchMedia && window.matchMedia("(pointer: coarse) and (max-width: 768px)").matches;
    }

    function viewportHeight() {
      var vv = window.visualViewport;
      return vv ? vv.height : window.innerHeight;
    }

    function scrollerOf(el) {
      for (var node = el.parentElement; node && node !== document.body; node = node.parentElement) {
        if (/(auto|scroll)/.test(getComputedStyle(node).overflowY)) return node;
      }
      return document.scrollingElement || document.documentElement;
    }

    function fitHeight() {
      if (!dropdown || !phone) return;
      var vv = window.visualViewport;
      var bottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
      var room = bottom - wrap.getBoundingClientRect().bottom - 12;
      dropdown.style.maxHeight = Math.max(120, Math.round(room)) + "px";
    }

    function closeOnPhone() {
      if (!phone) return;
      (window.visualViewport || window).removeEventListener("resize", phone.onResize);
      phone.scrollTarget.removeEventListener("scroll", fitHeight);
      phone.scroller.style.paddingBottom = phone.padding;
      phone = null;
    }

    function destroyDropdown() {
      closeOnPhone();
      if (dropdown) {
        dropdown.remove();
        dropdown = null;
      }
      items = [];
      activeIdx = -1;
    }

    /* Closed until the reader types again: no answer still on its way reopens it. */
    function dismiss() {
      clearTimeout(timer);
      seq++;
      queued = false;
      destroyDropdown();
    }

    /* The keyboard closing (Android's Back) leaves the field focused, and the
       list would stay over the controls beneath it, taking the next tap. */
    function onViewportResize() {
      var height = viewportHeight();
      if (height > phone.shortest + 120) dismiss();
      else {
        phone.shortest = Math.min(phone.shortest, height);
        fitHeight();
      }
    }

    function openOnPhone() {
      var scroller = scrollerOf(wrap);
      phone = {
        scroller: scroller,
        // A smooth-scrolling page (www) is still moving after scrollIntoView.
        scrollTarget: scroller === document.documentElement ? window : scroller,
        padding: scroller.style.paddingBottom,
        shortest: viewportHeight(),
        onResize: onViewportResize,
      };
      // Clear of a sticky page header (the landing page has one).
      input.style.scrollMarginTop = "4rem";
      scroller.style.paddingBottom = "calc(" + (getComputedStyle(scroller).paddingBottom || "0px") + " + 100vh)";
      input.scrollIntoView({ block: "start" });
      (window.visualViewport || window).addEventListener("resize", phone.onResize);
      phone.scrollTarget.addEventListener("scroll", fitHeight);
    }

    function createDropdown() {
      var fresh = !dropdown;
      if (fresh) {
        dropdown = document.createElement("div");
        dropdown.className = "place-ac-dropdown";
        dropdown.setAttribute("role", "listbox");
        wrap.appendChild(dropdown);
        if (isPhone()) openOnPhone();
      }
      fitHeight();
      return dropdown;
    }

    /* Keep the country, ask for the part of it — without losing what was typed.
       The field becomes ", United States" with the caret at the front. No `input`
       event is dispatched (a search would only return the country again);
       `onNarrow` tells the tracking surfaces instead. */
    function narrow(idx) {
      var place = items[idx];
      input.value = ", " + place.display_name;
      input.setSelectionRange(0, 0);
      destroyDropdown();
      input.focus();
      if (onNarrow) onNarrow(place);
    }

    function select(idx) {
      if (idx < 0 || idx >= items.length) return;
      var place = items[idx];
      input.value = place.display_name;
      // Assigning .value leaves the caret wherever the browser's own default
      // puts it, and that default is not the same everywhere. On the device
      // behind the Argentina signup of 2026-08-23 it landed at the front, so
      // every further keystroke was typed into the head of the field and the
      // queries that reached the geocoder read "GENRIo Negro, Argentina".
      // Placing it explicitly is what stops the field depending on that default
      // at all — desktop Chrome, where it already lands at the end, is
      // unaffected. Both ways in (mousedown and Enter) come through here.
      var end = input.value.length;
      input.setSelectionRange(end, end);
      destroyDropdown();
      if (onSelect) onSelect(place);
    }

    /* Both ways of taking a row — mousedown and Enter — come through here.
       A country with no single clock is never taken, only narrowed: the save
       would refuse it. */
    function choose(idx) {
      if (idx < 0 || idx >= items.length) return;
      if (_paIsNarrowRow(items[idx])) narrow(idx);
      else select(idx);
    }

    function renderItems(suggestions) {
      const dd = createDropdown();
      items = suggestions;
      activeIdx = -1;

      if (!suggestions.length) {
        dd.innerHTML = '<div class="place-ac-empty">' + GHD.escapeHtml(strings().noResults) + "</div>";
        return;
      }

      var say = strings();
      dd.innerHTML = suggestions
        .map(function (s, i) {
          if (_paIsNarrowRow(s)) {
            return (
              '<div class="place-ac-item place-ac-narrow" role="option" data-idx="' +
              i +
              '"><span class="place-ac-name">' +
              GHD.escapeHtml(s.display_name) +
              "</span>" +
              '<span class="place-ac-narrow-hint">' +
              GHD.escapeHtml(String(say.countryNarrow).replace("{hours}", String(s.country_clock_hours))) +
              "</span>" +
              "</div>"
            );
          }
          return (
            '<div class="place-ac-item" role="option" data-idx="' +
            i +
            '"><span class="place-ac-name">' +
            GHD.escapeHtml(s.display_name) +
            "</span>" +
            '<span class="place-ac-tz">' +
            GHD.escapeHtml(s.timezone) +
            "</span>" +
            "</div>"
          );
        })
        .join("");

      // Click handlers
      dd.querySelectorAll(".place-ac-item").forEach(function (el) {
        el.addEventListener("mousedown", function (e) {
          e.preventDefault(); // prevent blur
          choose(parseInt(el.dataset.idx, 10));
        });
      });
    }

    function renderLoading() {
      var dd = createDropdown();
      dd.innerHTML = '<div class="place-ac-empty">' + GHD.escapeHtml(strings().searching) + "</div>";
    }

    /* A search that failed, said as such, never as "no such place". 429 gets its
       own line (a still-typing person hits it, and waiting is the advice);
       everything else shares the generic one. */
    function renderError(status) {
      var dd = createDropdown();
      items = [];
      activeIdx = -1;
      var say = strings();
      var text = say.error;
      if (status === 429) text = say.rateLimited;
      // 503 is the geocoder saying "not now", which the backend used to answer
      // as an empty 200 — indistinguishable from "your city is not a place", and
      // read as exactly that by whoever was typing. It is its own line because
      // the advice differs from both neighbours: nothing is wrong with their
      // connection and nothing is wrong with the name, so the thing to do is
      // keep going.
      else if (status === 503) text = say.busy || say.error;
      dd.innerHTML = '<div class="place-ac-empty">' + GHD.escapeHtml(text) + "</div>";
    }

    /* Answer this keystroke from the last server answer, if it honestly can.
       Only when the query EXTENDS the last one, so the result is a subset of a
       real server answer; when narrowing empties, return null and ask the server,
       so a stale list never outlives its query. */
    function narrowLocally(q) {
      if (!lastQuery || !lastResults.length) return null;
      var folded = _paFold(q);
      if (folded.indexOf(_paFold(lastQuery)) !== 0) return null;
      var narrowed = lastResults.filter(function (place) {
        return _paStillMatches(place.display_name, q);
      });
      return narrowed.length ? narrowed : null;
    }

    function setActive(idx) {
      if (!dropdown) return;
      var els = dropdown.querySelectorAll(".place-ac-item");
      els.forEach(function (el) {
        el.classList.remove("active");
      });
      if (idx >= 0 && idx < els.length) {
        els[idx].classList.add("active");
        els[idx].scrollIntoView({ block: "nearest" });
      }
      activeIdx = idx;
    }

    function search(q) {
      if (inFlight) {
        // The answer in flight is for an older query: never shown, but still
        // kept as the narrowing base, which may answer this one on arrival.
        seq++;
        queued = true;
        renderLoading();
        return;
      }
      inFlight = true;
      var mySeq = ++seq;
      var released = false;
      function release() {
        if (released) return;
        released = true;
        inFlight = false;
        if (!queued) return;
        // Run the query that waited, as the field reads now. This replaces the
        // search the last keystroke's debounce would start.
        queued = false;
        clearTimeout(timer);
        var next = input.value.trim();
        if (next.length < 4) return;
        var local = narrowLocally(next);
        if (local) {
          seq++;
          renderItems(local);
        } else {
          search(next);
        }
      }
      // A request that never settles must not hold the field forever. Past the
      // server's own wait for a geocoder slot, the next query goes regardless.
      var stall = setTimeout(release, _PA_STALL_MS);
      renderLoading();
      fetchFn(q)
        .then(function (results) {
          // A straggler past the stall bound may be older than the base.
          if (released && mySeq !== seq) return;
          lastQuery = q;
          lastResults = results || [];
          if (mySeq === seq) renderItems(lastResults);
        })
        .catch(function (err) {
          if (mySeq !== seq) return;
          // A failed search teaches us nothing about this query, so the
          // narrowing base is left alone rather than emptied: if a previous
          // query's list is still a fair answer, the next keystroke can still
          // use it instead of queueing behind the same busy geocoder.
          renderError(err && err.status);
        })
        .then(function () {
          clearTimeout(stall);
          release();
        });
    }

    // Debounced search
    input.addEventListener("input", function () {
      clearTimeout(timer);
      var q = input.value.trim();
      // Only search once the query is specific enough to be useful: short
      // fragments ("Ci", "New") match thousands of places and just add load on
      // the geocoder. 4+ chars keeps the typeahead snappy and the results relevant.
      if (q.length < 4) {
        seq++;
        queued = false;
        destroyDropdown();
        return;
      }

      // Answered from what is already on screen: no debounce, no request, no
      // queue to be refused by. This is where the load actually goes away —
      // typing out a city name used to cost one lookup per pause, and now costs
      // one for the word.
      var local = narrowLocally(q);
      if (local) {
        // Nothing in flight or queued may arrive later and overwrite this.
        seq++;
        queued = false;
        renderItems(local);
        return;
      }

      timer = setTimeout(function () {
        search(q);
      }, 400);
    });

    // Keyboard navigation
    input.addEventListener("keydown", function (e) {
      if (!dropdown || !items.length) return;
      // A desktop IME takes Enter to commit the candidate it is offering, and a
      // place name is exactly what someone types through one. Without this, that
      // keystroke picks whichever row happens to be highlighted (js/platform.js).
      // Optional call: the marketing landing pages and the MCP consent page load
      // this file without platform.js, and there the key keeps its old behaviour.
      if (GHD.isComposingKey?.(e)) return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setActive(Math.min(activeIdx + 1, items.length - 1));
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setActive(Math.max(activeIdx - 1, 0));
      } else if (e.key === "Enter" && activeIdx >= 0) {
        e.preventDefault();
        choose(activeIdx);
      } else if (e.key === "Escape") {
        destroyDropdown();
      }
    });

    // Close on blur
    input.addEventListener("blur", function () {
      // Small delay so mousedown on item fires first
      setTimeout(dismiss, 150);
    });
  },

  /* The id the public geocoder rate-limits per device. */
  deviceId() {
    let id = null;
    try {
      id = localStorage.getItem(_PA_DEVICE_KEY);
    } catch (e) {
      /* blocked storage */
    }
    if (!id) {
      id =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : Date.now().toString(36) + Math.random().toString(36).slice(2);
      try {
        localStorage.setItem(_PA_DEVICE_KEY, id);
      } catch (e) {
        /* the next call mints another — autocomplete still works */
      }
    }
    return id;
  },

  /* The signed-out geocoder. */
  /* The zone a save would get for `place`, through the server's own fence: a
     name several places share, or a country of several clocks, is refused (409)
     with the message that says what to type instead. */
  publicResolve(apiBase, place) {
    return fetch(`${apiBase}/v1/public/resolve-location?place=${encodeURIComponent(place)}`, {
      headers: { "X-Device-Id": this.deviceId() },
    }).then((r) =>
      r.json().then(
        (body) => ({ status: r.status, body }),
        () => ({ status: r.status, body: {} }),
      ),
    );
  },

  publicSearch(apiBase, query) {
    return fetch(`${apiBase}/v1/public/search-locations?q=${encodeURIComponent(query)}`, {
      headers: { "X-Device-Id": this.deviceId() },
    }).then((r) => {
      if (!r.ok) {
        const err = new Error(`search-locations ${r.status}`);
        err.status = r.status;
        throw err;
      }
      return r.json();
    });
  },

  /* The "Timezone: …" line under a birth-place field, and the checkmark beside it.
     The zone is marked on `input._timezone` for every surface's save. `hintClass`
     lets the consent screen style its own hints; `format` supplies the sentence
     where `t()` is unavailable. */
  timezoneHint(input, { hint, icon, hintClass = "field-tz-hint", format } = {}) {
    const say = format || ((tz) => t("common.timezone", { timezone: tz }));

    const setIcon = (state) => {
      if (!icon) return;
      icon.className = "field-place-icon";
      if (state === "ok") {
        icon.textContent = "✓";
        icon.classList.add("icon-ok", "visible");
      } else if (state === "err") {
        icon.textContent = "✗";
        icon.classList.add("icon-err", "visible");
      }
    };

    const write = (text, state) => {
      if (!hint) return;
      hint.textContent = text;
      hint.className = state ? `${hintClass} ${state}` : hintClass;
    };

    const api = {
      get timezone() {
        return (input && input._timezone) || "";
      },
      set(tz) {
        if (input) input._timezone = tz || "";
        write(tz ? say(tz) : "", tz ? "tz-ok" : "");
        setIcon(tz ? "ok" : null);
      },
      clear() {
        api.set("");
      },
      /* While a typed place is being looked up: no zone yet, and none implied. */
      checking(text) {
        if (input) input._timezone = "";
        write(text || "", text ? "tz-loading" : "");
        setIcon(null);
      },
      /* Settle the place in the field before a save: "confirmed" (a zone was
         already showing), "resolved" (one just appeared), "refused" (the reason
         is under the field), "stale" (the field changed while it looked) or
         "unchecked" (nothing to say; the save decides).
         Replaced by `_confirmTyped` where the field confirms typed places. */
      confirm() {
        return Promise.resolve(api.timezone ? "confirmed" : "unchecked");
      },
      /* A place the server will refuse, said under the field before the save does. */
      refuse(text) {
        if (input) input._timezone = "";
        write(text, "tz-err");
        setIcon("err");
      },
      /* Resolve a place already in the field — an edit prefill, or a restored
         signup seed that carried no zone. The only path that can report a
         failure. Needs the authenticated Api. */
      resolve(value) {
        const query = String(value || "").trim();
        if (!query) return Promise.resolve("");
        if (input) input._timezone = "";
        write(t("settings.tz.checking"), "tz-loading");
        setIcon(null);
        // Another place typed while this looked is not this place's zone.
        const stale = () => input && input.value.trim() !== query;
        return Api.resolveLocation(query)
          .then((data) => {
            if (stale()) return "";
            api.set(data.timezone);
            return data.timezone;
          })
          .catch((err) => {
            if (stale()) return "";
            // Say what the server said. It distinguishes "no such place" (404)
            // from "that name is several places in different time zones" (409),
            // and the 409 names them — which is the whole answer to "so what do
            // I type instead?". Collapsing both into "Location not found" told
            // the one user whose chart was actually wrong that their home town
            // does not exist. Api._request already carries the server's `detail`
            // here as the Error message. www and the consent page load this
            // without ui-toast.js, hence the guard.
            const text = GHD.errorText ? GHD.errorText(err, "settings.tz.not_found") : err?.message;
            write(text || t("settings.tz.not_found"), "tz-err");
            setIcon("err");
            return "";
          });
      },
    };
    return api;
  },

  /* A birth-place field on a page with no session: the dropdown, the public
     geocoder behind it, and the timezone hint. Returns the hint handle.
     `strings` is for the marketing form, whose copy comes from its data-msg-*
     attributes (one landing.js for every locale). `confirmOnBlur`: a place typed
     and left without a pick is resolved as the save would (`_confirmTyped`). */
  bindPublic(input, { apiBase, hint, icon, hintClass, format, onSelect, onNarrow, strings, confirmOnBlur } = {}) {
    if (!input) return null;
    const tz = this.timezoneHint(input, { hint, icon, hintClass, format });

    this.bind(input, {
      onSelect(place) {
        tz.set(place.timezone);
        if (onSelect) onSelect(place);
      },
      // Arming the field for a narrower search is the opposite of confirming a
      // zone, and the line under the field has to say so: the country the user
      // just declined to keep may have left a zone from an earlier pick there.
      onNarrow(place) {
        tz.clear();
        if (onNarrow) onNarrow(place);
      },
      fetchFn: (q) => this.publicSearch(apiBase, q),
      ...(strings ? { strings } : {}),
    });

    // Editing after picking invalidates the zone that was picked, and a refusal
    // spoke of the text that was there.
    input.addEventListener("input", () => {
      if (tz.timezone || (hint && hint.textContent)) tz.clear();
    });

    if (confirmOnBlur) {
      this._confirmTyped(input, tz, {
        resolve: (typed) =>
          this.publicResolve(apiBase, typed).then(({ status, body }) => {
            if (status === 200 && body.timezone) return { timezone: body.timezone };
            if (status === 409) return { refusal: GHD.detailText ? GHD.detailText(body) : "" };
            return {};
          }),
        onResolved: onSelect,
      });
    }

    return tz;
  },

  /* The same field on a page that has a session: the dropdown through the
     authenticated Api, the timezone hint, and a typed place confirmed as
     bindPublic's `confirmOnBlur` does. Returns the hint handle. */
  bindTzHint(input, hint, icon) {
    if (!input || !hint) return null;
    const tz = this.timezoneHint(input, { hint, icon });

    this.bind(input, {
      onSelect(place) {
        tz.set(place.timezone);
      },
      onNarrow() {
        tz.clear();
      },
      fetchFn(q) {
        return Api.searchLocations(q);
      },
    });

    // Clear the hint when the user edits after selecting.
    input.addEventListener("input", () => {
      tz.clear();
    });

    this._confirmTyped(input, tz, {
      resolve: (typed) =>
        Api.resolveLocation(typed).then(
          (data) => ({ timezone: data && data.timezone }),
          (err) => {
            // A verdict on the name: 409 names the rival places, and the 404's
            // own detail is English. Anything else is a failed lookup, which
            // the save repeats.
            if (err && err.status === 409) return { refusal: GHD.errorText ? GHD.errorText(err) : err.message };
            if (err && err.status === 404) return { refusal: t("settings.tz.not_found") };
            return {};
          },
        ),
      checking: () => t("settings.tz.checking"),
    });

    if (input.value.trim()) tz.resolve(input.value);
    return tz;
  },

  /* A place typed and left without a pick, resolved as the save would resolve
     it — on blur, and again through `tz.confirm()` before a save, sharing one
     lookup. A zone counts as picked (`onResolved`, with the typed text as the
     place); a refusal is shown under the field. `resolve(typed)` answers
     `{timezone}`, `{refusal}` or `{}` (no verdict). */
  _confirmTyped(input, tz, { resolve, onResolved, checking }) {
    let pending = null;
    // A number or a stray key is not a place; its "first match" is a random one.
    const lookable = (typed) => typed.length >= 3 && /\p{L}{2}/u.test(typed);

    const run = (typed) => {
      if (pending && pending.typed === typed) return pending.promise;
      if (checking) tz.checking(checking());
      const promise = Promise.resolve()
        .then(() => resolve(typed))
        .catch(() => ({}))
        .then((verdict) => {
          if (pending && pending.promise === promise) pending = null;
          if (input.value.trim() !== typed) return "stale";
          // A pick that landed while this was in flight wins.
          if (tz.timezone) return "confirmed";
          if (verdict && verdict.timezone) {
            tz.set(verdict.timezone);
            if (onResolved) onResolved({ display_name: typed, timezone: verdict.timezone });
            return "resolved";
          }
          if (verdict && verdict.refusal) {
            tz.refuse(verdict.refusal);
            return "refused";
          }
          if (checking) tz.clear();
          return "unchecked";
        });
      pending = { typed, promise };
      return promise;
    };

    input.addEventListener("blur", () => {
      const typed = input.value.trim();
      if (tz.timezone || !lookable(typed)) return;
      // After the dropdown's own blur delay, so a pick in flight lands first.
      setTimeout(() => {
        if (tz.timezone || input.value.trim() !== typed) return;
        run(typed);
      }, 200);
    });

    tz.confirm = () => {
      const typed = input.value.trim();
      if (tz.timezone) return Promise.resolve("confirmed");
      if (!lookable(typed)) return Promise.resolve("unchecked");
      return run(typed);
    };
  },
};

// The export convention — see the boot list in js/app.js.
window.PlaceAutocomplete = PlaceAutocomplete;

;
/* dashboard/js/birth-format.js */
/* A birth date and a birth time, written the way their reader writes them. */
(function () {
  window.GHD = window.GHD || {};

  // The locale a *birth date* is written in: the reader's, except that bare "en"
  // is widened to en-GB. Birth dates read day-first everywhere in the product,
  // and plain "en" is the one locale Intl would flip to month-first — which would
  // date the same birth two ways two screens apart. Four places needed this rule
  // (the chart page, the share page, the sweep card, the PDF) and three had
  // written it out; the fourth had hardcoded en-GB and so never localized at all.
  //
  // The tag is the registry's public one (GHD.i18n.bcp47), not the bare code:
  // Intl reads plain "zh" as Simplified and prints 周三 to a Traditional reader.
  GHD.birthDateLocale = function () {
    var tag = GHD.intlLocale();
    return tag === "en" ? "en-GB" : tag;
  };

  // The locale every other Intl call in the app formats in: the reader's UI
  // language as its public tag. A call that passes `undefined` gets the
  // browser's language instead, which dates a Dutch reader's renewal in English
  // on an English browser.
  GHD.intlLocale = function () {
    var locale = (window.GHD_I18N && window.GHD_I18N.locale) || "en";
    if (!GHD.i18n || typeof GHD.i18n.bcp47 !== "function") return locale;
    // On the Gregorian calendar: Thai dates default to the Buddhist era.
    return typeof GHD.i18n.intlTag === "function" ? GHD.i18n.intlTag(GHD.i18n.bcp47(locale)) : GHD.i18n.bcp47(locale);
  };

  // Users confuse 24-hour times (is 00:00 midnight or noon? is 12:00?) and
  // mix up AM and PM, so a birth time is never printed as bare digits a reader
  // could misread.
  //
  // Every word here comes from the catalog, and which form a locale wants is
  // itself a catalog answer: `chart.clock_hint_style` is a setting, not a
  // sentence. "12h" leads with the clock its readers use, names the part of the
  // day ("10:30 AM (morning)"), and adds the 24-hour clock wherever its digits
  // differ ("10:30 PM (evening, 22:30)"); "12h-part" is the same for a locale
  // whose AM/PM word is the part of the day (zh). Anything else means the locale reads
  // 24-hour clocks natively; it gets the digits, with only midnight and noon —
  // the two clocks people misread in any language — spelled out.
  //
  // Keys live in the `chart` namespace because that is the one both bundle
  // families carry — this file is loaded by the public share pages too.
  function dayPart(hours, minutes, say) {
    if (hours === 0 && minutes === 0) return say("chart.clock_midnight", "midnight");
    if (hours === 12 && minutes === 0) return say("chart.clock_noon", "noon");
    if (hours < 5) return say("chart.clock_part_night", "night");
    if (hours < 12) return say("chart.clock_part_morning", "morning");
    if (hours < 18) return say("chart.clock_part_afternoon", "afternoon");
    return say("chart.clock_part_evening", "evening");
  }

  // What a birth time *means*, as the word every surface renders verbatim:
  // "exact" | "roughly" | "unknown", or "" when there is no birth datetime to
  // judge. The person's own answer decides it and nothing else: a row that
  // carries no confidence was saved before anyone was asked, and is believed as
  // given. Migration 131 makes the column NOT NULL once the release that always
  // stores one is live, so that case stops existing rather than being guessed at.
  //
  // There used to be a fourth word — "unconfirmed", for a row nobody was ever
  // asked about whose clock read 12:00 or 00:00 — inferred here at render time.
  // Guessing intent from a clock cannot be done: a noon somebody was born at
  // looks exactly like a noon the form filled in. That question is now answered
  // in the row itself, where those people say "unknown" like anyone else whose
  // hour we do not have, and this function reads the answer instead of guessing
  // at it.
  //
  // Mirrors backend hd_operations.birth_time_verdict — keep the two in sync
  // (parity-tested): a live turn gets the backend's word over SSE, a reloaded
  // transcript rebuilds it here from the stored payload's confidence, and the
  // two must never disagree about the same person.
  //
  // It lives in THIS module rather than in cards.js because the roster needs it
  // too and does not load the chat's card renderer.
  var UNCERTAIN_CONFIDENCES = ["roughly", "unknown"];
  GHD.birthTimeVerdict = function (confidence, birthDatetime) {
    if (!birthDatetime) return "";
    // Anything that is not one of the two provisional answers is believed as
    // given — including the missing answer, and including a value from some
    // future vocabulary this build has never heard of, which the backend also
    // reads as exact rather than echoing back as a word no surface can render.
    return UNCERTAIN_CONFIDENCES.indexOf(confidence) === -1 ? "exact" : confidence;
  };

  // ── What a surface may say off the stored chart summary ───────────────────
  //
  // `hd_type`, `profile` and `authority` sit on the person row so a list costs
  // no chart calculation — and they are the chart at ONE minute, which for a
  // birth time nobody vouches for is a minute we do not believe. The backend
  // grades the three against the person's whole birth-time window and stores
  // the verdict beside them (`derived_tiers`, migration 137 — the same block a
  // chart payload carries as `birth_time.tiers`, so one birth day cannot be
  // described two ways).
  //
  // Two bars, because two kinds of surface read them:
  //
  //   * a bare line — the roster row, the two people pickers, a mention chip —
  //     has nowhere to hang a qualification, so it prints only what the sweep
  //     calls 'certain'. That is exactly what the person page one tap away
  //     prints, which is the whole point: the roster used to say "1/3 ·
  //     Emotional" over a page that answered "needs an exact birth time";
  //   * a card that draws the window can also show a 'likely' value, greyed
  //     like the shapes the same sweep greys, under a key that already defines
  //     that grey (cards.js).
  //
  // No grade on a non-exact row means no claim on file — a sweep that failed,
  // or a row not written since 137 — and it reads as 'unclear', because the
  // fence's own rule is that a failure fences harder, never softer.

  // "" when the verdict is not one of the two provisional answers and the value
  // stands as given; otherwise the tier the sweep put it in. `key` is the
  // sweep's name for the attribute ("type"), not the column's ("hd_type").
  //
  // It takes the verdict rather than the raw confidence because both callers
  // already hold one — a row resolves it from its own columns just below, and a
  // card was handed the backend's word with the payload.
  // A grade travels two ways, both spelled here rather than converted at every
  // call site: a person row and a chart payload carry `{tier, hold_share}` —
  // the share is what the person page's Advanced rows print out loud — while a
  // card carries the word alone, because a card prints no percentage and one of
  // the two card payloads is read by the model.
  GHD.summaryTier = function (verdict, tiers, key) {
    if (UNCERTAIN_CONFIDENCES.indexOf(verdict) === -1) return "";
    var entry = (tiers && tiers[key]) || "";
    var tier = typeof entry === "string" ? entry : entry.tier;
    return tier === "certain" || tier === "likely" ? tier : "unclear";
  };

  // Column on the row, and the sweep key that grades it, in the order a line
  // prints them.
  var SUMMARY_PARTS = [
    ["hd_type", "type"],
    ["profile", "profile"],
    ["authority", "authority"],
  ];

  // The stored summary as a bare line may state it: each value, or "" where the
  // birth time does not settle it. Callers that print one field ask for it by
  // name; callers that print the line take `statedSummaryParts` below.
  GHD.statedSummary = function (person) {
    var stated = { hd_type: "", profile: "", authority: "" };
    if (!person) return stated;
    var verdict = GHD.birthTimeVerdict(person.birth_time_confidence, person.birth_datetime);
    SUMMARY_PARTS.forEach(function (part) {
      var value = person[part[0]];
      if (!value) return;
      var tier = GHD.summaryTier(verdict, person.derived_tiers, part[1]);
      if (tier === "" || tier === "certain") stated[part[0]] = value;
    });
    return stated;
  };

  // The same, as the non-empty values in printing order and in the reader's
  // words (GHD.hdTerms) — so a line joins them with its own separator and simply
  // comes out shorter when the hour decided less. The clock chip beside it is
  // what says why.
  GHD.statedSummaryParts = function (person) {
    var stated = GHD.statedSummary(person);
    var terms = GHD.hdTerms;
    return SUMMARY_PARTS.map(function (part) {
      var value = stated[part[0]];
      return value && terms ? terms.value(part[1], value) : value;
    }).filter(Boolean);
  };

  // "10:30 AM (morning)", "10:30 PM (evening, 22:30)" in a 12-hour locale;
  // "22:30", "00:00 (midnight)" in a 24-hour one. `{ short: true }` drops the
  // part of the day for a line with no room for it ("10:30 PM (22:30)"); a
  // "12h-part" locale, whose AM/PM word already is the part of the day, has
  // nothing to drop. `{ part: true }` names the part of the day in a 24-hour
  // locale too ("14:30 (afternoon)"): under the HH : MM boxes the bare digits
  // would only repeat them. `say` stands in for GHD.trOr on a page with no
  // i18n runtime, which hands over its own catalog words.
  GHD.formatBirthClock = function (hours, minutes, opts) {
    var say = (opts && opts.say) || GHD.trOr;
    var mm = String(minutes).padStart(2, "0");
    var clock = String(hours).padStart(2, "0") + ":" + mm;
    var style = say("chart.clock_hint_style", "12h");
    if (style !== "12h" && style !== "12h-part") {
      var named = (opts && opts.part) || ((hours === 0 || hours === 12) && minutes === 0);
      if (!named) return clock;
      var dayWord = dayPart(hours, minutes, say);
      // The catalog's own brackets: ja writes «14:30（午後）».
      return say("chart.clock_12h", clock + " (" + dayWord + ")", { time: clock, part: dayWord });
    }
    var h12 = hours % 12 || 12;
    var hour = h12 + ":" + mm;
    var time =
      hours < 12
        ? say("chart.clock_am", hour + " AM", { hour: hour })
        : say("chart.clock_pm", hour + " PM", { hour: hour });
    if (opts && opts.short && style === "12h") return h12 === hours ? time : time + " (" + clock + ")";
    var part = dayPart(hours, minutes, say);
    return h12 === hours
      ? say("chart.clock_12h", time + " (" + part + ")", { time: time, part: part })
      : say("chart.clock_12h_24h", time + " (" + part + ", " + clock + ")", { time: time, part: part, clock: clock });
  };

  // Same, parsed from an <input type="time"> value ("HH:MM"). "" if blank/invalid.
  GHD.formatBirthTimeValue = function (value, opts) {
    var m = /^(\d{1,2}):(\d{2})/.exec(value || "");
    if (!m) return "";
    var h = parseInt(m[1], 10);
    var min = parseInt(m[2], 10);
    if (h > 23 || min > 59) return "";
    return GHD.formatBirthClock(h, min, opts);
  };

  /**
   * A birth date as its reader writes it — "6 Aug 1987", or "6 August 1987"
   * with `{ month: "long" }`.
   *
   * Read off the ISO string's own digits, never `new Date(iso)`: a clockless
   * date parses as UTC midnight and renders a day early west of Greenwich.
   * Answers "" for a non-ISO value, and the bare date without Intl.
   */
  GHD.formatBirthDate = function (iso, opts) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso == null ? "" : iso));
    if (!m) return "";
    try {
      return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).toLocaleDateString(GHD.birthDateLocale(), {
        day: "numeric",
        month: (opts && opts.month) || "short",
        year: "numeric",
      });
    } catch (e) {
      return m[0];
    }
  };

  /**
   * The wall date an ISO string spells, in the reader's language: "6 Sep 2033",
   * or "6 Sep 2033, 14:02" with `{ clock: true }`. Any offset is ignored — the
   * digits already are the local clock — so the browser's zone never shifts it.
   *
   * opts: clock, weekday ("Wed 16 Sep 2027"), year (default true), day
   * (default true), month (Intl month style, default "short"). Answers "" for
   * a non-ISO value, and the ISO digits without Intl.
   */
  GHD.formatWallDate = function (iso, opts) {
    var o = opts || {};
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/.exec(String(iso == null ? "" : iso));
    if (!m) return "";
    var hour = m[4] ? Number(m[4]) : 0;
    var minute = m[5] ? Number(m[5]) : 0;
    var fields = { month: o.month || "short", timeZone: "UTC" };
    if (o.day !== false) fields.day = "numeric";
    if (o.year !== false) fields.year = "numeric";
    if (o.weekday) fields.weekday = "short";
    if (o.clock) {
      fields.hour = "2-digit";
      fields.minute = "2-digit";
    }
    try {
      return new Intl.DateTimeFormat(GHD.birthDateLocale(), fields).format(
        new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]), hour, minute)),
      );
    } catch (e) {
      return m[0].replace("T", " ");
    }
  };

  /**
   * The one-line "6 Aug 1987 · 2:32 PM (afternoon, 14:32) · Amsterdam" every surface
   * prints under a name: the person page, the shared chart page and the PDF.
   *
   * data: { birth_datetime, birth_place, timezone }. opts: showTime (false where
   * the hour must not be asserted), timezone (name the zone; PDF only), sep.
   * Empty parts are omitted.
   */
  GHD.formatBirthLine = function (data, opts) {
    var o = opts || {};
    var iso = String((data && data.birth_datetime) || "");
    var parts = [GHD.formatBirthDate(iso, { month: o.month })];
    if (o.showTime !== false) parts.push(GHD.formatBirthTimeValue(iso.split("T")[1] || ""));
    if (o.timezone && data && data.timezone) parts.push(data.timezone);
    if (data && data.birth_place) parts.push(data.birth_place);
    return parts.filter(Boolean).join(o.sep || " · ");
  };

  /**
   * When a usage window reopens, as one line: "Resets in 4 days · Wed 14 Oct,
   * 9:30 am". Both halves are Intl's in the UI language, in the reader's own
   * zone: the relative part so nobody counts days, the moment so nobody guesses
   * the hour. The date reads day first like every date in the app; the clock
   * keeps the language's 12- or 24-hour habit, so it is asked of the plain tag.
   * A moment already behind us says the limit has reset — the allowance on the
   * page is stale by then. `opts.now` (ms) is for tests. "" without a moment.
   */
  GHD.formatQuotaReset = function (resetAtMs, opts) {
    var at = Number(resetAtMs);
    if (!resetAtMs || !isFinite(at)) return "";
    var now = opts && opts.now != null ? Number(opts.now) : Date.now();
    var ms = at - now;
    if (ms <= 0) return GHD.trOr("quota.reset_passed", "Your limit has reset. Please reload the page.");

    var tag = GHD.intlLocale();
    var relative;
    try {
      var rtf = new Intl.RelativeTimeFormat(tag, { numeric: "auto" });
      var minutes = Math.ceil(ms / 60000);
      if (minutes < 60) {
        relative = rtf.format(minutes, "minute");
      } else if (ms < 86400000) {
        relative = rtf.format(Math.min(23, Math.max(1, Math.round(ms / 3600000))), "hour");
      } else {
        // Calendar days, not 24-hour blocks: 25 hours from a Monday morning is
        // "tomorrow", which is what the date beside it says.
        var a = new Date(now);
        var b = new Date(at);
        var days = Math.round(
          (Date.UTC(b.getFullYear(), b.getMonth(), b.getDate()) -
            Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())) /
            86400000,
        );
        relative = rtf.format(Math.max(1, days), "day");
      }
    } catch (e) {
      relative = "";
    }

    var when;
    try {
      var hourCycle = new Intl.DateTimeFormat(tag, { hour: "numeric" }).resolvedOptions().hourCycle;
      var twelve = hourCycle === "h12" || hourCycle === "h11";
      when = new Intl.DateTimeFormat(GHD.birthDateLocale(), {
        weekday: "short",
        day: "numeric",
        month: "short",
        hour: twelve ? "numeric" : "2-digit",
        minute: "2-digit",
        hourCycle: hourCycle,
      }).format(new Date(at));
    } catch (e) {
      when = new Date(at).toLocaleString();
    }
    return GHD.trOr("quota.resets", "Resets {relative} · {when}", { relative: relative, when: when });
  };

  // Live-bind a hint element to a birth-time <input>: echoes formatBirthClock
  // (e.g. "12:00 AM (midnight, 00:00)") as the user types/picks, and clears when empty.
  // A value set in code fires no event: call the returned function to refresh.
  // `opts` goes to formatBirthClock.
  GHD.bindBirthTimeHint = function (inputEl, hintEl, opts) {
    if (!inputEl || !hintEl) return function () {};
    var update = function () {
      hintEl.textContent = GHD.formatBirthTimeValue(inputEl.value, opts);
    };
    inputEl.addEventListener("input", update);
    inputEl.addEventListener("change", update);
    update();
    return update;
  };
})();

;
/* dashboard/js/people-form.js */
/* The birth-details form, for every surface that asks for one: the People add
 * and edit forms, /signup, onboarding and the OAuth consent screen. */

// How sure the user is of the birth time. The user declares it; nothing infers
// it, and nothing but the user may pick "exact". It decides what the explorer
// shows (js/birth-time-explorer.js) and rides along to the API as
// `birth_time_confidence`.
const _PF_CONFIDENCE_OPTIONS = ["exact", "roughly", "unknown"];

// The birth dates a chart can be cast for, mirroring the backend's own bounds
// (backend/engine/calculator.py — SUPPORTED_BIRTH_DATE_MIN and
// supported_birth_date_max, held in step by backend_api/tests/
// test_birth_date_bounds.py, which reads these two constants out of this file).
//
// The floor is 1781, when Human Design dates the 9-centred human; the bundled
// kernels have no planetary positions before mid-1780 either.
// The ceiling is five years out — nobody is born later than that, and the room
// is there so a chart for a due date still works.
//
// The server is the real gate; these two attributes are what stop the browser
// sending the request in the first place. On 2026-08-29 an unbounded field took
// the year 0196 and every chart that account asked for failed from then on.
const _PF_BIRTH_DATE_MIN = "1781-01-01";
const _PF_BIRTH_DATE_FUTURE_YEARS = 5;

// Below this age, a birth date the user is entering *for themselves* is asked
// about — never refused. The bounds above catch a three-digit year and a date
// five years out; they cannot catch a date whose day and month are real and
// whose year simply stayed where the phone's date wheel opened it, which is the
// error the data actually shows: 24 accounts hold a `is_me` birth date in the
// current year against one to five for every other recent year, nine of them
// dated in the future at the moment they were written, and nearly all of them
// marked 'exact'. The whole product then runs off a chart that cannot be theirs.
//
// Twelve rather than five because it is a question, not a gate: the youngest
// plausible account holder is well above it, and a wrong year is nearly always
// the current one, so the wider window costs a real twelve-year-old one dismissed
// sentence and catches every case we have seen. Only the forms that write the
// account holder's own row ask it — saving a toddler on the People form is an
// ordinary thing to do and gets no note.
const _PF_YOUNG_BIRTH_YEARS = 12;

const PersonForm = {
  CONFIDENCE: _PF_CONFIDENCE_OPTIONS,
  BIRTH_DATE_MIN: _PF_BIRTH_DATE_MIN,
  BIRTH_DATE_FUTURE_YEARS: _PF_BIRTH_DATE_FUTURE_YEARS,
  YOUNG_BIRTH_YEARS: _PF_YOUNG_BIRTH_YEARS,

  /* The latest birth date a form accepts, as "YYYY-MM-DD".
   * Read at render time, never a constant: an open app or a cached bundle would
   * keep an old day's ceiling. */
  birthDateMax() {
    const now = new Date();
    // setFullYear on 29 February rolls to 1 March of the target year, which is
    // one day of slack in a bound that already has five years of it.
    now.setFullYear(now.getFullYear() + _PF_BIRTH_DATE_FUTURE_YEARS);
    const pad = (n) => String(n).padStart(2, "0");
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  },

  /* Is this "YYYY-MM-DD" outside what a chart can be cast for? */
  birthDateOutOfRange(value) {
    const date = (value || "").trim();
    if (!date) return false;
    return date < _PF_BIRTH_DATE_MIN || date > this.birthDateMax();
  },

  /** Put the bounds on a date input the caller rendered itself. */
  applyBirthDateBounds(el) {
    if (!el) return;
    el.min = _PF_BIRTH_DATE_MIN;
    el.max = this.birthDateMax();
  },

  /* A birth date as day and month lists and a typed year, followed by the
   * hidden date input `id` that holds the value every caller reads. A native
   * date picker opens on today, and paging back decades to a birth year is the
   * complaint this answers. `own` lets the browser fill the user's own birthday;
   * a form for someone else must not offer it. */
  datePartsHTML(id, { value = "", own = false } = {}) {
    const esc = GHD.escapeHtml;
    const tr = (key, fallback) => esc(typeof GHD.trOr === "function" ? GHD.trOr(key, fallback) : fallback);
    const day = tr("people.date_day", "Day");
    const month = tr("people.date_month", "Month");
    const year = tr("people.date_year", "Year");
    const auto = (part) => (own ? `bday-${part}` : "off");
    return (
      `<div class="date-parts" id="${id}-parts" role="group">` +
      `<select class="date-part-day" id="${id}-day" data-part="day" aria-label="${day}" autocomplete="${auto("day")}"></select>` +
      `<select class="date-part-month" id="${id}-month" data-part="month" aria-label="${month}" autocomplete="${auto("month")}"></select>` +
      `<input type="text" class="date-part-year" id="${id}-year" data-part="year" inputmode="numeric" maxlength="4" placeholder="${year}" aria-label="${year}" autocomplete="${auto("year")}" />` +
      `</div><input type="date" id="${id}" value="${esc(value)}" min="${_PF_BIRTH_DATE_MIN}" max="${this.birthDateMax()}" hidden />`
    );
  },

  /* Wire the parts `datePartsHTML` put before `dateEl`. Each change is written
   * back to `dateEl` with the events a date input fires, so everything bound to
   * it keeps working; `pull()` fills the parts after code set `dateEl` itself.
   * The parts follow the order the page's language writes a date in. */
  bindDateParts(dateEl) {
    const box = dateEl?.previousElementSibling;
    if (!box || !box.classList.contains("date-parts")) return null;
    const [day, month, year] = ["day", "month", "year"].map((p) => box.querySelector(`[data-part="${p}"]`));
    const lang = document.documentElement.lang || "en";
    const option = (select, value, text) => {
      const o = document.createElement("option");
      o.value = value;
      o.textContent = text;
      select.appendChild(o);
    };
    // The empty first option is the field's own label, as the year's placeholder is.
    option(day, "", day.getAttribute("aria-label"));
    for (let d = 1; d <= 31; d++) option(day, String(d), String(d));
    option(month, "", month.getAttribute("aria-label"));
    let monthName;
    try {
      monthName = new Intl.DateTimeFormat(lang, { month: "long", timeZone: "UTC" });
    } catch {
      monthName = new Intl.DateTimeFormat("en", { month: "long", timeZone: "UTC" });
    }
    for (let m = 1; m <= 12; m++) option(month, String(m), monthName.format(new Date(Date.UTC(2000, m - 1, 1))));
    // Day-month-year, month-day-year for English, year first for Chinese and Hungarian.
    try {
      new Intl.DateTimeFormat(lang).formatToParts(new Date(Date.UTC(2000, 10, 22))).forEach((part) => {
        const el = box.querySelector(`[data-part="${part.type}"]`);
        if (el) box.appendChild(el);
      });
    } catch {
      /* the markup's order stands */
    }

    const pad = (n) => String(n).padStart(2, "0");
    const compose = () => {
      const d = Number(day.value);
      const m = Number(month.value);
      const y = year.value.length === 4 ? Number(year.value) : 0;
      if (!d || !m || !y) return "";
      // 31 February rolls over into March; a date that moved is no date.
      return new Date(Date.UTC(y, m - 1, d)).getUTCMonth() === m - 1 ? `${y}-${pad(m)}-${pad(d)}` : "";
    };
    const push = () => {
      const value = compose();
      [day, month, year].forEach((el) => el.classList.toggle("is-valid", Boolean(value)));
      if (value === dateEl.value) return;
      dateEl.value = value;
      dateEl.dispatchEvent(new Event("input", { bubbles: true }));
      dateEl.dispatchEvent(new Event("change", { bubbles: true }));
    };
    year.addEventListener("input", () => {
      const digits = year.value.replace(/\D/g, "").slice(0, 4);
      if (digits !== year.value) year.value = digits;
      push();
    });
    day.addEventListener("change", push);
    month.addEventListener("change", push);

    const pull = () => {
      const p = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateEl.value);
      day.value = p ? String(Number(p[3])) : "";
      month.value = p ? String(Number(p[2])) : "";
      year.value = p ? p[1] : "";
      push();
    };
    pull();
    return {
      els: [day, month, year],
      pull,
      /** The first empty part in reading order, else the year: a date out of range is a year. */
      target: () => [...box.children].find((el) => !el.value) || year,
      focus() {
        this.target().focus();
      },
    };
  },

  /* A birth time as two typed boxes, HH : MM, plus an AM/PM list where the
   * page's language writes a 12-hour clock, then a clock button over the
   * hidden time input `id` that holds the value every caller reads. The boxes
   * open the number keypad; the button opens the native picker for those who
   * prefer the dial or the wheel. */
  timePartsHTML(id, { value = "" } = {}) {
    const esc = GHD.escapeHtml;
    const tr = (key, fallback) => esc(typeof GHD.trOr === "function" ? GHD.trOr(key, fallback) : fallback);
    const hour = tr("people.time_hour", "Hour");
    const minute = tr("people.time_minute", "Minutes");
    const box = (part, label) =>
      // No maxlength on the hour: a whole time pasted or autofilled there
      // ("2:35 pm") must arrive whole; bindTimeParts keeps it to two digits.
      `<input type="text" class="time-part time-part-${part}" id="${id}-${part}" data-part="${part}" inputmode="numeric"${part === "hour" ? "" : ' maxlength="2"'} placeholder="--" aria-label="${label}" autocomplete="off" />`;
    return (
      `<div class="time-parts" id="${id}-parts" role="group">` +
      box("hour", hour) +
      `<span class="time-parts-sep" aria-hidden="true">:</span>` +
      box("minute", minute) +
      `<select class="time-part-period" data-part="period" aria-label="${tr("people.time_period", "AM or PM")}" hidden></select>` +
      // Its own glyph, not GHD.icons.clock: that one marks an uncertain birth time.
      `<span class="time-picker"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg><input type="time" id="${id}" value="${esc(value)}" aria-label="${tr("people.time_picker", "Pick a time")}" tabindex="-1" /></span>` +
      `</div>`
    );
  },

  /* Wire the parts `timePartsHTML` put around `timeEl`. Each change is written
   * back to `timeEl` with the events a time input fires, so everything bound to
   * it keeps working; a time chosen in the picker comes back into the boxes,
   * and `pull()` does the same after code set `timeEl` itself. */
  bindTimeParts(timeEl) {
    const box = typeof timeEl?.closest === "function" ? timeEl.closest(".time-parts") : null;
    if (!box) return null;
    const [hour, minute, period] = ["hour", "minute", "period"].map((p) => box.querySelector(`[data-part="${p}"]`));
    const lang = document.documentElement.lang || "en";
    // The clock follows the reader's own region where it speaks the page's
    // language: the page says only "en", which Intl reads as the US and a
    // 12-hour clock, while a phone set to en-GB or en-NL writes 22:00.
    const own = (typeof navigator !== "undefined" && (navigator.languages?.[0] || navigator.language)) || "";
    const clock = own && own.split("-")[0].toLowerCase() === lang.split("-")[0].toLowerCase() ? own : lang;
    let twelve = false;
    try {
      twelve = /^h1[12]$/.test(new Intl.DateTimeFormat(clock, { hour: "numeric" }).resolvedOptions().hourCycle);
    } catch {
      /* 24-hour boxes */
    }
    if (twelve) {
      const dayPeriod = (h) => {
        try {
          const fmt = new Intl.DateTimeFormat(clock, { hour: "numeric", hourCycle: "h12", timeZone: "UTC" });
          return fmt.formatToParts(new Date(Date.UTC(2000, 0, 1, h))).find((p) => p.type === "dayPeriod")?.value;
        } catch {
          return null;
        }
      };
      // No default: a guessed AM turns an unnoticed 2:35 PM into a different chart.
      [
        ["", "--"],
        ["am", dayPeriod(1) || "AM"],
        ["pm", dayPeriod(13) || "PM"],
      ].forEach(([value, text]) => {
        const o = document.createElement("option");
        o.value = value;
        o.textContent = text;
        period.appendChild(o);
      });
      period.hidden = false;
    }
    const parts = twelve ? [hour, minute, period] : [hour, minute];
    // Whether AM or PM is settled (the list, "pm" typed, a stored or picked
    // time), as opposed to the boxes inferring it from a 24-hour hour: only a
    // settled one stops a 2 from waiting for its second digit, so 23 corrected
    // to 21 still works.
    let periodSaid = false;
    const pad = (s) => (s.length === 1 ? `0${s}` : s);

    const compose = () => {
      if (hour.value.length !== 2 || minute.value.length !== 2) return "";
      let h = Number(hour.value);
      const m = Number(minute.value);
      if (m > 59) return "";
      if (twelve) {
        if (h < 1 || h > 12 || !period.value) return "";
        h = (h % 12) + (period.value === "pm" ? 12 : 0);
      } else if (h > 23) return "";
      return `${pad(String(h))}:${minute.value}`;
    };
    // Our own writes fire the input's events too; the picker listener must not
    // answer them by rewriting the boxes from a half-typed (empty) value.
    let pushing = false;
    const push = () => {
      const value = compose();
      parts.forEach((el) => el.classList.toggle("is-valid", Boolean(value)));
      if (value === timeEl.value) return;
      timeEl.value = value;
      pushing = true;
      timeEl.dispatchEvent(new Event("input", { bubbles: true }));
      timeEl.dispatchEvent(new Event("change", { bubbles: true }));
      pushing = false;
    };
    const pull = () => {
      const p = /^(\d{2}):(\d{2})/.exec(timeEl.value);
      if (!p) {
        parts.forEach((el) => (el.value = ""));
        periodSaid = false;
      } else if (twelve) {
        const h = Number(p[1]);
        hour.value = pad(String(h % 12 || 12));
        // A stored or picked time states its half as plainly as the list does.
        period.value = h >= 12 ? "pm" : "am";
        periodSaid = true;
        minute.value = p[2];
      } else {
        hour.value = p[1];
        minute.value = p[2];
      }
      push();
    };
    // "1435", "14:35", "2:35 pm": a whole time typed or pasted into the hour box.
    // Written into the boxes and pushed from there, so the input's events fire.
    const takeWhole = (text) => {
      const p = /^\s*(\d{1,2})\s*[:.h]?\s*(\d{2})\s*([ap])?/i.exec(text);
      if (!p) return false;
      let h = Number(p[1]);
      const m = p[2];
      if (h > 23 || Number(m) > 59 || (p[3] && (h < 1 || h > 12))) return false;
      if (twelve) {
        if (p[3]) {
          period.value = p[3].toLowerCase() === "p" ? "pm" : "am";
          periodSaid = true;
        }
        // 13 to 23 can only be the afternoon; 1 to 12 with no am/pm keeps
        // whatever period the reader chose, or leaves the question open.
        else if (h > 12 || h === 0) {
          period.value = h > 12 ? "pm" : "am";
          periodSaid = false;
        }
        h = h % 12 || 12;
      } else if (p[3]) {
        h = (h % 12) + (p[3].toLowerCase() === "p" ? 12 : 0);
      }
      hour.value = pad(String(h));
      minute.value = m;
      push();
      return true;
    };

    hour.addEventListener("input", (e) => {
      // A whole time arrives in one insert (paste, autofill, a keyboard
      // suggestion); one more key after "10" is a typo, not 1:05.
      const oneKey = e.inputType === "insertText" && (e.data || "").length <= 1;
      if (!oneKey && hour.value.replace(/\D/g, "").length > 2 && takeWhole(hour.value)) return minute.focus();
      // A pasted time that is not one ("14:5", "14:60") still brings its own
      // minutes, so the stored ones cannot quietly stay behind them.
      let pastedMinutes = null;
      if (!oneKey) {
        const m = /^\s*(\d{1,2})\D+(\d*)/.exec(hour.value);
        if (m) {
          hour.value = m[1];
          pastedMinutes = m[2].slice(0, 2);
        }
      }
      let digits = hour.value.replace(/\D/g, "").slice(0, 2);
      // A first digit no hour can continue from is the whole hour: 7 is 07.
      // With AM or PM still open a 2 waits, because 20 to 23 are hours too
      // (10 PM typed as 22); once the reader has said AM or PM only 1 can go on.
      const continues = twelve && periodSaid ? 1 : 2;
      if (digits.length === 1 && Number(digits) > continues) digits = `0${digits}`;
      // 24 to 29 is no hour: the 2 was the hour and the next digit starts the
      // minutes, replacing any there, as every key after the hour does.
      let carry = "";
      if (digits.length === 2 && Number(digits) >= 24 && Number(digits) <= 29) {
        carry = digits[1];
        digits = `0${digits[0]}`;
      }
      // A 24-hour time typed into a 12-hour clock says which half it is: 13 to
      // 23 is that hour PM, 00 is 12 AM.
      // Above 23 it stays an hour no clock has, for the form to refuse.
      const typedHour = Number(digits);
      if (twelve && digits.length === 2 && ((typedHour > 12 && typedHour <= 23) || digits === "00")) {
        const h = typedHour;
        period.value = h >= 12 ? "pm" : "am";
        // Inferred, not said: the next 2 typed here may still begin 20-23.
        periodSaid = false;
        digits = pad(String(h % 12 || 12));
      }
      hour.value = digits;
      if (carry) minute.value = carry;
      else if (pastedMinutes !== null) minute.value = pastedMinutes;
      push();
      if (digits.length === 2) {
        minute.focus();
        // The carried digit stays put, with the caret after it, so the next
        // keystroke completes the minutes.
        if (carry) minute.setSelectionRange(1, 1);
      }
    });
    hour.addEventListener("keydown", (e) => {
      if ([":", ".", " "].includes(e.key) && hour.value) {
        e.preventDefault();
        hour.value = pad(hour.value);
        push();
        minute.focus();
      }
    });
    hour.addEventListener("paste", (e) => {
      if (takeWhole(e.clipboardData?.getData("text") || "")) e.preventDefault();
    });
    minute.addEventListener("input", () => {
      minute.value = minute.value.replace(/\D/g, "").slice(0, 2);
      // No jump into AM/PM: a keyboard user Tabs there, and a jump made that
      // Tab skip it.
      push();
    });
    minute.addEventListener("keydown", (e) => {
      if (e.key === "Backspace" && !minute.value) {
        e.preventDefault();
        hour.focus();
      }
    });
    // A box's digits are selected when the reader lands in it, so typing
    // replaces them: a full box (maxlength 2) drops the keystrokes, and "235"
    // over a stored 10:30 saved 2:30. On focus for Tab and the hand-over from
    // the hour; on click too, because a click places its caret after the focus
    // event. Two digits are retyped, never edited in the middle.
    [hour, minute].forEach((el) => {
      el.addEventListener("focus", () => el.select());
      el.addEventListener("click", () => {
        if (el.selectionStart === el.selectionEnd) el.select();
      });
    });
    [hour, minute].forEach((el) =>
      el.addEventListener("blur", () => {
        if (el.value.length === 1) {
          el.value = pad(el.value);
          push();
        }
      }),
    );
    period.addEventListener("change", () => {
      periodSaid = Boolean(period.value);
      push();
    });
    // Opening the list and leaving the half as it was is choosing it too;
    // a select fires no change for that.
    period.addEventListener("blur", () => {
      if (period.value) periodSaid = true;
    });
    // The picker writes the input itself; its time comes back into the boxes.
    ["input", "change"].forEach((type) =>
      timeEl.addEventListener(type, () => {
        if (!pushing) pull();
      }),
    );
    // The clock is the only visible part of the input, so any tap on it means
    // the picker. Chrome on Android otherwise focuses the hidden digits on a
    // device that also reports a fine pointer, and nothing opens. Firefox opens
    // its own picker on the click, and a second opening from showPicker shut
    // it, so Gecko is left to its own. Cancelling the click instead would
    // leave the clock dead where showPicker exists but cannot open a time
    // input (older iOS Safari).
    const geckoOpensItself = /\bFirefox\//.test(globalThis.navigator?.userAgent || "");
    timeEl.addEventListener("click", () => {
      if (geckoOpensItself) return;
      try {
        timeEl.showPicker?.();
      } catch {
        /* already open, or not allowed from this gesture */
      }
    });

    pull();
    return {
      box,
      els: parts,
      pull,
      /** The first empty part in reading order, else the hour. */
      target: () => parts.find((el) => !el.value) || hour,
      focus() {
        this.target().focus();
      },
    };
  },

  /* A clear button inside a place field's wrapper (its positioned parent),
   * shown while the field has focus and text; in the app it takes the tick's
   * place, which comes back on blur as the confirmation. A long picked place is
   * otherwise a lot of backspacing. With a mouse, the first click into a
   * confirmed place selects it all, so typing replaces it; on a phone
   * select-all on tap fights where the reader puts the caret. `label` is for
   * pages with no i18n runtime. */
  bindPlaceClear(placeEl, { label } = {}) {
    const wrap = placeEl?.parentElement;
    if (!wrap) return;
    const clearBtn = document.createElement("button");
    clearBtn.type = "button";
    clearBtn.className = "place-clear";
    clearBtn.hidden = true;
    clearBtn.setAttribute("aria-label", label || GHD.trOr("people.place_clear", "Clear place"));
    clearBtn.innerHTML =
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M15 9l-6 6M9 9l6 6"/></svg>';
    wrap.appendChild(clearBtn);
    wrap.classList.add("has-place-clear");
    // Shown while the focus is in the field or on the button itself, so Tab
    // from the field reaches it. Read after the focus has moved.
    const refresh = () => {
      const editing = wrap.contains(document.activeElement) && Boolean(placeEl.value);
      clearBtn.hidden = !editing;
      wrap.classList.toggle("is-editing", editing);
      // Left behind, a long place stays scrolled to its end, where the caret
      // was; its start, the city, is the part worth reading.
      if (document.activeElement !== placeEl) placeEl.scrollLeft = 0;
    };
    ["focus", "input"].forEach((type) => placeEl.addEventListener(type, refresh));
    wrap.addEventListener("focusout", () => setTimeout(refresh, 0));
    // Keep the focus in the field, or the blur hides the button mid-press.
    clearBtn.addEventListener("mousedown", (e) => e.preventDefault());
    clearBtn.addEventListener("click", () => {
      placeEl.value = "";
      // The place listeners clear the zone and close the dropdown on this.
      placeEl.dispatchEvent(new Event("input", { bubbles: true }));
      placeEl.focus();
      refresh();
    });
    let selectOnUp = false;
    placeEl.addEventListener("pointerdown", (e) => {
      selectOnUp = e.pointerType === "mouse" && document.activeElement !== placeEl && Boolean(placeEl._timezone);
    });
    placeEl.addEventListener("mouseup", (e) => {
      if (!selectOnUp) return;
      selectOnUp = false;
      // The mouseup would collapse the selection to the click point.
      e.preventDefault();
      placeEl.select();
    });
  },

  /* The ⓧ at the end of the "we'll use noon" note: back to typing a time.
   * The same mark as the place field's clear button. */
  unsureUndoHTML(id, label) {
    return `<button type="button" class="time-unsure-undo" id="${id}" aria-label="${GHD.escapeHtml(label || "")}"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M15 9l-6 6M9 9l6 6"/></svg></button>`;
  },

  /* What to tell someone whose birth date falls outside the range.
   * Bounds are interpolated, never written into the copy. `text` is the already
   * translated sentence for pages with no i18n runtime (landing page, knowledge
   * base), where trOr would otherwise answer in English. */
  birthDateRangeMessage(text) {
    const vars = { min: _PF_BIRTH_DATE_MIN, max: this.birthDateMax() };
    return GHD.trOr(
      "people.birth_date_range",
      // Word for word what `people.birth_date_range` says in i18n/en/common.json:
      // the catalog wins wherever one is loaded, so a default that reads
      // differently is a second English nobody chose.
      text || "Please check the birth date — we can only calculate a chart for a birth between {min} and {max}.",
      vars,
    );
  },

  /* Where a `collect()` error points, in GHD.fieldStatus's shape: the inputs to
   * mark invalid (a date or time in parts marks every part) and what to focus
   * (the first empty part). Empty for a field this form does not have. */
  fieldErrorTarget(els, field) {
    const el = els[field];
    if (!el) return {};
    const parts = field === "date" ? els.dateParts : field === "time" ? els.timeParts : null;
    return { fields: parts ? parts.els : [el], focus: () => (parts || el).focus() };
  },

  /* Is this "YYYY-MM-DD" a birth less than :data:`_PF_YOUNG_BIRTH_YEARS` ago? */
  birthDateLooksTooRecent(value) {
    const date = (value || "").trim();
    if (!date) return false;
    const cutoff = new Date();
    cutoff.setFullYear(cutoff.getFullYear() - _PF_YOUNG_BIRTH_YEARS);
    const pad = (n) => String(n).padStart(2, "0");
    const floor = `${cutoff.getFullYear()}-${pad(cutoff.getMonth() + 1)}-${pad(cutoff.getDate())}`;
    // Out of range entirely is a different sentence, and the caller shows that
    // one instead: two notes under one field is noise.
    if (this.birthDateOutOfRange(date)) return false;
    return date > floor;
  },

  /* The question to put under the date field. */
  youngBirthDateMessage(text) {
    return GHD.trOr(
      "people.birth_date_recent",
      text || "That birth date is less than {years} years ago. Is the year right?",
      { years: _PF_YOUNG_BIRTH_YEARS },
    );
  },

  /* Bind the young-birth-date question to a date input the caller rendered. */
  bindYoungBirthDateNote({ dateEl, noteEl, text } = {}) {
    if (!dateEl || !noteEl) return null;
    noteEl.textContent = this.youngBirthDateMessage(text);
    const refresh = () => {
      noteEl.hidden = !this.birthDateLooksTooRecent(dateEl.value);
    };
    dateEl.addEventListener("input", refresh);
    dateEl.addEventListener("change", refresh);
    refresh();
    return { refresh };
  },

  /**
   * "YYYY-MM-DDTHH:MM" (or a space-separated / date-only variant) → ["YYYY-MM-DD", "HH:MM"].
   * Both halves come back "" when absent, which is what the <input>s want.
   */
  splitBirthDatetime(value) {
    const normalized = (value || "").trim().replace(" ", "T");
    if (!normalized) return ["", ""];
    const [date, time] = (normalized.includes("T") ? normalized : `${normalized}T`).split("T");
    const timeParts = (time || "").split(":");
    const normalizedTime =
      timeParts.length >= 2 ? `${timeParts[0].padStart(2, "0")}:${timeParts[1].padStart(2, "0")}` : time || "";
    return [date || "", normalizedTime];
  },

  /* Which confidence segment starts selected when editing `person`. */
  confidenceFor(person, time) {
    const stored = person?.birth_time_confidence;
    if (_PF_CONFIDENCE_OPTIONS.includes(stored)) return stored;
    return time ? "exact" : "unknown";
  },

  /* The one rule for "I don't know my birth time", whatever control asks it.
   *
   * Picking "unknown" hides the field and shows the noon that will be saved
   * instead: a locked field showing 12:00 read as a time the reader could not
   * change. The typed time is held and put back when the reader leaves
   * "unknown"; overwriting it outright once erased a typed time with no way back.
   * The signup forms ask it as an "I'm not sure" link beside the label
   * (`unsureEl`) and take it back with the ⓧ in the noon note (`undoEl`).
   * `refreshTimeHint` rewrites the readback after the time is put back in code.
   * Returns { value, set(next, {notify}), time() }. */
  bindTimeConfidence({
    timeEl,
    timeBoxEl = timeEl,
    timeHintEl = null,
    refreshTimeHint = null,
    noteEl = null,
    roughNoteEl = null,
    chips = null,
    checkbox = null,
    unsureEl = null,
    undoEl = null,
    initial = "exact",
    onChange = null,
  } = {}) {
    if (!timeEl) return null;
    let value = _PF_CONFIDENCE_OPTIONS.includes(initial) ? initial : "exact";
    // The time the reader typed, held while the field is hidden behind noon;
    // null whenever the field shows their own time.
    let typed = null;
    const buttons = chips ? [...chips] : [];

    /* Select a value and put the time field in the matching shape.
     * `notify` is false when the change comes from the explorer, and for the
     * first call, which runs before the explorer mounts. */
    const apply = (next, { notify = true } = {}) => {
      const unknown = next === "unknown";
      if (unknown !== (typed !== null)) {
        if (unknown) {
          typed = timeEl.value;
          timeEl.value = "12:00";
        } else {
          timeEl.value = typed;
          typed = null;
          // Set in code, so the field's own listeners never hear it.
          if (refreshTimeHint) refreshTimeHint();
          else if (timeHintEl && GHD.formatBirthTimeValue)
            timeHintEl.textContent = GHD.formatBirthTimeValue(timeEl.value);
        }
      }
      value = next;
      buttons.forEach((btn) => {
        const on = btn.dataset.confidence === next;
        btn.classList.toggle("active", on);
        btn.setAttribute("aria-checked", on ? "true" : "false");
        btn.tabIndex = on ? 0 : -1;
      });
      if (checkbox) checkbox.checked = unknown;
      if (unsureEl) unsureEl.hidden = unknown;
      timeEl.disabled = unknown;
      timeBoxEl.hidden = unknown;
      if (noteEl) noteEl.hidden = !unknown;
      if (roughNoteEl) roughNoteEl.hidden = next !== "roughly";
      // "12:00 (noon)" under "We'll use 12:00 noon." is the same sentence twice.
      if (timeHintEl) timeHintEl.hidden = unknown;
      if (notify && onChange) onChange(next);
    };

    buttons.forEach((btn, i) => {
      btn.addEventListener("click", () => {
        const wasUnknown = value === "unknown";
        apply(btn.dataset.confidence);
        // Back from "No idea", the field reappears: put the reader in it.
        if (wasUnknown && value !== "unknown") (timeBoxEl.querySelector?.("input") || timeEl).focus();
      });
      // Radio-group keys: the arrows move the selection, not just the focus.
      btn.addEventListener("keydown", (e) => {
        const step = ["ArrowRight", "ArrowDown"].includes(e.key)
          ? 1
          : ["ArrowLeft", "ArrowUp"].includes(e.key)
            ? -1
            : 0;
        if (!step) return;
        e.preventDefault();
        const target = buttons[(i + step + buttons.length) % buttons.length];
        apply(target.dataset.confidence);
        target.focus();
      });
    });

    if (checkbox) checkbox.addEventListener("change", () => apply(checkbox.checked ? "unknown" : "exact"));
    // The link hides itself, so the focus goes to the ⓧ that undoes it, and back.
    unsureEl?.addEventListener("click", () => {
      apply("unknown");
      undoEl?.focus();
    });
    undoEl?.addEventListener("click", () => {
      apply("exact");
      (timeBoxEl.querySelector?.("input") || timeEl).focus();
    });
    apply(value, { notify: false });

    return {
      get value() {
        return value;
      },
      set(next, opts) {
        apply(next, opts);
      },
      /** What to store: the field's time, or noon when nobody knows it. */
      time() {
        return value === "unknown" ? "12:00" : timeEl.value;
      },
    };
  },

  /* The birth-details field cluster, as markup.
   * Every id is `<prefix>-<part>`. `labels` are already translated by the
   * caller. `nameField` is null on /signup; `timeControl` is "chips", "link" or
   * "checkbox". "chips" asks the birth-time question under the field's label,
   * with one segment per entry in `choices`; "link" asks it as "I'm not sure"
   * beside the label (`labels.notSure`), undone by the ⓧ in the note
   * (`labels.undo`). `placeFirst` puts the place above
   * the time: the edit form's time explorer needs the place's zone, and it
   * opens with room below the form. `after` goes inside the same wrapper. */
  fields({
    prefix = "pf",
    labels = {},
    nameField = null,
    values = {},
    confidence = "exact",
    timeControl = "chips",
    choices = _PF_CONFIDENCE_OPTIONS,
    placeFirst = false,
    youngDateNote = false,
    after = "",
  }) {
    const id = (part) => `${prefix}-${part}`;
    const esc = GHD.escapeHtml;

    const nameHTML = !nameField
      ? ""
      : `<div class="field-group field-name"><label for="${id(nameField.key)}">${nameField.label}</label>` +
        `<input type="text" id="${id(nameField.key)}" ` +
        (nameField.value ? `value="${esc(nameField.value)}"` : `placeholder="${esc(nameField.placeholder || "")}"`) +
        ` autocomplete="${nameField.autocomplete || "off"}" /></div>`;

    let timeHTML;
    if (timeControl === "chips") {
      const segments = choices
        .map((key) => {
          const on = key === confidence;
          return `<button type="button" role="radio" class="${on ? "active" : ""}" data-confidence="${key}" aria-checked="${on}" tabindex="${on ? 0 : -1}">${(labels.confidence || {})[key] || key}</button>`;
        })
        .join("");
      timeHTML = `
          <div class="field-group field-group-time">
            <label id="${id("time-label")}" for="${id("time")}-hour">${labels.time || ""}</label>
            <div class="field-confidence" id="${id("confidence")}" role="radiogroup" aria-labelledby="${id("time-label")}">${segments}</div>
            ${this.timePartsHTML(id("time"), { value: values.time || "" })}<span class="field-time-hint" id="${id("time-hint")}"></span>
            <span class="field-time-note" id="${id("time-note")}" hidden>${labels.unknownHint || ""}</span>
            <span class="field-time-note" id="${id("rough-note")}" hidden>${labels.roughHint || ""}</span>
          </div>`;
    } else if (timeControl === "link") {
      timeHTML = `
          <div class="field-group field-group-time">
            <div class="field-label-row"><label id="${id("time-label")}" for="${id("time")}-hour">${labels.time || ""}</label><button type="button" class="time-unsure-link" id="${id("time-unsure")}">${labels.notSure || ""}</button></div>
            ${this.timePartsHTML(id("time"), { value: values.time || "" })}<span class="field-time-hint" id="${id("time-hint")}"></span>
            <span class="field-time-note time-unsure-note" id="${id("time-note")}" hidden><span>${labels.unknownHint || ""}</span>${this.unsureUndoHTML(id("time-undo"), labels.undo)}</span>
          </div>`;
    } else {
      timeHTML = `
          <div class="field-group field-group-time"><label for="${id("time")}-hour">${labels.time || ""}</label>${this.timePartsHTML(id("time"), { value: values.time || "" })}<span class="field-time-hint" id="${id("time-hint")}"></span></div>
          <div class="field-group field-group-inline ob-no-time-wrap"><input type="checkbox" id="${id("no-time")}" /><label for="${id("no-time")}">${labels.noTimeLabel || ""}</label></div>
          <p class="ob-no-time-hint" id="${id("no-time-hint")}" hidden>${labels.unknownHint || ""}</p>`;
    }
    const placeHTML = `
          <div class="field-group field-place">
            <label for="${id("place")}">${labels.place || ""}</label>
            <div class="field-place-wrap"><input type="text" id="${id("place")}" ${
              values.place ? `value="${esc(values.place)}"` : `placeholder="${esc(labels.placePlaceholder || "")}"`
            } autocomplete="off" data-lpignore="true" data-1p-ignore /><span class="field-place-icon" id="${id("place-icon")}"></span></div>
            <span class="field-tz-hint" id="${id("tz-hint")}"></span>
          </div>`;

    return `
        <div class="add-person-fields">
          ${nameHTML}
          <div class="field-group field-date"><label for="${id("date")}-day">${labels.date || ""}</label>${this.datePartsHTML(id("date"), { value: values.date || "", own: youngDateNote })}${youngDateNote ? `<span class="field-date-note" id="${id("date-note")}" hidden></span>` : ""}</div>
          ${placeFirst ? placeHTML + timeHTML : timeHTML + placeHTML}
          ${after}
        </div>`;
  },

  /* Wire a cluster `fields()` rendered, and hand back what a caller needs to
   * read it, restore it and save it. Given `apiBase`, the place field uses the
   * public geocoder (no session yet); omitted, the authenticated Api. */
  bindFields({
    root = document,
    prefix = "pf",
    nameKey = "",
    timeControl = "chips",
    confidence = "exact",
    apiBase = null,
    youngDateNote = false,
    onConfidenceChange = null,
  } = {}) {
    const pick = (part) => root.querySelector(`#${prefix}-${part}`);
    const els = {
      date: pick("date"),
      time: pick("time"),
      place: pick("place"),
      placeIcon: pick("place-icon"),
      tzHint: pick("tz-hint"),
      timeHint: pick("time-hint"),
      name: nameKey ? pick(nameKey) : null,
    };

    els.dateParts = this.bindDateParts(els.date);
    els.timeParts = this.bindTimeParts(els.time);
    const tz = apiBase
      ? PlaceAutocomplete.bindPublic(els.place, { apiBase, hint: els.tzHint, icon: els.placeIcon, confirmOnBlur: true })
      : PlaceAutocomplete.bindTzHint(els.place, els.tzHint, els.placeIcon);
    this.bindPlaceClear(els.place);
    const refreshTimeHint = GHD.bindBirthTimeHint(els.time, els.timeHint, { part: true }) || (() => {});
    if (youngDateNote) this.bindYoungBirthDateNote({ dateEl: els.date, noteEl: pick("date-note") });

    const chips = timeControl === "chips";
    const link = timeControl === "link";
    const conf = this.bindTimeConfidence({
      timeEl: els.time,
      timeBoxEl: els.timeParts?.box,
      timeHintEl: els.timeHint,
      refreshTimeHint,
      noteEl: chips || link ? pick("time-note") : pick("no-time-hint"),
      roughNoteEl: chips ? pick("rough-note") : null,
      chips: chips ? [...root.querySelectorAll(`#${prefix}-confidence button`)] : null,
      checkbox: chips || link ? null : pick("no-time"),
      unsureEl: link ? pick("time-unsure") : null,
      undoEl: link ? pick("time-undo") : null,
      initial: confidence,
      onChange: onConfidenceChange,
    });

    return {
      els,
      tz,
      confidence: conf,

      /* The values, or which check failed: `{ error: "fields" | "time" |
       * "date_range" }`, plus `field`, the first empty input in reading order.
       * The caller owns the sentences. */
      collect({ requireName = true } = {}) {
        const name = els.name ? els.name.value.trim() : "";
        const date = els.date.value.trim();
        const place = els.place.value.trim();
        const time = conf.time();
        if (requireName && !name) return { error: "fields", field: "name" };
        if (!date) return { error: "fields", field: "date" };
        // The `min`/`max` on the field constrain the picker and mark the input
        // invalid, but none of these forms submits natively, so nothing would
        // act on that. This is what does. A three-digit year typed straight into
        // the year box is the shape that reached production.
        if (PersonForm.birthDateOutOfRange(date)) return { error: "date_range", field: "date" };
        if (!place) return { error: "fields", field: "place" };
        if (!time) return { error: "time", field: "time" };
        return {
          values: {
            name,
            date,
            time,
            place,
            timezone: tz ? tz.timezone : "",
            birthTimeConfidence: conf.value,
            birthDatetime: `${date}T${time}`,
          },
        };
      },

      /* Settle a place typed and never picked before a save (tz.confirm in
       * place-autocomplete.js). Answers whether the save may go ahead: not
       * when a zone has only just appeared (so it is seen first), when the
       * place was refused, or when the fields changed while it looked —
       * `collected` is what the caller read before asking. */
      async confirmPlace(collected) {
        const verdict = tz ? await tz.confirm() : "unchecked";
        if (verdict !== "confirmed" && verdict !== "unchecked") return false;
        const now = this.collect({ requireName: false }).values;
        return JSON.stringify(now) === JSON.stringify(collected.values);
      },

      /** Put a signup seed back into the fields. Answers whether it had one. */
      restoreSeed(seed) {
        if (!seed) return false;
        els.date.value = seed.birthDate || "";
        els.dateParts?.pull();
        // A seed with no time carries the noon that stood in for it; that is
        // not a time the reader typed, so it stays out of the hidden field.
        if (seed.birthTime && !seed.noTime) els.time.value = seed.birthTime;
        els.timeParts?.pull();
        els.place.value = seed.birthPlace || "";
        // The "14:30 (afternoon)" echo is bound to the field's own events, and a
        // value put there in code fires none — so it is refreshed by hand rather
        // than by dispatching an input event the place field would also hear.
        refreshTimeHint();
        if (seed.noTime) conf.set("unknown");
        if (!tz) return true;
        if (seed.timezone) tz.set(seed.timezone);
        // A seed written before the place resolved carries no zone. Signed in we
        // can look one up; signed out the field simply shows none until the user
        // picks from the dropdown again.
        else if (!apiBase && els.place.value.trim()) tz.resolve(els.place.value);
        return true;
      },
    };
  },

  /* The signup-seed record for the values `collect()` returned.
   * The field stays `firstName` (it holds the whole name): both origins and
   * cached landing pages read that wire shape. */
  seedFrom(values, name) {
    return {
      firstName: name || "",
      birthDate: values.date,
      birthTime: values.time,
      birthPlace: values.place,
      // The seed's wire shape is older than the three-way control and both
      // origins read it, so what crosses is still the yes/no question.
      noTime: values.birthTimeConfidence === "unknown",
      timezone: values.timezone,
      savedAt: Date.now(),
    };
  },

  /* Render the People add/edit form into `host` (its contents are replaced).
   * `meDefault` ticks "This is me" only for an entry point that says so, never
   * the plain Add button: a wrong is_me cannot be corrected from the app.
   * `meName` names whoever is "This is me" now, so the note under the box can
   * say who ticking it replaces.
   * `onSubmit` throws to show `err.message` under the form. Returns the form. */
  render(
    host,
    {
      mode = "add",
      person = null,
      hasMe = false,
      meName = "",
      meDefault = false,
      heading: showHeading = true,
      pro = false,
      onCancel,
      onSubmit,
    } = {},
  ) {
    if (!host) return null;
    const isEdit = mode === "edit";
    const [date, time] = isEdit ? this.splitBirthDatetime(person?.birth_datetime) : ["", ""];
    const isMe = Boolean(isEdit && person?.is_me);
    // Ticked, not disabled: the caller asked for this person to be the account
    // holder, and the reader can still say otherwise before they save.
    const meChecked = isMe || (!isEdit && meDefault);
    // A brand-new person is assumed to come with a known time — that is the
    // common case, and it is the one state that shows nothing extra at all.
    const confidence0 = isEdit ? this.confidenceFor(person, time) : "exact";

    // Editing someone in place, under a header that already names them: the
    // fields and Save say it is an edit, so the heading is for assistive tech only.
    const title = isEdit
      ? t("people.edit_person_title", { name: GHD.escapeHtml(person?.name || "") })
      : t("people.add_person");
    const heading = isEdit || !showHeading ? "" : `<h3 class="people-form-title">${title}</h3>`;

    const fields = this.fields({
      prefix: "pf",
      nameField: {
        key: "name",
        label: t("people.field_name"),
        value: isEdit ? person?.name || "" : "",
        placeholder: t("people.name_placeholder"),
      },
      // An unknown time is stored as the noon that stood in for it; offered
      // back as a typed 12:00, "Exact time" would save it as the real one.
      values: { date, time: confidence0 === "unknown" ? "" : time, place: isEdit ? person?.birth_place || "" : "" },
      confidence: confidence0,
      placeFirst: true,
      // The note rides on the checkbox's own line: as a sentence under it,
      // "Right now you are …" read as an error message. The birth time check
      // comes last, below every field, where the wide form has a row for it.
      after: `
          <div class="field-group field-group-inline field-is-me"><input type="checkbox" id="pf-is-me" ${isMe ? "checked disabled" : meChecked ? "checked" : ""} aria-describedby="pf-is-me-note" /><label for="pf-is-me">${t("people.this_is_me")}</label><span class="field-is-me-note" id="pf-is-me-note" aria-live="polite" hidden></span></div>
          <div id="pf-bte" hidden></div>`,
      labels: {
        date: t("people.field_birth_date"),
        time: t("people.field_birth_time"),
        place: t("people.field_birth_place"),
        placePlaceholder: t("people.place_placeholder"),
        unknownHint: t("people.unknown_time_hint"),
        roughHint: t("people.time_roughly_hint"),
        confidence: {
          exact: t("people.time_choice_exact"),
          roughly: t("people.time_choice_roughly"),
          unknown: t("people.time_choice_unknown"),
        },
      },
    });

    host.innerHTML = `
      <div class="add-person-form people-inline-form" role="group" aria-label="${title}">
        ${heading}
        ${fields}
        <div class="add-person-actions">
          <button class="btn-outline btn-small" id="pf-cancel">${t("people.cancel")}</button>
          <button class="btn-primary btn-small" id="pf-save">${t("people.save")}</button>
          <p class="error" id="pf-error" hidden></p>
        </div>
      </div>
    `;

    const form = host.querySelector(".add-person-form");
    const isMeEl = form.querySelector("#pf-is-me");
    const isMeNote = form.querySelector("#pf-is-me-note");
    const saveBtn = form.querySelector("#pf-save");
    const cancelBtn = form.querySelector("#pf-cancel");
    const errEl = form.querySelector("#pf-error");

    /* The validation nudge, pointed at the field it is about.
     * It clears itself on edit, on answering the birth-time question, or after
     * HOLD_MS; the aria description must never outlive the sentence. */
    const HOLD_MS = 3000;
    let errTimer = null;
    let erred = null;

    const clearFieldError = () => {
      if (errTimer) {
        clearTimeout(errTimer);
        errTimer = null;
      }
      if (erred) {
        erred.removeEventListener("input", clearFieldError);
        erred.classList.remove("field-invalid", "field-shake");
        erred.removeAttribute("aria-invalid");
        erred.removeAttribute("aria-describedby");
        erred = null;
      }
      errEl.hidden = true;
      errEl.textContent = "";
    };

    const showFieldError = (el, message) => {
      clearFieldError();
      errEl.textContent = message;
      errEl.hidden = false;
      if (!el) return;
      erred = el;
      el.classList.add("field-invalid");
      el.setAttribute("aria-invalid", "true");
      el.setAttribute("aria-describedby", "pf-error");
      // Replay from a clean baseline — the class may still be on this field
      // from the last attempt, and re-adding it alone would not restart the
      // animation. The reflow between the two writes is what makes it.
      el.classList.remove("field-shake");
      void el.offsetWidth;
      el.classList.add("field-shake");
      el.focus();
      el.addEventListener("input", clearFieldError);
      errTimer = setTimeout(clearFieldError, HOLD_MS);
    };

    const bound = this.bindFields({
      root: form,
      prefix: "pf",
      nameKey: "name",
      confidence: confidence0,
      // The explorer owns its own post-adoption collapse, so it hears about a
      // change the user made and never about one it made itself.
      onConfidenceChange: (next) => {
        // Only "nobody knows" answers the missing-time message on its own: it
        // is the one confidence `time()` substitutes noon for. "Roughly" still
        // saves whatever the field holds, so on a blank field the message is
        // still true and clearing it here would send the reader back to a save
        // that fails for the same reason with nothing to show why. The field
        // sees no input event either way, which is why this is not left to
        // clearFieldError's own listener.
        if (next === "unknown" || bound.els.time.value.trim()) clearFieldError();
        BirthTimeExplorer.setConfidence(next);
      },
    });

    BirthTimeExplorer.mount(form.querySelector("#pf-bte"), {
      dateEl: bound.els.date,
      timeEl: bound.els.time,
      placeEl: bound.els.place,
      confidence: confidence0,
      pro,
      onConfidenceChange: (next) => bound.confidence.set(next, { notify: false }),
    });
    bound.els.name.focus();

    // What the form held when it opened, to tell Cancel whether it discards anything.
    const snapshot = () =>
      [...form.querySelectorAll("input, select, textarea")]
        .map((el) => (el.type === "checkbox" || el.type === "radio" ? el.checked : el.value))
        .concat(bound.confidence.value)
        .join("\u0000");
    const pristine = snapshot();

    // The on-screen keyboard's own reveal leaves a focused field flush against
    // its edge (the minute box, after the hour advances to it); a field with
    // no room under it is moved to the middle of what is left.
    if (typeof matchMedia === "function" && matchMedia("(pointer: coarse)").matches) {
      let reveal = 0;
      form.addEventListener("focusin", (e) => {
        const el = e.target;
        if (!el.matches?.("input:not([type=checkbox]):not([type=radio]), select, textarea")) return;
        clearTimeout(reveal);
        // After the keyboard has resized the page, which takes a few frames.
        reveal = setTimeout(() => {
          if (document.activeElement !== el) return;
          const vv = window.visualViewport;
          const bottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
          if (el.getBoundingClientRect().bottom > bottom - 64)
            el.scrollIntoView({ block: "center", behavior: "smooth" });
        }, 350);
      });
    }

    // Who "This is me" is now, and what ticking the box does to them, in names:
    // the swap is the one change here the app gives no way to undo.
    const refreshMeNote = () => {
      let text = "";
      if (isMe) text = t("people.is_me_change_note");
      else if (meName) {
        text = t(isMeEl.checked ? "people.is_me_replaces" : "people.is_me_currently", { me: meName });
      } else if (hasMe) text = t("people.is_me_note");
      isMeNote.textContent = text;
      isMeNote.hidden = !text;
      isMeNote.classList.toggle("field-note-warn", Boolean(meName && !isMe && isMeEl.checked));
    };
    isMeEl.addEventListener("change", refreshMeNote);
    refreshMeNote();

    // Where there is room the confirmed zone sits inside the place field
    // (people-form.css), and the field's own text has to stop short of it.
    const tzHint = bound.els.tzHint;
    if (tzHint && typeof ResizeObserver === "function") {
      new ResizeObserver(() => {
        tzHint.parentElement.style.setProperty("--pf-tz-w", `${tzHint.offsetWidth}px`);
      }).observe(tzHint);
    }

    // Busy disables the whole form, not just the button: a second click on any
    // control mid-save would race the request. Controls that were already
    // disabled (the "this is me" box on the me person, the time field while the
    // time is unknown) stay that way after.
    const setFormBusy = (busy) => {
      form.querySelectorAll("input, select, button").forEach((el) => {
        if (busy) {
          el.dataset.busyRestoreDisabled = el.disabled ? "true" : "false";
          el.disabled = true;
          return;
        }
        el.disabled = el.dataset.busyRestoreDisabled === "true";
        delete el.dataset.busyRestoreDisabled;
      });
      saveBtn.textContent = busy ? t("people.saving") : t("people.save");
      cancelBtn.textContent = t("people.cancel");
    };

    // True when nothing typed would be lost, or the reader chose to lose it.
    // On the form element too, for a page's own leave guard (People.renderNewPerson).
    const confirmDiscard = async () =>
      snapshot() === pristine ||
      !GHD.confirmDialog ||
      GHD.confirmDialog({
        message: t("people.discard_confirm"),
        confirmLabel: t("people.discard"),
        cancelLabel: t("people.keep_editing"),
      });
    form._isDirty = () => snapshot() !== pristine;
    form._confirmDiscard = confirmDiscard;

    cancelBtn.addEventListener("click", async () => {
      if (!(await confirmDiscard())) return;
      if (onCancel) onCancel();
    });

    saveBtn.addEventListener("click", async () => {
      const collected = bound.collect();
      if (collected.error) {
        // A birth time is never blank: an empty time here can only mean
        // Exact/Roughly with nothing typed — which would silently store a
        // time-less record.
        showFieldError(
          collected.field === "date" && bound.els.dateParts
            ? bound.els.dateParts.target()
            : collected.field === "time" && bound.els.timeParts
              ? bound.els.timeParts.target()
              : bound.els[collected.field],
          collected.error === "time"
            ? t("people.time_required")
            : collected.error === "date_range"
              ? PersonForm.birthDateRangeMessage()
              : t("people.fill_all_fields"),
        );
        return;
      }
      // The server geocodes a place only when it moved, so an edit that keeps
      // the stored one is not held up by it.
      const storedPlace = isEdit ? (person?.birth_place || "").trim().toLowerCase() : null;
      if (collected.values.place.toLowerCase() !== storedPlace) {
        saveBtn.disabled = true;
        let go;
        try {
          go = await bound.confirmPlace(collected);
        } finally {
          saveBtn.disabled = false;
        }
        if (!go) return;
      }
      const values = { ...collected.values, isMe: isMeEl.checked };

      setFormBusy(true);
      clearFieldError();
      try {
        if (onSubmit) await onSubmit(values);
      } catch (err) {
        // Deliberately none of the treatment above: a save that failed on the
        // way out is not the user's mistake, so nothing shakes, no field is
        // marked wrong, and the sentence stays up. There is nothing here for
        // them to correct, and a message that cleared itself after three
        // seconds would take the only account of what happened with it.
        // www and the consent page load this form without ui-toast.js.
        errEl.textContent = GHD.errorText ? GHD.errorText(err) : err?.message || t("people.unknown_error");
        errEl.hidden = false;
        setFormBusy(false);
      }
    });

    return form;
  },
};

window.PersonForm = PersonForm;

;
/* js/landing.js */
/* Lazy asset injection — same pattern as dashboard/js/lazy-libs.js: the CSP
 * disallows inline scripts, so only external tags are injected, carrying the
 * same SRI hashes the static tags used to. Lives on the GHD namespace rather
 * than in a local closure because the signup form below reaches for it. */
(function () {
  window.GHD = window.GHD || {};

  GHD.injectScript = function (src, integrity) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = src;
      if (integrity) {
        s.integrity = integrity;
        s.crossOrigin = "anonymous";
      }
      s.onload = function () {
        resolve();
      };
      s.onerror = function () {
        s.remove();
        reject(new Error("Failed to load " + src));
      };
      document.head.appendChild(s);
    });
  };

  // The knowledge base injects this file after DOMContentLoaded has fired
  // (js/chart-form-loader.js says so), and a listener added then never runs.
  GHD.onDomReady = function (fn) {
    if (GHD.domContentLoaded) fn();
    else document.addEventListener("DOMContentLoaded", fn);
  };
})();

/* A script this page needed never arrived.
 *
 * Every tag in this page's head and footer is pinned to the release it was
 * built as — /v/ghd-<sha>/pricing.js and so on — and Cloudflare Pages serves
 * one upload at a time, so the previous release's /v/ tree 404s the moment a
 * deploy lands. A page held in a browser cache across a deploy therefore asks
 * for scripts that are gone, and `defer` reports that to nobody: the tag fires
 * an error event and the chain simply continues without it.
 *
 * Which is how one 404 used to take the page. The handlers below run at
 * DOMContentLoaded and reached straight for `Pricing`, `PersonForm`,
 * `PlaceAutocomplete`, `GHD.trOr` and `GHD.signupSeed`; a bare reference to a
 * name nothing defined throws, and a throw inside a DOMContentLoaded listener
 * kills every line after it. So a missing pricing.js also cost the signup
 * form. Five different messages in `app_errors` — "Pricing is not defined",
 * "PersonForm is not defined", "Cannot read properties of undefined (reading
 * 'read')" — one fault, 1-6 page loads a day.
 *
 * Two things happen here, in this order.
 *
 * **The page reloads, if that is the fix.** A stale release is not a broken
 * deploy: the shell is served no-cache, so asking this origin for "/" says
 * which release is live now, and if it has moved, a reload brings a document
 * whose tags point at a tree that exists. This is the recovery
 * dashboard/js/lazy-libs.js already does on the app origin, for the same 404,
 * arrived at the same way — read its "A file this release's tree no longer
 * serves" for the longer account. Bounded to one reload per live release per
 * tab: if the reloaded page is missing modules too, a stale release was not
 * the cause and a second reload would only be a loop.
 *
 * **And meanwhile the page degrades a feature at a time.** The reload is a
 * network round trip away and may not come at all — a real network failure, or
 * an edge that has not received the deploy yet, leaves this release live and
 * correct. So every caller below takes its module through `GHD.moduleOr`,
 * which answers null rather than throwing, and skips its own feature. A
 * visitor missing pricing.js sees no prices and a signup form that works.
 */
(function () {
  window.GHD = window.GHD || {};

  // Stamped by the deploy like every other `__GHD_VERSION__`; on localhost the
  // placeholder stays, and so does the one in the shell this compares against.
  var RELEASE = "__GHD_VERSION__";
  var RELOAD_KEY = "ghd_stale_release_reload";
  var missing = [];

  function liveRelease(html) {
    var m = /\/v\/([A-Za-z0-9_.-]+)\//.exec(html);
    return m ? m[1] : "";
  }

  /** Reload once if a newer release is live. Never throws, never loops. */
  function reloadIfReleaseMoved() {
    fetch("/", { cache: "no-store" })
      .then(function (res) {
        return res.ok ? res.text() : "";
      })
      .then(function (html) {
        var live = liveRelease(html);
        if (!live || live === RELEASE) return;
        // The try is the bound on the loop, not a formality (GHD.storage is
        // the app's guard and wraps localStorage; this origin loads neither).
        // A browser blocking site data throws on both calls, and a reload we
        // cannot remember making is a reload that makes itself again — so a
        // page that degraded is the answer there. Worse than a reload, far
        // better than a loop.
        try {
          if (sessionStorage.getItem(RELOAD_KEY) === live) return;
          sessionStorage.setItem(RELOAD_KEY, live);
        } catch (_e) {
          return;
        }
        location.reload();
      })
      .catch(function () {
        /* Nothing here is worth failing over: the page has already degraded. */
      });
  }

  /**
   * `value`, or null once it has been recorded that `name` never arrived.
   *
   * Callers read the module themselves — `window.Pricing`, `GHD.signupSeed` —
   * because reading a missing property is `undefined` where a bare `Pricing`
   * is a ReferenceError, and the whole point is to not throw.
   */
  GHD.moduleOr = function (name, value) {
    if (value) return value;
    if (missing.indexOf(name) === -1) missing.push(name);
    if (missing.length === 1) {
      // One report for the page, not one per module: the callers run in the
      // same tick, and five names on one line is the diagnosis. A timeout
      // rather than a microtask, so the second handler's names are on it too.
      // The names ride in the stack, not the message, so every page that loses
      // scripts is one row in app_errors rather than one per combination.
      setTimeout(function () {
        if (GHD.reportClientError) {
          GHD.reportClientError("reported", "deferred script never arrived", "missing: " + missing.join(","), null);
        }
        reloadIfReleaseMoved();
      }, 0);
    }
    return null;
  };

  /**
   * Stand in for `GHD.trOr` when js/i18n-core.js is the script that 404'd.
   *
   * Not a degradation: on this origin that IS the whole of what trOr does. It
   * asks `window.t` first and no www page has one, and every caller here
   * already passes the reader's own sentence, because this page's copy is
   * substituted into data-msg-* attributes at build time rather than looked
   * up at runtime. So the fallback plus `{var}` interpolation is the real
   * answer, byte for byte (js/i18n-core.js, `interpolate`).
   *
   * A stand-in rather than a guard at the call site, because the calls are
   * not ours to guard: PersonForm.bindYoungBirthDateNote reaches for trOr on
   * its way to printing the `text` we hand it, and PlaceAutocomplete
   * .bindPublic does the same for the strings we hand it. A missing
   * i18n-core.js threw inside the first of those and took the whole signup
   * form with it — "GHD.trOr is not a function", on three locales in
   * app_errors. (Codex review, 2026-09-22.)
   *
   * Called from DOMContentLoaded, never from here: this file may run before
   * the rest of the chain has, and then every module looks missing.
   */
  GHD.ensureTrOr = function () {
    if (typeof GHD.trOr === "function") return;
    GHD.moduleOr("GHD.trOr", null);
    GHD.trOr = function (key, fallback, vars) {
      var text = fallback == null ? key : fallback;
      if (!vars) return text;
      return String(text).replace(/\{(\w+)\}/g, function (whole, name) {
        return Object.prototype.hasOwnProperty.call(vars, name) ? vars[name] : whole;
      });
    };
  };
})();

GHD.onDomReady(function () {
  // Shadows the global for this whole handler, so every `Pricing.` below is
  // this one. Assigned in init(), which is the only path that reaches a
  // `Pricing.` call and the only one that has established there are prices on
  // this page at all — see the note there.
  var Pricing = null;

  // The Pro card's period toggle; monthly is the default (docs/internal/decisions.md).
  var billing = "monthly";

  function updatePriceDisplay(currency, inputs) {
    var priceEl = document.getElementById("price-display");
    var noteEl = document.getElementById("price-note");
    if (!priceEl || !noteEl) return;
    // The note's localized strings are #price-note's data-* attributes
    // (substituted per locale at build time via data-i18n-attr): this script is
    // shared across locales, so it can't carry the strings itself.
    var q = Pricing.quote(inputs.charge, currency, inputs.rates, billing, noteEl.dataset);
    priceEl.textContent = q.headline;
    noteEl.textContent = q.note;
    noteEl.hidden = !q.note;

    // The free plan costs nothing in every currency, but it sits beside the Pro
    // card: leaving it at the markup's "€0" while Pro reads "≈ $4.47" puts two
    // currencies on one price table.
    var freeEl = document.getElementById("free-price-display");
    if (freeEl) freeEl.textContent = q.free;

    var toggle = document.getElementById("billing-toggle");
    if (toggle) {
      var save = document.getElementById("billing-save");
      if (save) save.textContent = q.saving;
      toggle.hidden = false;
    }
  }

  // Points the Pro button at the period the toggle shows. Signed in, auth-nav.js
  // leaves a checkout link per period on it; signed out, it is the signup link,
  // whose ?billing= the app carries through to Checkout.
  function syncCheckoutLink() {
    var btn = document.querySelector(".pricing-card.featured .btn-plan");
    if (!btn) return;
    var href = btn.getAttribute(billing === "yearly" ? "data-href-yearly" : "data-href-monthly");
    if (href) {
      btn.href = href;
      return;
    }
    try {
      var url = new URL(btn.href);
      if (!url.searchParams.has("billing")) return;
      url.searchParams.set("billing", billing);
      btn.href = url.toString();
    } catch (e) {}
  }

  function init() {
    /* The selector decides whether this page has prices, and it is checked
     * FIRST — before pricing.js is so much as asked for. Every knowledge-base
     * article loads this file and deliberately does not load pricing.js
     * (tools/build/build_docs.py), so asking up here would report a missing
     * module on all 209 × 9 of them, spend a shell fetch on each, and reload a
     * cached one after every deploy for a script it never wanted. Which is
     * also why the old bare `Pricing.getSelectedCurrency()` was survivable at
     * all: this return is what kept it from being reached.
     * (Codex review, 2026-09-22.) */
    var selector = document.getElementById("currency-selector");
    if (!selector) return;

    Pricing = GHD.moduleOr("Pricing", window.Pricing);
    if (!Pricing) return;

    var current = Pricing.getSelectedCurrency();
    // The geo-IP answer, the rates and the charge, once all three are in. The
    // price waits for them, so a first visit is painted once, in the currency
    // geo-IP settles on, rather than in a guess and then again.
    var inputs = null;
    var picked = false;

    function paint() {
      if (inputs) updatePriceDisplay(current, inputs);
    }

    var toggle = document.getElementById("billing-toggle");
    if (toggle) {
      toggle.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-billing]");
        if (!btn || btn.dataset.billing === billing) return;
        billing = btn.dataset.billing;
        toggle.querySelectorAll("[data-billing]").forEach(function (b) {
          b.setAttribute("aria-pressed", String(b === btn));
        });
        syncCheckoutLink();
        paint();
      });
    }

    // Localized picker strings, substituted per locale onto the selector's
    // data-* attributes at build time — /pricing.js is one file for all seven.
    var picker = Pricing.mountPicker(selector, {
      value: current,
      labels: {
        header: selector.dataset.labelHeader,
        search: selector.dataset.labelSearch,
        empty: selector.dataset.labelEmpty,
      },
      onSelect: function (code) {
        picked = true;
        current = code;
        paint();
      },
    });

    // Four requests (the geo lookup, two rate sources and the charge) nobody
    // needs until the price table is near: they start a screen or two before it
    // scrolls in.
    function price() {
      Pricing.loadPriceInputs().then(function (got) {
        // A currency picked while they loaded is the reader's, not geo-IP's.
        if (!picked) {
          current = got.currency;
          picker.set(current);
        }
        inputs = got;
        paint();
      });
    }
    if (!("IntersectionObserver" in window)) return price();
    var io = new IntersectionObserver(
      function (entries) {
        if (
          !entries.some(function (e) {
            return e.isIntersecting;
          })
        )
          return;
        io.disconnect();
        price();
      },
      { rootMargin: "1500px 0px" },
    );
    // Not the picker itself: a Pro reader's card hides it, and a display:none
    // target never intersects.
    io.observe(document.getElementById("pricing") || selector);
  }

  init();
});

(function () {
  var faqList = document.querySelector(".faq-list");
  if (!faqList) return;
  faqList.querySelectorAll(".faq-question").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var item = btn.closest(".faq-item");
      var isOpen = item.classList.contains("open");
      faqList.querySelectorAll(".faq-item.open").forEach(function (openItem) {
        openItem.classList.remove("open");
        openItem.querySelector(".faq-question").setAttribute("aria-expanded", "false");
      });
      if (!isOpen) {
        item.classList.add("open");
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });
})();

/* The FAQ ships twelve answers but opens on the five that decide a signup; the
 * rest stay in the DOM — hidden in CSS, never removed — so the FAQPage
 * structured data still describes the whole page. */
(function () {
  var more = document.getElementById("faq-more");
  var list = document.getElementById("faq-list");
  if (!more || !list) return;
  more.addEventListener("click", function () {
    var expanded = list.classList.toggle("faq-list-expanded");
    more.setAttribute("aria-expanded", String(expanded));
    more.textContent = expanded ? more.dataset.less : more.dataset.more;
    // Collapsing from far down the list would otherwise leave the reader
    // staring at the footer.
    if (!expanded) more.scrollIntoView({ block: "center", behavior: "smooth" });
  });
})();

/** Synchronize app strip controls with whether its screen row actually overflows. */
function updateAppStripOverflowControls(track, strip, navs, progress, bar) {
  var max = Math.max(0, track.scrollWidth - track.clientWidth);
  var hasOverflow = max > 1;
  var ratio = Math.min(1, track.clientWidth / track.scrollWidth);

  navs.forEach(function (btn) {
    btn.hidden = !hasOverflow;
  });
  if (progress) progress.hidden = !hasOverflow;
  if (bar) {
    bar.style.width = (ratio * 100).toFixed(2) + "%";
    bar.style.left = hasOverflow ? ((track.scrollLeft / max) * (100 - ratio * 100)).toFixed(2) + "%" : "0%";
  }
  strip.classList.toggle("at-start", !hasOverflow || track.scrollLeft < 4);
  strip.classList.toggle("at-end", !hasOverflow || max - track.scrollLeft < 4);
}

/* The app strip — arrows, a progress rail, tap-to-enlarge, and the dark-theme
 * screenshots.
 *
 * Scrolling and snapping are pure CSS; this only adds what CSS cannot do. The
 * arrows start [hidden] in the markup so a no-JS visitor never sees a dead
 * control. */
(function () {
  var track = document.getElementById("app-strip-track");
  if (!track) return;
  var strip = track.closest(".app-strip");
  var screens = Array.prototype.slice.call(track.querySelectorAll(".app-screen"));
  var bar = document.getElementById("app-strip-bar");
  var progress = bar ? bar.parentElement : null;
  var navs = strip.querySelectorAll(".app-strip-nav");
  var smooth = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";

  /* One chapter per click. Measured rather than assumed, because the phones and
   * both gaps shrink on a narrow screen — and because a step of "three phones"
   * would now fall short by one chapter gap and leave the strip drifting a
   * little further out of alignment with every press. */
  function chapterStep() {
    var gap = parseFloat(getComputedStyle(track).columnGap) || 44;
    var chapter = track.querySelector(".app-chapter");
    if (chapter) return chapter.getBoundingClientRect().width + gap;
    var screen = track.querySelector(".app-screen");
    return ((screen ? screen.getBoundingClientRect().width : 158) + gap) * 3;
  }

  navs.forEach(function (btn) {
    btn.addEventListener("click", function () {
      track.scrollBy({ left: chapterStep() * Number(btn.dataset.step), behavior: smooth });
    });
  });

  function update() {
    updateAppStripOverflowControls(track, strip, navs, progress, bar);
  }
  track.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  update();

  /* Dark theme gets the dark captures. Each <picture> picks by
   * prefers-color-scheme, because the lazy images are fetched before this
   * deferred script runs. The site's theme can be an explicit choice the media
   * query knows nothing about, so from here on the source follows data-theme. */
  function swapHref(el, dark) {
    if (!el.dataset.light) el.dataset.light = el.getAttribute("href");
    el.setAttribute("href", el.dataset[dark ? "dark" : "light"] || el.dataset.light);
  }
  var section = strip.closest(".features");
  function syncShots() {
    var dark = document.documentElement.getAttribute("data-theme") === "dark";
    var media = dark ? "all" : "not all";
    section.classList.toggle("shots-dark", dark);
    screens.forEach(function (screen) {
      var source = screen.querySelector("source");
      if (source && source.getAttribute("media") !== media) source.setAttribute("media", media);
      swapHref(screen, dark);
    });
  }
  syncShots();
  new MutationObserver(syncShots).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-theme"],
  });

  /* Enlarge on tap — the honest answer to "those screens are too small". It stays
   * a phone on a dimmed page: a bare full-bleed image reads as "the app opened".
   * <dialog>.showModal() carries Esc, the focus trap and the backdrop; the rest
   * is paging. Without JS the anchor still opens the image on its own. */
  var viewer = document.getElementById("shot-viewer");
  if (!viewer || !viewer.showModal) return;
  var viewerImg = document.getElementById("shot-viewer-img");
  var viewerCaption = document.getElementById("shot-viewer-caption");
  var current = 0;

  function show(index) {
    current = (index + screens.length) % screens.length;
    var screen = screens[current];
    var img = screen.querySelector("img");
    viewerImg.src = screen.getAttribute("href");
    viewerImg.alt = img.alt;
    // The strip's own micro-caption, so the enlarged screen is named the same
    // way it was named in the row. A caption that carries a Pro chip wraps its
    // words in the translated span, and that span is what is read: textContent
    // on the caption itself would name the screen "Today's transitsPro".
    var caption = screen.querySelector(".app-screen-caption");
    var named = caption && (caption.querySelector("[data-i18n]") || caption);
    viewerCaption.textContent = named ? named.textContent : "";
    // Keep the strip on the screen being viewed, so closing lands where you are.
    screen.scrollIntoView({ behavior: "auto", block: "nearest", inline: "center" });
  }

  track.addEventListener("click", function (e) {
    var screen = e.target.closest(".app-screen");
    if (!screen) return;
    e.preventDefault();
    show(screens.indexOf(screen));
    viewer.showModal();
  });

  viewer.querySelectorAll("[data-viewer-step]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      show(current + Number(btn.dataset.viewerStep));
    });
  });

  viewer.querySelector("[data-viewer-close]").addEventListener("click", function () {
    viewer.close();
  });

  // A click on the dialog itself is a click beside the phone, so it closes.
  viewer.addEventListener("click", function (e) {
    if (e.target === viewer) viewer.close();
  });

  viewer.addEventListener("keydown", function (e) {
    if (e.key === "ArrowLeft") show(current - 1);
    if (e.key === "ArrowRight") show(current + 1);
  });

  var touchX = null;
  viewer.addEventListener(
    "touchstart",
    function (e) {
      touchX = e.changedTouches[0].clientX;
    },
    { passive: true },
  );
  viewer.addEventListener(
    "touchend",
    function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 45) show(current + (dx < 0 ? 1 : -1));
    },
    { passive: true },
  );
})();

if ("serviceWorker" in navigator && location.hostname !== "localhost") {
  // The .catch() is not optional. A registration the browser or a privacy
  // extension refuses rejects, and an unhandled rejection is exactly what
  // error-reporter.js listens for — so every such visitor filed an `app_errors`
  // row reading only "Rejected". Sixteen arrived in the first hour after www's
  // reporter started delivering (2026-09-20). Nothing is broken when this
  // fails: the service worker is a cache, the page works without it, and there
  // is no user to tell.
  navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).catch(function () {});
}

/* The review wall — shuffled, and arrowed for pointers that cannot swipe.
 *
 * Scrolling and snapping are pure CSS; this adds the two things CSS cannot do.
 *
 * The shuffle moves the quotes between the cards, and never the cards
 * themselves. Moving cards is the obvious way to do it and the wrong one: this
 * is a `scroll-snap-type: x mandatory` container, which holds on to the card
 * it is snapped to and re-asserts that hold on every layout pass while the
 * page finishes loading. Move that card and the row arrives parked several
 * quotes in, with a back arrow on a row nobody has scrolled — and no reset
 * survives to the load event. Nothing moves here, so there is nothing to
 * re-snap: the row always opens on its first card.
 *
 * The arrows start [hidden] in the markup, so a no-JS visitor never sees a
 * dead control — they swipe, and the cut-off card already says there is more. */
(function () {
  var track = document.querySelector(".trust-reviews");
  if (!track) return;
  var carousel = track.closest(".trust-carousel");
  var cards = Array.prototype.slice.call(track.querySelectorAll(".trust-review"));
  var navs = carousel.querySelectorAll(".trust-nav");
  var smooth = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";

  var quotes = cards.map(function (card) {
    return {
      quote: card.querySelector("p:not(.trust-stars)").innerHTML,
      cite: card.querySelector("cite").innerHTML,
    };
  });
  for (var i = quotes.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var swap = quotes[i];
    quotes[i] = quotes[j];
    quotes[j] = swap;
  }
  cards.forEach(function (card, index) {
    card.querySelector("p:not(.trust-stars)").innerHTML = quotes[index].quote;
    card.querySelector("cite").innerHTML = quotes[index].cite;
  });

  /* As many whole cards as are on screen, so a click turns the page rather
     than nudging it. */
  function pageStep() {
    var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
    var width = (cards[0] ? cards[0].getBoundingClientRect().width : 300) + gap;
    return Math.max(1, Math.floor(track.clientWidth / width)) * width;
  }

  navs.forEach(function (btn) {
    btn.addEventListener("click", function () {
      track.scrollBy({ left: pageStep() * Number(btn.dataset.step), behavior: smooth });
    });
  });

  function update() {
    updateAppStripOverflowControls(track, carousel, navs, null, null);
  }
  track.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  update();
})();

(function () {
  var installBtns = [document.getElementById("hero-install-btn"), document.getElementById("mobile-install-btn")].filter(
    Boolean,
  );
  if (!installBtns.length) return;

  // Until the App Store launch (GHD_APP.APP_STORE_LIVE), iPhone and iPad keep
  // Add to Home Screen: the button opens the instructions overlay, which only
  // the prelaunch build of the page carries. Deleted with the switch.
  function showAddToHomeScreen(btns) {
    var overlay = document.getElementById("pwa-ios-overlay");
    var closeBtn = document.getElementById("pwa-ios-close");
    if (!overlay) return;
    btns.forEach(function (b) {
      b.hidden = false;
      b.addEventListener("click", function () {
        overlay.hidden = false;
        requestAnimationFrame(function () {
          overlay.classList.add("visible");
        });
      });
    });
    function closeOverlay() {
      overlay.classList.remove("visible");
      setTimeout(function () {
        overlay.hidden = true;
      }, 200);
    }
    if (closeBtn) closeBtn.addEventListener("click", closeOverlay);
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeOverlay();
    });
  }

  var isStandalone = window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true;
  if (isStandalone) return;

  // The store badges are in the markup, and theme.js's ua-ios / ua-android class
  // decides which of them a phone sees. A phone gets its store's app, never the
  // web app: only a desktop browser that offers beforeinstallprompt is shown the
  // install button.
  var root = document.documentElement.classList;
  if (root.contains("ua-ios") && !(window.GHD_APP && window.GHD_APP.APP_STORE_LIVE)) {
    showAddToHomeScreen(installBtns);
    return;
  }
  if (root.contains("ua-ios") || root.contains("ua-android")) return;

  var deferredPrompt = null;
  window.addEventListener("beforeinstallprompt", function (e) {
    e.preventDefault();
    deferredPrompt = e;
    installBtns.forEach(function (b) {
      b.hidden = false;
    });
  });
  installBtns.forEach(function (b) {
    b.addEventListener("click", function () {
      if (deferredPrompt) {
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then(function () {
          deferredPrompt = null;
        });
      }
    });
  });
})();

/* ── Homepage signup form ─────────────────────────
 * Collects birth details + optional first name and creates a Supabase
 * account (Google OAuth or email+password). Birth details are
 * stashed in localStorage so the app's post-auth handler can finish
 * onboarding automatically and seed an "Explain my design" chat.
 */
GHD.onDomReady(function () {
  // The birth details this form collects are handed to the app through
  // GHD.signupSeed (/js/signup-seed.js), which owns the storage keys, the TTL
  // and what counts as a usable seed for every page on both origins.
  // The Supabase project, the API base and the app origin all come from
  // /app-config.js (window.GHD_APP), which this page loads first.
  var SUPABASE_URL = GHD_APP.SUPABASE_URL;
  var SUPABASE_ANON_KEY = GHD_APP.SUPABASE_ANON_KEY;
  var API = GHD_APP.API_BASE_URL;
  // Where Supabase sends the user back after email confirmation / OAuth. The app
  // is its own origin now, so this is no longer location.origin — and every value
  // it can take must be listed in supabase/config.toml's additional_redirect_urls,
  // or Supabase silently falls back to the project Site URL.
  //
  // Supabase must redirect to the *app* origin directly, not via /go/: it returns
  // the session in the URL for supabase-js to pick up, and only the app origin
  // runs supabase-js.
  //
  // That direct hop leaves the birth-details seed behind on this origin, which
  // would land the user on an empty onboarding form. It costs nothing today,
  // because the confirmation round trip does not happen: the project runs with
  // mailer_autoconfirm on (supabase/config.toml, [auth.email]
  // enable_confirmations = false), so signUp always returns a session and takes
  // the /go/ branch below. Turning confirmations on is what would expose it, and
  // the fix is not a one-liner: /go/ would have to forward Supabase's own
  // #access_token= fragment alongside its #ghd_handoff= payload (app.js keys on
  // the first characters of each), the www /go/ URL would need its own exact
  // entry in additional_redirect_urls, and none of it survives a move to the
  // PKCE flow, whose code verifier is origin-scoped to whoever called signUp.
  var DASHBOARD_RETURN = GHD_APP.appUrl("/");

  // The handoff hop on this origin. Everything this page stashed in localStorage
  // — the birth-details seed above all — lives on www and is invisible to the app,
  // so a signup that jumps straight to the app origin arrives with nothing and
  // asks the user for the details they just typed. /go/ carries them across.
  function goUrl(route) {
    return "/go/?to=" + encodeURIComponent(route);
  }

  var form = document.getElementById("chart-form-el");
  if (!form) return;

  /* Where visitors leave this form: one anonymous row per step per page load
   * in signup_form_events. `visit` is a random id held in page memory only —
   * never stored, never sent with an account — so the steps of one page load
   * can be counted together and nothing more. */
  var funnelVisit =
    GHD.chartFormVisit ||
    (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now());
  var funnelSent = {};
  // `make serve` writes to production's database, so a local click would count.
  var funnelOff = location.hostname === "localhost" || location.hostname === "127.0.0.1";
  // The page whose form this signup went through, read back by dashboard/js/api.js
  // at onboarding. The last form submitted wins: that is the page that converted.
  function rememberSignupPage() {
    try {
      localStorage.setItem("ghd_signup_page", JSON.stringify({ v: location.pathname, t: Date.now() }));
    } catch (e) {
      /* no storage: the signup still works, it just goes unattributed */
    }
  }
  function track(step, detail) {
    var key = step + ":" + (detail || "");
    if (funnelSent[key] || !API || funnelOff) return;
    funnelSent[key] = true;
    try {
      fetch(API + "/v1/signup-form-event", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        keepalive: true,
        body: JSON.stringify({
          visit: funnelVisit,
          step: step,
          detail: detail || null,
          surface: /\/docs\//.test(location.pathname) ? "kb" : "landing",
          locale: document.documentElement.lang || "en",
          // The article, named by js/chart-form-loader.js; landing pages have none.
          page: GHD.chartFormPage || null,
        }),
      }).catch(function () {});
    } catch (e) {
      /* a lost step is a gap in a count, never a broken form */
    }
  }
  // The knowledge-base prompt after an article's intro links here; a click on it
  // is counted apart from a scroll, which `viewed` cannot tell.
  document.addEventListener("click", function (e) {
    var link = e.target && e.target.closest && e.target.closest('a[href="#chart-form"]');
    if (link) track("jumped");
  });
  // Steps a restored seed takes without the visitor wait here for `viewed`: a
  // signed-in reader's form is hidden and never seen, yet its seed restores.
  var afterViewed = [];
  function whenViewed(fn) {
    if (afterViewed) afterViewed.push(fn);
    else fn();
  }
  function markViewed() {
    track("viewed");
    var queued = afterViewed || [];
    afterViewed = null;
    queued.forEach(function (fn) {
      fn();
    });
  }
  // On the knowledge base the loader watched the form from page load and may
  // have seen it, or a jump to it, before this file arrived.
  if (GHD.chartFormJumped) track("jumped");
  if (GHD.chartFormSeen) {
    markViewed();
  } else if ("IntersectionObserver" in window) {
    var seenIo = new IntersectionObserver(
      function (entries) {
        if (
          !entries.some(function (e) {
            return e.isIntersecting;
          })
        )
          return;
        seenIo.disconnect();
        markViewed();
      },
      { threshold: 0.3 },
    );
    seenIo.observe(form);
  } else {
    afterViewed = null;
  }

  /* The three modules this form is built out of, each shadowing its global for
   * the rest of the handler, and each missing in its own way.
   *
   * PersonForm is the one the form cannot do without: the birth-date bounds,
   * the "(not sure?)" rule and `seedFrom` are all its, so without it there is
   * no seed to collect and no honest way to accept a submit. The other two
   * degrade — a place field with no dropdown still takes a typed place, and a
   * signup with no seed still creates the account; onboarding then asks for
   * the birth details on the app side, which is where they were going. */
  // Before PersonForm is touched: bindYoungBirthDateNote calls GHD.trOr on its
  // first line, and a missing i18n-core.js would throw there.
  GHD.ensureTrOr();
  var PersonForm = GHD.moduleOr("PersonForm", window.PersonForm);
  var PlaceAutocomplete = GHD.moduleOr("PlaceAutocomplete", window.PlaceAutocomplete);
  var realSeedStore = GHD.moduleOr("GHD.signupSeed", GHD.signupSeed);
  /* Reading nothing and writing nothing is the easy half. Dropping what is
   * already there is the half that matters: a seed from an abandoned signup
   * outlives the visit, /go/ carries it to the app whatever route it is sent
   * to, and _finishPendingSignup acts on a seed it finds. A no-op `clear`
   * would therefore onboard the account created here with the birth details
   * of whoever last started and did not finish — on a shared device, somebody
   * else's, silently, and a wrong is_me cannot be corrected from the app.
   * (Codex review, 2026-09-22.)
   *
   * The two key names are signup-seed.js's to own and are spelled again here
   * only because the file that owns them is the one that is missing. They are
   * held to its copies by landing-stale-release.test.js, the same way
   * signup-seed-handoff.test.js holds site/go/'s. */
  var signupSeed = realSeedStore || {
    read: function () {
      return null;
    },
    readEmail: function () {
      return null;
    },
    write: function () {
      this.clear();
    },
    writeEmail: function () {},
    clear: function () {
      try {
        localStorage.removeItem("ghd_signup_birth_data");
        localStorage.removeItem("ghd_signup_email");
      } catch (_e) {
        /* Blocked site data holds no stale seed to drop either. */
      }
    },
  };

  /* Where a finished signup lands.
   *
   * /chat, normally: the app reads the seed this form wrote and finishes the
   * onboarding off it before painting (dashboard/js/app.js
   * _finishPendingSignup), so the reader arrives with a chart.
   *
   * But that function returns immediately when there is no seed, and with the
   * stand-in above there is none — so /chat would be a new account dropped
   * into a conversation about a bodygraph it does not have, which is the one
   * state this app must not put someone in. /onboarding asks for the birth
   * details instead, which is what the seed existed to save them typing.
   * (Codex review, 2026-09-22.) */
  var afterSignup = realSeedStore ? "/chat" : "/onboarding";

  if (!PersonForm) {
    /* A form left unwired is worse than no form. The email pane's button falls
     * through to a native submit, which reloads this page with the birth
     * details in the query string and creates nothing; the Google button and
     * the email link are `type="button"` and do nothing at all — and Google is
     * the control almost everybody reaches for. (Codex review, 2026-09-22: the
     * first version of this took only the submit.)
     *
     * So every way out of this form goes to the app's own signup, which is a
     * working form — the same place this one sends people anyway, one
     * re-typing later. Through /go/, because that hop is what carries this
     * origin's localStorage across the split. */
    var leaveForAppSignup = function (e) {
      e.preventDefault();
      window.location.href = goUrl("/signup");
    };
    form.addEventListener("submit", leaveForAppSignup);
    document.querySelectorAll("[data-auth-provider], #cf-email-toggle").forEach(function (btn) {
      btn.addEventListener("click", leaveForAppSignup);
    });
    return;
  }

  /* Localized runtime strings.
   *
   * This file is served to every locale, so it cannot carry user-facing copy.
   * The strings ride on the form as data-msg-* attributes, substituted per
   * locale at build time (see the data-i18n-attr marker in
   * frontend_web/partials/chart-form.html); the English argument below is the
   * fallback if a build ever drops one. */
  function msg(name, fallback) {
    return form.dataset[name] || fallback;
  }

  var dateEl = document.getElementById("cf-date");
  var dateDisp = document.getElementById("cf-date-display");
  /* The birth dates a chart can be cast for, put on the field from PersonForm so
   * the app and this page cannot bound it differently. Set here rather than in
   * the partial because the ceiling is five years from today, and this page is
   * built once and then served from cache for weeks. */
  PersonForm.applyBirthDateBounds(dateEl);

  /* Day and month lists and a typed year stand in for #cf-date, which stays
   * the one value the rest of this form reads (PersonForm.bindDateParts). */
  var dateParts = (PersonForm.bindDateParts && PersonForm.bindDateParts(dateEl)) || {
    els: [],
    pull: function () {},
    focus: function () {
      dateEl.focus();
    },
  };
  /* This form seeds the account holder's own birth data, so it asks the same
   * question the app's signup forms do when the year looks like the one the
   * date wheel opened on. The rule comes from PersonForm; the sentence comes off
   * the form, because PersonForm reaches for it through GHD.trOr and no www page
   * loads an i18n runtime for trOr to ask — it answered English here on every
   * locale until 2026-09-21. */
  PersonForm.bindYoungBirthDateNote({
    dateEl: dateEl,
    noteEl: document.getElementById("cf-date-note"),
    text: msg("msgBirthDateRecent", "That birth date is less than {years} years ago. Is the year right?"),
  });
  var timeEl = document.getElementById("cf-time");
  var timeSaidEl = document.getElementById("cf-time-said");
  var timeUnsureEl = document.getElementById("cf-time-unsure");
  var timeUndoEl = document.getElementById("cf-time-undo");
  var noTimeHintEl = document.getElementById("cf-no-time-hint");
  var placeEl = document.getElementById("cf-place");
  var tzEl = document.getElementById("cf-tz");
  var emailEl = document.getElementById("cf-email");
  var passwordEl = document.getElementById("cf-password");
  var submitLabelEl = document.getElementById("cf-submit-label");
  var errorEl = document.getElementById("cf-error");
  var successEl = document.getElementById("cf-success");
  var resumeBanner = document.getElementById("cf-resume-banner");
  var resumeReset = document.getElementById("cf-resume-reset");
  // The label already sits in the markup in the page's own language.
  var submitDefaultLabel = submitLabelEl ? submitLabelEl.textContent.trim() : "";

  /* Lazy Supabase client.
   *
   * The supabase-js UMD build is ~43 KB gzipped and only the signup form needs
   * it, so it is injected on demand instead of shipped to every landing-page
   * visitor. The warm-up below starts the fetch the moment someone engages with
   * the form, so it overlaps their typing and is long finished by submit time;
   * the submit paths await it regardless. */
  // The app's vendored copy, which www keeps because this line names it
  // (build_site.py, www_dashboard_keep_list).
  var SUPABASE_SDK_SRC = "/v/__GHD_VERSION__/dashboard/js/vendor/supabase.min.js";
  var SDK_ERROR = msg("msgSdk", "Couldn't load the signup library. Please check your connection and try again.");
  var supabaseClient = null;
  var supabaseSdk = null;

  function loadSupabaseSdk() {
    if (!supabaseSdk) {
      supabaseSdk =
        typeof supabase !== "undefined" && supabase.createClient
          ? Promise.resolve()
          : GHD.injectScript(SUPABASE_SDK_SRC).catch(function (err) {
              supabaseSdk = null; // a flaky network shouldn't poison the retry
              throw err;
            });
    }
    return supabaseSdk;
  }

  /* Resolves with the client; rejects only when the SDK itself can't load. */
  function getSupabase() {
    return loadSupabaseSdk().then(function () {
      if (!supabaseClient)
        supabaseClient = supabase.createClient(SUPABASE_URL, SUPABASE_ANON_KEY, { auth: { flowType: "pkce" } });
      return supabaseClient;
    });
  }

  ["focusin", "pointerdown", "input"].forEach(function (evt) {
    form.addEventListener(
      evt,
      function () {
        loadSupabaseSdk().catch(function () {}); // surfaced at submit time instead
      },
      { once: true },
    );
  });

  // A check that names one field shows its error under that field and marks it;
  // anything else (the server, the network) stays under the buttons.
  var errorHome = errorEl && errorEl.parentNode;
  var errorHomeNext = errorEl && errorEl.nextSibling;
  var invalidEls = [];
  function clearStatus() {
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = "";
      errorEl.classList.remove("is-field");
      if (errorHome && errorEl.parentNode !== errorHome) errorHome.insertBefore(errorEl, errorHomeNext);
    }
    invalidEls.forEach(function (el) {
      el.removeAttribute("aria-invalid");
    });
    invalidEls = [];
    if (successEl) {
      successEl.hidden = true;
      successEl.innerHTML = "";
    }
  }

  /* `text`, not `msg`: naming the parameter `msg` shadowed the translation
   * helper of the same name, so the "Sign in instead" lookup below called a
   * string and threw. The throw was caught by the submit handler's own
   * .catch(), which then printed the TypeError where the explanation belongs —
   * and only ever on the one path that passes signInLink, i.e. the person who
   * already has an account. */
  function showError(text, opts) {
    opts = opts || {};
    if (!errorEl) return;
    clearStatus();
    var fields = (opts.fields || []).filter(Boolean);
    var fieldBox = fields.length && fields[0].closest(".chart-form-field");
    if (fieldBox) {
      fieldBox.appendChild(errorEl);
      errorEl.classList.add("is-field");
      fields.forEach(function (el) {
        el.setAttribute("aria-invalid", "true");
      });
      invalidEls = fields;
    }
    errorEl.appendChild(document.createTextNode(text));
    if (opts.signInLink) {
      errorEl.appendChild(document.createTextNode(" "));
      var a = document.createElement("a");
      a.href = GHD_APP.appUrl("/login");
      a.textContent = msg("msgSignInInstead", "Sign in instead");
      errorEl.appendChild(a);
    }
    errorEl.hidden = false;
    if (successEl) successEl.hidden = true;
    if (fieldBox) {
      fieldBox.scrollIntoView({ block: "center", behavior: "smooth" });
      (opts.focus || fields[0].focus.bind(fields[0]))({ preventScroll: true });
    } else {
      errorEl.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
  }

  function showSuccess(title, body) {
    if (!successEl) return;
    successEl.innerHTML = "";
    var t = document.createElement("strong");
    t.textContent = title;
    successEl.appendChild(t);
    // The space belongs to the layout, not to the sentence — a translated body
    // that starts with one would lose it to JSON trimming or a tidy editor.
    if (body) successEl.appendChild(document.createTextNode(" " + body));
    successEl.hidden = false;
    if (errorEl) errorEl.hidden = true;
  }

  function setBusy(isBusy, label) {
    if (submitLabelEl) {
      submitLabelEl.textContent = isBusy
        ? label || msg("msgBusyCreating", "Creating account\u2026")
        : submitDefaultLabel;
    }
    document.querySelectorAll(".chart-form-auth-social-btn").forEach(function (b) {
      b.disabled = isBusy;
    });
  }

  /* Date confirmation display — spelled out in the language the page is
   * written in, not the one the browser happens to be set to. Someone reading
   * /it/ on an English-configured browser was told their birthday back as
   * "January 15, 1990" in the middle of an otherwise Italian form. */
  function updateDateDisplay() {
    if (!dateDisp) return;
    var d = new Date(dateEl.value + "T00:00");
    if (isNaN(d.getTime())) {
      dateDisp.textContent = "";
      return;
    }
    var opts = { year: "numeric", month: "long", day: "numeric" };
    var pageLang = document.documentElement.lang;
    // Gregorian years on a Thai page too (GHD.i18n.intlTag).
    if (pageLang && window.GHD && GHD.i18n && GHD.i18n.intlTag) pageLang = GHD.i18n.intlTag(pageLang);
    try {
      dateDisp.textContent = d.toLocaleDateString(pageLang || navigator.language, opts);
    } catch (_) {
      // An unusable lang attribute must not cost the reader the date itself.
      dateDisp.textContent = d.toLocaleDateString(navigator.language, opts);
    }
  }
  dateEl.addEventListener("change", updateDateDisplay);

  /* The time read back under the boxes, "✓ 2:35 PM (afternoon, 14:35)", in the
   * page's own words: birth-format.js asks GHD.trOr, which has no catalog here. */
  var CLOCK_WORDS = {
    "chart.clock_hint_style": msg("msgClockStyle", "12h"),
    "chart.clock_am": msg("msgClockAm", "{hour} AM"),
    "chart.clock_pm": msg("msgClockPm", "{hour} PM"),
    "chart.clock_12h": msg("msgClockTwelve", "{time} ({part})"),
    "chart.clock_12h_24h": msg("msgClockTwelveBoth", "{time} ({part}, {clock})"),
    "chart.clock_midnight": msg("msgClockMidnight", "midnight"),
    "chart.clock_noon": msg("msgClockNoon", "noon"),
    "chart.clock_part_night": msg("msgClockNight", "night"),
    "chart.clock_part_morning": msg("msgClockMorning", "morning"),
    "chart.clock_part_afternoon": msg("msgClockAfternoon", "afternoon"),
    "chart.clock_part_evening": msg("msgClockEvening", "evening"),
  };
  function clockSay(key, fallback, vars) {
    var text = CLOCK_WORDS[key] || fallback;
    return text.replace(/\{(\w+)\}/g, function (whole, name) {
      return vars && name in vars ? vars[name] : whole;
    });
  }
  var refreshTimeSaid = GHD.bindBirthTimeHint
    ? GHD.bindBirthTimeHint(timeEl, timeSaidEl, { say: clockSay, part: true })
    : function () {};

  /* The birth time as HH : MM, with "I'm not sure" beside its label —
   * PersonForm's rules, shared with the app's own signup form: the link hides
   * the boxes and says noon is used instead, and the ⓧ in that note undoes it. */
  var timeParts = (PersonForm.bindTimeParts && PersonForm.bindTimeParts(timeEl)) || null;
  var confidence = PersonForm.bindTimeConfidence({
    timeEl: timeEl,
    timeBoxEl: timeParts ? timeParts.box : timeEl,
    timeHintEl: timeSaidEl,
    refreshTimeHint: refreshTimeSaid,
    noteEl: noTimeHintEl,
    unsureEl: timeUnsureEl,
    undoEl: timeUndoEl,
    onChange: function () {
      if (errorEl && !errorEl.hidden) clearStatus();
    },
  });

  /* Resume banner \u2014 driven by live form state, not by localStorage alone.
   * After restoring a seed we check the actual input values; if anything
   * went wrong (browser rejected the date format, value got cleared
   * elsewhere, user edits the field later) the banner stays in sync. */
  var restoredSeed = false;
  function syncResumeBanner() {
    if (!resumeBanner) return;
    var hasDate = !!dateEl.value;
    var hasPlace = placeEl.value.trim().length > 0;
    // Only a seed from an earlier visit is something to pick up again; details
    // typed on this visit are just the form being filled.
    resumeBanner.hidden = !(restoredSeed && hasDate && hasPlace);
  }

  /* Place autocomplete. PlaceAutocomplete.bindPublic owns the anonymous device
   * id the geocoder rate-limits on and the public endpoint itself, so this page,
   * the app's /signup and the OAuth consent screen all ask the same way. The
   * hint here is the marketing form's own tick-plus-zone line rather than the
   * app's "Timezone: \u2026", so it supplies the sentence and the class. */
  var placeTz = !PlaceAutocomplete
    ? /* No dropdown and no timezone, but the field still takes a typed place
       * and the seed still crosses. `timezone` is optional the whole way down
       * (people-form.seedFrom passes it through, signup-seed stores whatever
       * text it gets), so onboarding asks for the place again rather than
       * getting it wrong. */
      { set: function () {}, timezone: null }
    : PlaceAutocomplete.bindPublic(placeEl, {
        apiBase: API,
        hint: tzEl,
        hintClass: "chart-form-tz",
        format: function (timezone) {
          return "\u2713 " + timezone;
        },
        onSelect: function () {
          placeEl.classList.add("is-valid");
        },
        onNarrow: function () {
          placeEl.classList.remove("is-valid");
        },
        // A place typed and left without a pick is what the server would geocode
        // silently; putting its first match in the field lets it be corrected.
        confirmOnBlur: true,
        /* The dropdown's own six lines. bindPublic falls back to GHD.trOr, which
         * on this page has no runtime to ask and would answer English on /nl/ and
         * every other locale \u2014 so they come off the form like the rest of the
         * runtime copy here. Supplying the set at all means supplying ALL of it: a
         * line left out of this object is `undefined` in the dropdown, not the
         * English default. */
        strings: function () {
          return {
            searching: msg("msgPlaceSearching", "Searching\u2026"),
            noResults: msg("msgPlaceNoResults", "No locations found"),
            rateLimited: msg(
              "msgPlaceRateLimited",
              "Too many searches in a row \u2014 wait a moment, then keep typing.",
            ),
            busy: msg("msgPlaceBusy", "The place search is busy \u2014 wait a moment, then keep typing."),
            error: msg("msgPlaceError", "Couldn't search just now. Check your connection and try again."),
            countryNarrow: msg(
              "msgPlaceCountryNarrow",
              "Spans about {hours} hours of clock time \u2014 add a city or region",
            ),
          };
        },
      });

  // Green means a known zone, never just text in the field.
  function markPlaceConfirmed() {
    placeEl.classList.toggle("is-valid", !!placeTz.timezone);
  }
  placeEl.addEventListener("input", markPlaceConfirmed);
  if (PersonForm.bindPlaceClear) PersonForm.bindPlaceClear(placeEl, { label: msg("msgPlaceClear", "Clear place") });

  /* Pick up where the visitor left off. GHD.signupSeed owns the TTL and what
   * counts as a usable seed; anything it refuses reads here as no seed at all. */
  var saved = signupSeed.read();
  if (saved) {
    restoredSeed = true;
    dateEl.value = saved.birthDate;
    dateParts.pull();
    updateDateDisplay();
    // A not-sure seed carries the noon that stood in; that is not a typed time.
    if (saved.birthTime && !saved.noTime) timeEl.value = saved.birthTime;
    if (timeParts) timeParts.pull();
    refreshTimeSaid();
    placeEl.value = saved.birthPlace;
    // Not a step the visitor took on this visit: no progress event.
    if (saved.noTime) confidence.set("unknown", { notify: false });
    if (saved.timezone) placeTz.set(saved.timezone);
    markPlaceConfirmed();
    var savedEmail = signupSeed.readEmail();
    if (savedEmail && dateEl.value && placeEl.value.trim()) emailEl.value = savedEmail;
  }

  // If the restore didn't actually leave usable values in the DOM (the
  // browser refused the date format, place input never got set, etc.)
  // wipe the seed so the next visit starts clean and the banner stays
  // hidden.
  if (!dateEl.value || !placeEl.value.trim()) signupSeed.clear();
  syncResumeBanner();

  // "Did you mean …@gmail.com?" for an address at a domain that cannot receive
  // mail. Taking it rewrites the saved copy too, since the restore just above
  // would otherwise put the typo back on the next visit.
  //
  // The table behind it is 25 KB that nobody needs until they type an address,
  // so the homepage carries it as an inert tag (#email-typos-src) and it is
  // fetched on the field's first focus. The hint itself fires on blur, so a
  // blur that beats the download goes unhinted and the next one is caught.
  // A page that already loaded the module (the knowledge-base articles) binds
  // at once; one with neither simply has no nudge, as before it existed.
  function bindEmailTypoNudge() {
    GHD.bindEmailTypoNudge(
      emailEl,
      document.getElementById("cf-email-typo"),
      msg("msgEmailTypo", "Did you mean {email}?"),
      function (corrected) {
        signupSeed.writeEmail(corrected);
      },
    );
  }
  emailEl.addEventListener(
    "focus",
    function () {
      var lazy = document.getElementById("email-typos-src");
      var src = lazy && lazy.getAttribute("data-src");
      var loaded = GHD.bindEmailTypoNudge ? Promise.resolve() : src ? GHD.injectScript(src) : Promise.reject();
      loaded.then(bindEmailTypoNudge).catch(function () {
        /* no table, no hint */
      });
    },
    { once: true },
  );

  // Keep the banner honest as the user edits.
  dateEl.addEventListener("change", syncResumeBanner);
  placeEl.addEventListener("input", syncResumeBanner);

  // A validation error ("fill in your birth date", "add your birth time")
  // named a specific field; once the user edits that field the message is
  // stale and should go, not wait for another submit click to re-validate.
  function clearErrorOnBirthEdit() {
    if (errorEl && !errorEl.hidden) clearStatus();
  }
  dateEl.addEventListener("change", clearErrorOnBirthEdit);
  timeEl.addEventListener("change", clearErrorOnBirthEdit);
  placeEl.addEventListener("input", clearErrorOnBirthEdit);
  dateParts.els.forEach(function (el) {
    el.addEventListener("change", clearErrorOnBirthEdit);
  });
  emailEl.addEventListener("input", clearErrorOnBirthEdit);
  passwordEl.addEventListener("input", clearErrorOnBirthEdit);

  if (resumeReset) {
    resumeReset.addEventListener("click", function (e) {
      e.preventDefault();
      signupSeed.clear();
      // Full reload \u2014 the place autocomplete and other widgets cache state
      // we can't reliably tear down in-place.
      window.location.reload();
    });
  }

  /* One way to sign up shows at a time: the providers, which most people take,
   * or email, each with a link under its button to the other. */
  var emailToggle = document.getElementById("cf-email-toggle");
  var googleToggle = document.getElementById("cf-google-toggle");
  var emailPane = document.getElementById("cf-email-pane");
  var googleBtn = form.querySelector('[data-auth-provider="google"]');
  var appleBtn = form.querySelector('[data-auth-provider="apple"]');
  var appleOn = !!(window.GHD_APP && window.GHD_APP.APPLE_SIGN_IN) && !!appleBtn;

  /* Sign in with Apple, once its Supabase provider is configured: Apple's
   * button and Google's as equals, the same size and both titled "Continue
   * with …", Apple's first on an iPhone, iPad or Mac. Neither takes the accent
   * fill a ready form gives its one button, since Apple's must stay black or
   * white. Unconfigured, the button stays hidden and nothing else changes. */
  if (appleOn) {
    appleBtn.hidden = false;
    if (googleBtn) {
      googleBtn.classList.remove("is-main");
      var googleLabel = document.getElementById("cf-google-label");
      if (googleLabel) googleLabel.textContent = msg("msgGoogleContinue", "Continue with Google");
      if (GHD.appleFirst && GHD.appleFirst()) googleBtn.parentNode.insertBefore(appleBtn, googleBtn);
      else googleBtn.parentNode.insertBefore(appleBtn, googleBtn.nextSibling);
    }
    if (googleToggle) googleToggle.textContent = msg("msgProvidersInstead", "Sign up with Apple or Google instead");
  } else if (appleBtn) {
    appleBtn.remove();
  }
  var providerBtns = Array.prototype.slice.call(form.querySelectorAll("[data-auth-provider]"));

  function showEmail(on, focus) {
    if (!emailPane) return;
    emailPane.hidden = !on;
    providerBtns.forEach(function (btn) {
      btn.hidden = on;
    });
    if (emailToggle) {
      emailToggle.hidden = on;
      emailToggle.setAttribute("aria-expanded", on ? "true" : "false");
    }
    if (focus) (on ? emailEl : providerBtns[0]).focus();
  }
  function openEmailPane(focus) {
    showEmail(true, focus);
  }
  if (emailToggle) {
    emailToggle.addEventListener("click", function () {
      clearStatus();
      track("email_opened");
      showEmail(true, true);
    });
  }
  if (googleToggle) {
    googleToggle.addEventListener("click", function () {
      clearStatus();
      showEmail(false, true);
    });
  }

  var passwordToggle = document.getElementById("cf-password-toggle");
  if (passwordToggle) {
    passwordToggle.addEventListener("click", function () {
      var show = passwordEl.type === "password";
      passwordEl.type = show ? "text" : "password";
      passwordToggle.setAttribute("aria-pressed", show ? "true" : "false");
    });
  }

  function birthFilled() {
    return !!dateEl.value && !!confidence.time() && !!placeEl.value.trim();
  }
  function trackBirthProgress() {
    track("started");
    if (birthFilled()) track("birth_done");
  }
  function syncReady() {
    form.classList.toggle("chart-form-ready", birthFilled());
  }
  [dateEl, timeEl, placeEl].concat(dateParts.els).forEach(function (el) {
    el.addEventListener("input", trackBirthProgress);
    el.addEventListener("change", trackBirthProgress);
    el.addEventListener("input", syncReady);
    el.addEventListener("change", syncReady);
  });
  // After PersonForm's own click handlers, which answer the question first.
  [timeUnsureEl, timeUndoEl].forEach(function (el) {
    if (!el) return;
    el.addEventListener("click", trackBirthProgress);
    el.addEventListener("click", syncReady);
  });
  syncReady();
  // A restored seed filled these without a keystroke; its steps count once the
  // visitor has the form in front of them.
  if (saved && birthFilled()) whenViewed(trackBirthProgress);
  if (emailEl.value) {
    openEmailPane(false);
    whenViewed(function () {
      track("email_opened");
    });
  }

  function collectBirthSeed() {
    var birthTime = confidence.time();
    var birthPlace = placeEl.value.trim();
    var dateFields = dateParts.els.length ? dateParts.els : [dateEl];
    if (!dateEl.value || !birthPlace) {
      showError(
        msg("msgMissingBirthFields", "Please fill in your birth date and birth place first."),
        !dateEl.value
          ? {
              fields: dateFields,
              focus: function () {
                dateParts.focus();
              },
            }
          : { fields: [placeEl] },
      );
      track("blocked", "birth_fields");
      return null;
    }
    /* A date outside the range no chart can be cast for. The `max`/`min` above
     * stop the picker offering one, but a year typed straight into the box is
     * not stopped by anything the browser does here — and what this form writes
     * is the signup seed that onboarding replays without ever showing a form,
     * so a date refused later has nowhere to be refused to. */
    if (PersonForm.birthDateOutOfRange(dateEl.value)) {
      showError(
        PersonForm.birthDateRangeMessage(
          msg(
            "msgBirthDateRange",
            "Please check the birth date — we can only calculate a chart for a birth between {min} and {max}.",
          ),
        ),
        {
          fields: dateFields,
          focus: function () {
            dateParts.focus();
          },
        },
      );
      track("blocked", "birth_range");
      return null;
    }
    // A birth time is never blank: either it was typed, or "(not sure?)"
    // declared it unknown, which is what puts noon there. Silently defaulting an
    // empty field to noon used to mark people as time-unknown who had simply not
    // reached the field yet.
    if (!birthTime) {
      showError(timeEl.dataset.requiredMsg || "Please add your birth time, or tap the not-sure link next to it.", {
        fields: timeParts ? timeParts.els : [timeEl],
        focus: timeParts
          ? function () {
              timeParts.focus();
            }
          : undefined,
      });
      track("blocked", "birth_time");
      return null;
    }
    return PersonForm.seedFrom({
      date: dateEl.value,
      time: birthTime,
      place: birthPlace,
      timezone: placeTz.timezone,
      birthTimeConfidence: confidence.value,
    });
  }

  /* Supabase's own message is English whatever the page's language, so the two
   * failures worth recognising are answered with a localized one. The reading
   * itself is GHD.friendlyAuthError (/js/auth-shared.js), shared with the app's
   * signup form; the sentences are this page's, because its copy is substituted
   * into data-msg-* attributes at build time rather than looked up at runtime. */
  function friendlyAuthError(err) {
    var sentences = {
      generic: msg("msgGeneric", "Something went wrong. Please try again."),
      accountExists: msg("msgAccountExists", "You already have an account with this email."),
      passwordTooShort: msg("msgPasswordTooShort", "Please choose a longer password (8+ characters)."),
    };
    // Without auth-shared.js the two recognised failures read as the generic
    // one. The reading is the only thing lost — never the localized sentence,
    // which comes off this page's own data-msg-* attributes.
    var read = GHD.moduleOr("GHD.friendlyAuthError", GHD.friendlyAuthError);
    var info = read ? read(err, sentences) : { message: sentences.generic };
    info.passwordTooShort = info.message === sentences.passwordTooShort;
    return info;
  }

  /* Email + password signup */
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    clearStatus();
    var seed = collectBirthSeed();
    if (!seed) return;
    var email = (emailEl.value || "").trim().toLowerCase();
    var password = passwordEl.value || "";
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError(msg("msgInvalidEmail", "Please enter a valid email address."), { fields: [emailEl] });
      track("blocked", "invalid_email");
      return;
    }
    if (password.length < 8) {
      showError(msg("msgPasswordMin", "Please choose a password with at least 8 characters."), {
        fields: [passwordEl],
      });
      track("blocked", "password");
      return;
    }
    track("submitted", "email");
    signupSeed.write(seed, email);
    rememberSignupPage();
    setBusy(true, msg("msgBusyCreating", "Creating account\u2026"));
    getSupabase()
      .then(
        function (sb) {
          return sb.auth.signUp({
            email: email,
            password: password,
            options: { emailRedirectTo: DASHBOARD_RETURN },
          });
        },
        function () {
          showError(SDK_ERROR);
          setBusy(false);
        },
      )
      .then(function (res) {
        if (!res) return; // SDK failed to load; already reported
        if (res.error) {
          track("blocked", "auth_error");
          var info = friendlyAuthError(res.error);
          showError(info.message, {
            signInLink: !!info.existing,
            fields: [info.existing ? emailEl : info.passwordTooShort ? passwordEl : null],
          });
          setBusy(false);
          return;
        }
        if (res.data && res.data.session) {
          // Through /go/: the session and the birth-details seed are both on this
          // origin right now, and neither survives a direct jump to the app.
          //
          // The route is a preference, not a contract. The app finishes this
          // signup off the seed itself (dashboard/js/app.js _finishPendingSignup)
          // wherever it lands, so changing "/chat" here cannot silently strand
          // people without a chart the way changing "#/chat" to "/chat" once did.
          // Unless there is no seed to finish off — see `afterSignup`.
          window.location.href = goUrl(afterSignup);
          return;
        }
        showSuccess(
          msg("msgConfirmTitle", "Check your email"),
          msg(
            "msgConfirmBody",
            "We sent a confirmation link to {email}. Open it on this device to finish creating your account.",
          ).replace("{email}", email),
        );
        setBusy(false);
      })
      .catch(function (err) {
        showError(friendlyAuthError(err).message);
        setBusy(false);
      });
  });

  /* OAuth — bind only the provider buttons, not the
   * email submit button (which also has .chart-form-auth-social-btn). */
  document.querySelectorAll("[data-auth-provider]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      clearStatus();
      var seed = collectBirthSeed();
      if (!seed) return;
      var provider = btn.dataset.authProvider;
      track("submitted", provider);
      signupSeed.write(seed, "");
      rememberSignupPage();
      setBusy(true, msg("msgBusyRedirecting", "Redirecting\u2026"));
      // OAuth is started on the *app* origin, not here. Supabase hands the session
      // back to whichever origin it redirects to, and it has to be the app's — but
      // the birth-details seed was just written to this origin's localStorage, and
      // leaving for Google now would strand it. So hop through /go/ first, which
      // carries the seed across, and let the app's signup route start the provider
      // flow (dashboard/js/auth.js reads ?oauth=).
      window.location.href = goUrl("/signup?oauth=" + encodeURIComponent(provider));
    });
  });
});

